import { defineComponent as Se, openBlock as $, createElementBlock as j, normalizeClass as ye, createElementVNode as ne, toDisplayString as Ie, createCommentVNode as se, renderSlot as ve, createBlock as xe, unref as Z, createVNode as Re, mergeProps as Ce, shallowRef as _n, computed as W, toValue as at, watch as He, reactive as li, h as Xs, getCurrentInstance as oi, inject as $n, resolveComponent as Pa, createPropsRestProxy as ba, resolveDynamicComponent as Nt, withCtx as _e, ref as pe, onMounted as St, Transition as kn, normalizeProps as Ot, guardReactiveProps as Pt, createTextVNode as kt, toRef as Hi, normalizeStyle as Et, Teleport as pa, useSlots as cn, onUpdated as fo, onUnmounted as In, withModifiers as ca, Fragment as rt, renderList as yt, useModel as Ya, mergeModels as Cn, effectScope as Ys, useTemplateRef as nt, nextTick as Ga, createSlots as Ka, isRef as Ui, onBeforeUnmount as si, provide as Ja, withDirectives as Qt, withKeys as ci, vModelCheckbox as ho, vModelDynamic as qi, readonly as vo, vShow as ui, createStaticVNode as Gs, TransitionGroup as Ks, getCurrentScope as Js, onScopeDispose as mo, shallowReadonly as Rn, version as Qs, vModelRadio as ec, toRefs as Ea, onServerPrefetch as tc, onBeforeMount as nc, vModelText as ac, shallowReactive as rc, watchEffect as ic } from "vue";
import { toArray as lc, unrefElement as go, tryOnScopeDispose as bo, refDebounced as oc, useTransition as sc, TransitionPresets as cc, useScrollLock as po, onClickOutside as Qa, onKeyStroke as yo, useEventListener as qt, useMediaQuery as uc, usePreferredReducedMotion as wo, useVibrate as xo, useTimeoutFn as na, useIntervalFn as ko, useDebounceFn as dc, useElementSize as yn, useResizeObserver as fc, usePointerSwipe as hc } from "@vueuse/core";
import { isNotNestedPath as vc, cleanupNonNestedPath as mc, useForm as gc, useField as bc } from "vee-validate";
const Wr = /* @__PURE__ */ Se({
  __name: "LcCountBubble",
  props: {
    count: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => e.count ? ($(), j("div", {
      key: 0,
      class: ye(["lc-count-bubble", e.variant && `lc-count-bubble--${e.variant}`])
    }, [
      ne("span", null, Ie(e.count), 1)
    ], 2)) : se("", !0);
  }
}), C1 = ["info", "success", "warning"], pc = "medium", E1 = ["large", "medium", "small"], Je = /* @__PURE__ */ Se({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: () => pc }
  },
  setup(e) {
    return (t, n) => ($(), j("i", {
      "aria-hidden": "true",
      class: ye(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), T1 = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "clear",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "connection-slow",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "passkey",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "wifi-off",
  "winning",
  "winning-correction",
  "zoom"
], yc = { class: "lc-badge" }, A1 = /* @__PURE__ */ Se({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", yc, [
      ve(t.$slots, "icon", {}, () => [
        e.icon ? ($(), xe(Z(Je), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : se("", !0)
      ]),
      Re(Z(Wr), Ce({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      ve(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const wc = (e) => e != null;
var So = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Ba = /* @__PURE__ */ So.join(","), _o = typeof Element > "u", En = _o ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, za = !_o && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Va = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : Va(t.parentNode));
  return a;
}, xc = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Co = function(t, n, r) {
  if (Va(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Ba));
  return n && En.call(t, Ba) && o.unshift(t), o = o.filter(r), o;
}, Ha = function(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!Va(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, h = Ha(l, !0, r);
        r.flatten ? o.push.apply(o, h) : o.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = En.call(a, Ba);
        v && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var u = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !Va(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (u && f) {
          var m = Ha(u === !0 ? a.children : u.children, !0, r);
          r.flatten ? o.push.apply(o, m) : o.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, Eo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, wn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || xc(t)) && !Eo(t) ? 0 : t.tabIndex;
}, kc = function(t, n) {
  var r = wn(t);
  return r < 0 && n && !Eo(t) ? 0 : r;
}, Sc = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, To = function(t) {
  return t.tagName === "INPUT";
}, _c = function(t) {
  return To(t) && t.type === "hidden";
}, Cc = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Ec = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, Tc = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || za(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = Ec(o, t.form);
  return !i || i === t;
}, Ac = function(t) {
  return To(t) && t.type === "radio";
}, Lc = function(t) {
  return Ac(t) && !Tc(t);
}, $c = function(t) {
  var n, r = t && za(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var h, v, u;
      r = za(o), o = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = o) !== null && v !== void 0 && (u = v.ownerDocument) !== null && u !== void 0 && u.contains(o));
    }
  }
  return i;
}, ji = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Ic = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), s = a.visibility;
  if (s === "hidden" || s === "collapse")
    return !0;
  var l = En.call(t, "details>summary:first-of-type"), h = l ? t.parentElement : t;
  if (En.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var v = t; t; ) {
        var u = t.parentElement, f = za(t);
        if (u && !u.shadowRoot && o(u) === !0)
          return ji(t);
        t.assignedSlot ? t = t.assignedSlot : !u && f !== t.ownerDocument ? t = f.host : t = u;
      }
      t = v;
    }
    if ($c(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return ji(t);
  return !1;
}, Dc = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return En.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ua = function(t, n) {
  return !(n.disabled || _c(n) || Ic(n, t) || // For a details element with a summary, the summary element gets the focus
  Cc(n) || Dc(n));
}, Xr = function(t, n) {
  return !(Lc(n) || wn(n) < 0 || !Ua(t, n));
}, Oc = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ao = function(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = kc(s, a), h = a ? Ao(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, h) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: h
    });
  }), r.sort(Sc).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, Mc = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Ha([t], n.includeContainer, {
    filter: Xr.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Oc
  }) : r = Co(t, n.includeContainer, Xr.bind(null, n)), Ao(r);
}, Rc = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Ha([t], n.includeContainer, {
    filter: Ua.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Co(t, n.includeContainer, Ua.bind(null, n)), r;
}, Nn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return En.call(t, Ba) === !1 ? !1 : Xr(n, t);
}, Nc = /* @__PURE__ */ So.concat("iframe:not([inert]):not([inert] *)").join(","), kr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return En.call(t, Nc) === !1 ? !1 : Ua(n, t);
};
function Yr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Fc(e) {
  if (Array.isArray(e)) return Yr(e);
}
function Zi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = Lo(e)) || t) {
      n && (e = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function Pc(e, t, n) {
  return (t = Uc(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Bc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wi(Object(n), !0).forEach(function(r) {
      Pc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Vc(e) {
  return Fc(e) || Bc(e) || Lo(e) || zc();
}
function Hc(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Uc(e) {
  var t = Hc(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Lo(e, t) {
  if (e) {
    if (typeof e == "string") return Yr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Yr(e, t) : void 0;
  }
}
var Kt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Kt.getActiveTrap(t);
    n !== r && Kt.pauseTrap(t);
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Kt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, qc = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, jc = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, ia = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Zc = function(t) {
  return ia(t) && !t.shiftKey;
}, Wc = function(t) {
  return ia(t) && t.shiftKey;
}, Yi = function(t) {
  return setTimeout(t, 0);
}, Kn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ta = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Xc = [], Yc = function(t, n) {
  var r = n?.document || document, o = n?.trapStack || Xc, i = Xi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Zc,
    isKeyBackward: Wc
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(_, T, R) {
    return _ && _[T] !== void 0 ? _[T] : i[R || T];
  }, h = function(_, T) {
    var R = typeof T?.composedPath == "function" ? T.composedPath() : void 0;
    return a.containerGroups.findIndex(function(H) {
      var q = H.container, G = H.tabbableNodes;
      return q.contains(_) || R?.includes(q) || G.find(function(ie) {
        return ie === _;
      });
    });
  }, v = function(_) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, R = T.hasFallback, H = R === void 0 ? !1 : R, q = T.params, G = q === void 0 ? [] : q, ie = i[_];
    if (typeof ie == "function" && (ie = ie.apply(void 0, Vc(G))), ie === !0 && (ie = void 0), !ie) {
      if (ie === void 0 || ie === !1)
        return ie;
      throw new Error("`".concat(_, "` was specified but was not a node, or did not return a node"));
    }
    var X = ie;
    if (typeof ie == "string") {
      try {
        X = r.querySelector(ie);
      } catch (oe) {
        throw new Error("`".concat(_, '` appears to be an invalid selector; error="').concat(oe.message, '"'), {
          cause: oe
        });
      }
      if (!X && !H)
        throw new Error("`".concat(_, "` as selector refers to no known node"));
    }
    return X;
  }, u = function(_) {
    var T = _.activeElement;
    return T ? T.shadowRoot && T.shadowRoot.activeElement !== null ? u(T.shadowRoot) : T : null;
  }, f = function() {
    var _ = v("initialFocus", {
      hasFallback: !0
    });
    if (_ === !1)
      return !1;
    if (_ === void 0 || _ && !kr(_, i.tabbableOptions)) {
      var T = u(r);
      if (h(T) >= 0)
        _ = T;
      else {
        var R = a.tabbableGroups[0], H = R && R.firstTabbableNode;
        _ = H || v("fallbackFocus");
      }
    } else _ === null && (_ = v("fallbackFocus"));
    if (!_)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return _;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(_) {
      var T = Mc(_, i.tabbableOptions), R = Rc(_, i.tabbableOptions), H = T.length > 0 ? T[0] : void 0, q = T.length > 0 ? T[T.length - 1] : void 0, G = R.find(function(oe) {
        return Nn(oe);
      }), ie = R.slice().reverse().find(function(oe) {
        return Nn(oe);
      }), X = !!T.find(function(oe) {
        return wn(oe) > 0;
      });
      return {
        container: _,
        tabbableNodes: T,
        focusableNodes: R,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: X,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: H,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: G,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ie,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ue) {
          var he = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, be = T.indexOf(ue);
          return be < 0 ? he ? R.slice(R.indexOf(ue) + 1).find(function(fe) {
            return Nn(fe);
          }) : R.slice(0, R.indexOf(ue)).reverse().find(function(fe) {
            return Nn(fe);
          }) : T[be + (he ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(_) {
      return _.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(_) {
      return _.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(_) {
    if (_ !== !1) {
      if (_ === u(r)) {
        a.mostRecentlyFocusedNode = _;
        return;
      }
      if (!_ || !_.focus) {
        c(f());
        return;
      }
      _.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = _, qc(_) && _.select();
    }
  }, p = function(_) {
    var T = v("setReturnFocus", {
      params: [_]
    });
    return T || (T === !1 ? !1 : _);
  }, x = function(_) {
    var T = _.target, R = _.event, H = _.isBackward, q = H === void 0 ? !1 : H;
    T = T || Ta(R), m();
    var G = null;
    if (a.tabbableGroups.length > 0) {
      var ie = h(T, R), X = ie >= 0 ? a.containerGroups[ie] : void 0;
      if (ie < 0)
        q ? G = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : G = a.tabbableGroups[0].firstTabbableNode;
      else if (q) {
        var oe = a.tabbableGroups.findIndex(function(Ae) {
          var Oe = Ae.firstTabbableNode;
          return T === Oe;
        });
        if (oe < 0 && (X.container === T || kr(T, i.tabbableOptions) && !Nn(T, i.tabbableOptions) && !X.nextTabbableNode(T, !1)) && (oe = ie), oe >= 0) {
          var ue = oe === 0 ? a.tabbableGroups.length - 1 : oe - 1, he = a.tabbableGroups[ue];
          G = wn(T) >= 0 ? he.lastTabbableNode : he.lastDomTabbableNode;
        } else ia(R) || (G = X.nextTabbableNode(T, !1));
      } else {
        var be = a.tabbableGroups.findIndex(function(Ae) {
          var Oe = Ae.lastTabbableNode;
          return T === Oe;
        });
        if (be < 0 && (X.container === T || kr(T, i.tabbableOptions) && !Nn(T, i.tabbableOptions) && !X.nextTabbableNode(T)) && (be = ie), be >= 0) {
          var fe = be === a.tabbableGroups.length - 1 ? 0 : be + 1, we = a.tabbableGroups[fe];
          G = wn(T) >= 0 ? we.firstTabbableNode : we.firstDomTabbableNode;
        } else ia(R) || (G = X.nextTabbableNode(T));
      }
    } else
      G = v("fallbackFocus");
    return G;
  }, g = function(_) {
    var T = Ta(_);
    if (!(h(T, _) >= 0)) {
      if (Kn(i.clickOutsideDeactivates, _)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Kn(i.allowOutsideClick, _) || _.preventDefault();
    }
  }, b = function(_) {
    var T = Ta(_), R = h(T, _) >= 0;
    if (R || T instanceof Document)
      R && (a.mostRecentlyFocusedNode = T);
    else {
      _.stopImmediatePropagation();
      var H, q = !0;
      if (a.mostRecentlyFocusedNode)
        if (wn(a.mostRecentlyFocusedNode) > 0) {
          var G = h(a.mostRecentlyFocusedNode), ie = a.containerGroups[G].tabbableNodes;
          if (ie.length > 0) {
            var X = ie.findIndex(function(oe) {
              return oe === a.mostRecentlyFocusedNode;
            });
            X >= 0 && (i.isKeyForward(a.recentNavEvent) ? X + 1 < ie.length && (H = ie[X + 1], q = !1) : X - 1 >= 0 && (H = ie[X - 1], q = !1));
          }
        } else
          a.containerGroups.some(function(oe) {
            return oe.tabbableNodes.some(function(ue) {
              return wn(ue) > 0;
            });
          }) || (q = !1);
      else
        q = !1;
      q && (H = x({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), c(H || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, C = function(_) {
    var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = _;
    var R = x({
      event: _,
      isBackward: T
    });
    R && (ia(_) && _.preventDefault(), c(R));
  }, A = function(_) {
    (i.isKeyForward(_) || i.isKeyBackward(_)) && C(_, i.isKeyBackward(_));
  }, I = function(_) {
    jc(_) && Kn(i.escapeDeactivates, _) !== !1 && (_.preventDefault(), s.deactivate());
  }, L = function(_) {
    var T = Ta(_);
    h(T, _) >= 0 || Kn(i.clickOutsideDeactivates, _) || Kn(i.allowOutsideClick, _) || (_.preventDefault(), _.stopImmediatePropagation());
  }, E = function() {
    if (a.active) {
      Kt.activateTrap(o, s);
      var _;
      return i.delayInitialFocus ? _ = new Promise(function(T) {
        a.delayInitialFocusTimer = Yi(function() {
          c(f()), T();
        });
      }) : c(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", A, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), _;
    }
  }, F = function(_) {
    a.active && !a.paused && s._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var T = /* @__PURE__ */ new Set(), R = /* @__PURE__ */ new Set(), H = Zi(_), q;
    try {
      for (H.s(); !(q = H.n()).done; ) {
        var G = q.value;
        T.add(G);
        for (var ie = typeof ShadowRoot < "u" && G.getRootNode() instanceof ShadowRoot, X = G; X; ) {
          T.add(X);
          var oe = X.parentElement, ue = [];
          oe ? ue = oe.children : !oe && ie && (ue = X.getRootNode().children, oe = X.getRootNode().host, ie = typeof ShadowRoot < "u" && oe.getRootNode() instanceof ShadowRoot);
          var he = Zi(ue), be;
          try {
            for (he.s(); !(be = he.n()).done; ) {
              var fe = be.value;
              R.add(fe);
            }
          } catch (we) {
            he.e(we);
          } finally {
            he.f();
          }
          X = oe;
        }
      }
    } catch (we) {
      H.e(we);
    } finally {
      H.f();
    }
    T.forEach(function(we) {
      R.delete(we);
    }), a.adjacentElements = R;
  }, U = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", L, !0), r.removeEventListener("keydown", A, !0), r.removeEventListener("keydown", I), s;
  }, K = function(_) {
    var T = a.mostRecentlyFocusedNode;
    if (T) {
      var R = _.some(function(q) {
        var G = Array.from(q.removedNodes);
        return G.some(function(ie) {
          return ie === T || typeof ie.contains == "function" && ie.contains(T);
        });
      });
      if (R && a.containers.some(function(q) {
        return q?.isConnected;
      })) {
        m();
        var H = f();
        c(H);
      }
    }
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(K) : void 0, V = function() {
    O && (O.disconnect(), a.active && !a.paused && a.containers.map(function(_) {
      O.observe(_, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(_) {
      if (a.active)
        return this;
      var T = l(_, "onActivate"), R = l(_, "onPostActivate"), H = l(_, "checkCanFocusTrap"), q = Kt.getActiveTrap(o), G = !1;
      if (q && !q.paused) {
        var ie;
        (ie = q._setSubtreeIsolation) === null || ie === void 0 || ie.call(q, !1), G = !0;
      }
      try {
        H || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = u(r), T?.({
          trap: s
        });
        var X = function() {
          H && m();
          var he = function() {
            s._setSubtreeIsolation(!0), V(), R?.({
              trap: s
            });
          }, be = E();
          be ? be.then(he) : he();
        };
        if (H)
          return H(a.containers.concat()).then(X, X), this;
        X();
      } catch (ue) {
        if (q === Kt.getActiveTrap(o) && G) {
          var oe;
          (oe = q._setSubtreeIsolation) === null || oe === void 0 || oe.call(q, !0);
        }
        throw ue;
      }
      return this;
    },
    deactivate: function(_) {
      if (!a.active)
        return this;
      var T = Xi({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, _);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || s._setSubtreeIsolation(!1), a.alreadySilent.clear(), U(), a.active = !1, a.paused = !1, V(), Kt.deactivateTrap(o, s);
      var R = l(T, "onDeactivate"), H = l(T, "onPostDeactivate"), q = l(T, "checkCanReturnFocus"), G = l(T, "delayReturnFocus"), ie = l(T, "returnFocus", "returnFocusOnDeactivate");
      R?.({
        trap: s
      });
      var X = function() {
        ie && c(p(a.nodeFocusedBeforeActivation)), H?.({
          trap: s
        });
      }, oe = function() {
        G && ie ? Yi(X) : X();
      };
      return ie && q ? (q(p(a.nodeFocusedBeforeActivation)).then(oe, oe), this) : (oe(), this);
    },
    pause: function(_) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, _)) : this;
    },
    unpause: function(_) {
      return a.active ? (a.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, _)) : this;
    },
    updateContainerElements: function(_) {
      var T = [].concat(_).filter(Boolean);
      return a.containers = T.map(function(R) {
        return typeof R == "string" ? r.querySelector(R) : R;
      }), i.isolateSubtrees && F(a.containers), a.active && (m(), a.paused || s._setSubtreeIsolation(!0)), V(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(_, T) {
        if (a.paused === _)
          return this;
        if (a.paused = _, _) {
          var R = l(T, "onPause"), H = l(T, "onPostPause");
          R?.({
            trap: s
          }), U(), s._setSubtreeIsolation(!1), V(), H?.({
            trap: s
          });
        } else {
          var q = l(T, "onUnpause"), G = l(T, "onPostUnpause");
          q?.({
            trap: s
          });
          var ie = function() {
            m();
            var oe = function() {
              s._setSubtreeIsolation(!0), V(), G?.({
                trap: s
              });
            }, ue = E();
            ue ? ue.then(oe) : oe();
          };
          ie();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(_) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(T) {
          var R;
          _ ? i.isolateSubtrees === "aria-hidden" ? ((T.ariaHidden === "true" || ((R = T.getAttribute("aria-hidden")) === null || R === void 0 ? void 0 : R.toLowerCase()) === "true") && a.alreadySilent.add(T), T.setAttribute("aria-hidden", "true")) : ((T.inert || T.hasAttribute("inert")) && a.alreadySilent.add(T), T.setAttribute("inert", !0)) : a.alreadySilent.has(T) || (i.isolateSubtrees === "aria-hidden" ? T.removeAttribute("aria-hidden") : T.removeAttribute("inert"));
        });
      }
    }
  }), s.updateContainerElements(t), s;
};
function Gc(e, t = {}) {
  let n;
  const { immediate: r, ...o } = t, i = _n(!1), a = _n(!1), s = (f) => n && n.activate(f), l = (f) => n && n.deactivate(f), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  }, u = W(() => {
    const f = at(e);
    return lc(f).map((m) => {
      const c = at(m);
      return typeof c == "string" ? c : go(c);
    }).filter(wc);
  });
  return He(u, (f) => {
    if (f.length)
      if (!n)
        n = Yc(f, {
          ...o,
          onActivate(m) {
            i.value = !0, t.onActivate && t.onActivate(m);
          },
          onDeactivate(m) {
            i.value = !1, t.onDeactivate && t.onDeactivate(m);
          }
        }), r && s();
      else {
        const m = n?.active;
        n?.updateContainerElements(f), !m && r && s();
      }
  }, { flush: "post" }), bo(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: h,
    unpause: v
  };
}
const $o = /* @__PURE__ */ Se((e, { slots: t }) => {
  const n = _n(), r = li(Gc(n, e.options));
  return () => {
    if (t.default) return Xs(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Kc = 864e5, Jc = 6e4, Qc = 36e5, Gi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Zn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Gi in e ? e[Gi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Rt(e, t) {
  return Zn(e, e);
}
function eu(e, t, n) {
  const r = Rt(e);
  return isNaN(t) ? Zn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function tu(e, t, n) {
  const r = Rt(e);
  if (isNaN(t)) return Zn(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = Zn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
function Jn(e, t, n) {
  const {
    years: r = 0,
    months: o = 0,
    weeks: i = 0,
    days: a = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: h = 0
  } = t, v = Rt(e), u = o || r ? tu(v, o + r * 12) : v, f = a || i ? eu(u, a + i * 7) : u, m = l + s * 60, p = (h + m * 60) * 1e3;
  return Zn(e, +f + p);
}
function Ki(e) {
  const t = Rt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function un(e, ...t) {
  const n = Zn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ji(e, t) {
  const n = Rt(e);
  return n.setHours(0, 0, 0, 0), n;
}
function nu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = Ji(r), a = Ji(o), s = +i - Ki(i), l = +a - Ki(a);
  return Math.round((s - l) / Kc);
}
function la(e, t) {
  const n = +Rt(e) - +Rt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function au(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function qa(e) {
  return !(!au(e) && typeof e != "number" || isNaN(+Rt(e)));
}
function ru(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function iu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - o.getFullYear();
}
function lu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = Qi(r, o), a = Math.abs(
    nu(r, o)
  );
  r.setDate(r.getDate() - i * a);
  const s = +(Qi(r, o) === -i), l = i * (a - s);
  return l === 0 ? 0 : l;
}
function Qi(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function di(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function ou(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = (+r - +o) / Qc;
  return di(n?.roundingMethod)(i);
}
function Io(e, t) {
  return +Rt(e) - +Rt(t);
}
function su(e, t, n) {
  const r = Io(e, t) / Jc;
  return di(n?.roundingMethod)(r);
}
function cu(e, t) {
  const n = Rt(e);
  return n.setHours(23, 59, 59, 999), n;
}
function uu(e, t) {
  const n = Rt(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function du(e, t) {
  const n = Rt(e);
  return +cu(n) == +uu(n);
}
function fu(e, t, n) {
  const [r, o, i] = un(
    n?.in,
    e,
    e,
    t
  ), a = la(o, i), s = Math.abs(
    ru(o, i)
  );
  if (s < 1) return 0;
  o.getMonth() === 1 && o.getDate() > 27 && o.setDate(30), o.setMonth(o.getMonth() - a * s);
  let l = la(o, i) === -a;
  du(r) && s === 1 && la(r, i) === 1 && (l = !1);
  const h = a * (s - +l);
  return h === 0 ? 0 : h;
}
function hu(e, t, n) {
  const r = Io(e, t) / 1e3;
  return di(n?.roundingMethod)(r);
}
function vu(e, t, n) {
  const [r, o] = un(
    n?.in,
    e,
    t
  ), i = la(r, o), a = Math.abs(iu(r, o));
  r.setFullYear(1584), o.setFullYear(1584);
  const s = la(r, o) === -i, l = i * (a - +s);
  return l === 0 ? 0 : l;
}
function mu(e, t) {
  const [n, r] = un(e, t.start, t.end);
  return { start: n, end: r };
}
function gu(e, t) {
  const { start: n, end: r } = mu(t?.in, e), o = {}, i = vu(r, n);
  i && (o.years = i);
  const a = Jn(n, { years: o.years }), s = fu(r, a);
  s && (o.months = s);
  const l = Jn(a, { months: o.months }), h = lu(r, l);
  h && (o.days = h);
  const v = Jn(l, { days: o.days }), u = ou(r, v);
  u && (o.hours = u);
  const f = Jn(v, { hours: o.hours }), m = su(r, f);
  m && (o.minutes = m);
  const c = Jn(f, { minutes: o.minutes }), p = hu(r, c);
  return p && (o.seconds = p), o;
}
function bu(e) {
  return +Rt(e) < Date.now();
}
const pu = (e, t) => t.length === 1 ? (n) => e(n, t[0]) : (n) => e(n, ...t), er = (e, t) => t.length >= e.length ? e(...t) : pu(e, t);
function el(...e) {
  return er(yu, e);
}
const yu = (e, t) => e.length >= t;
function Lt(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function tl(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function wu(...e) {
  return er(Do, e);
}
function Do(e, t) {
  const n = {
    ...e,
    ...t
  };
  for (const r in t)
    Object.hasOwn(e, r) && tl(e[r]) && tl(t[r]) && (n[r] = Do(e[r], t[r]));
  return n;
}
function en(...e) {
  return er(xu, e);
}
function xu(e, t) {
  if (!el(t, 1)) return { ...e };
  if (!el(t, 2)) {
    const { [t[0]]: r, ...o } = e;
    return o;
  }
  const n = { ...e };
  for (const r of t) delete n[r];
  return n;
}
function ku(...e) {
  return er(Su, e);
}
function Su(e, t) {
  const n = {};
  for (const r of t) r in e && (n[r] = e[r]);
  return n;
}
const Oo = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcCarousel: {
    autoPlayDelayInSeconds: 5,
    nextSlideAriaLabel: "Next slide",
    pauseAriaLabel: "Pause slideshow",
    playAriaLabel: "Play slideshow",
    prevSlideAriaLabel: "Previous slide",
    slideAriaLabel: "Slide {slide}"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    removeAriaLabel: "Remove play",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, Ze = li(Oo), L1 = (e) => {
  Object.assign(Ze, wu(Oo, e));
}, _u = /* @__PURE__ */ Symbol(), ya = () => {
  const e = oi();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? $n(_u) : null;
}, Cu = () => ya() ? Pa("NuxtTime") : "time", Mo = /* @__PURE__ */ Se({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => Ze.general.locale }
  },
  setup(e) {
    const t = ba(e, ["datetime", "locale"]), n = Cu(), r = W(() => o.value ? i.value?.toISOString() : void 0), o = W(() => i.value ? qa(i.value) : !1), i = W(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, s) => o.value ? ($(), xe(Nt(Z(n)), Ce({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: _e(() => [
        ve(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : se("", !0);
  }
}), Yn = (e) => {
  const t = oi(), n = ya();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Pa("NuxtLink") : Pa("RouterLink");
}, fi = /* @__PURE__ */ Se({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Yn(e.to);
    return (n, r) => ($(), xe(Nt(Z(t)), Ce(n.$attrs, n.$props), {
      default: _e(() => [
        ve(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ua = /* @__PURE__ */ Se({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = pe(!1), n = oc(t, 1);
    return St(() => {
      t.value = !0;
    }), (r, o) => ($(), xe(kn, Ot(Pt({ name: e.name, mode: e.mode })), {
      default: _e(() => [
        Z(n) ? ve(r.$slots, "default", {}, void 0, void 0, 0) : se("", !0)
      ]),
      _: 3
    }, 16));
  }
}), Eu = {
  key: 0,
  class: "lc-feedback-message__content"
}, Dn = /* @__PURE__ */ Se({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = W(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => ($(), j("div", {
      class: ye(t.value),
      role: "alert"
    }, [
      Re(Z(ua), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: _e(() => [
          e.content ? ($(), j("p", Eu, [
            e.variant === "error" ? ($(), xe(Z(Je), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : se("", !0),
            kt(" " + Ie(e.content), 1)
          ])) : se("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), Ro = "--vc-auto-duration", Tu = `height var(${Ro}) cubic-bezier(0.33, 1, 0.68, 1)`, Aa = { padding: 0 }, Au = 300, Lu = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function nl(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function al(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: Tu } : { transition: t };
}
function rl(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function $u(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const Iu = /* @__PURE__ */ Se({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Hi(n, "when"), i = Hi(n, "baseHeight"), a = W(() => ({ overflow: "hidden", height: `${i.value}px` })), s = W(() => ({
      ...Aa,
      ...i.value === 0 ? { display: "none" } : a.value
    })), l = pe(null), h = pe(o.value ? "expanded" : "collapsed"), v = (L) => h.value = L;
    function u() {
      return o.value ? Aa : i.value === 0 ? Lu : s.value;
    }
    const f = _n(u()), m = (L) => f.value = L, c = (L) => m({ ...f.value, ...L }), p = pe(Au), x = (L) => p.value = L, g = W(() => ({ [Ro]: `${p.value}ms` }));
    let b = NaN;
    function C() {
      m(Aa), v("expanded"), r("expanded");
    }
    function A() {
      m(s.value), v("collapsed"), r("collapsed");
    }
    St(() => {
      if (!l.value) return;
      const L = $u(l.value.scrollHeight - i.value);
      L > 0 && x(L), !o.value && i.value === 0 && m(s.value);
    }), He(o, (L) => {
      if (l.value)
        if (b = NaN, L) {
          if (rl(l)) return C();
          v("expanding"), r("expand"), m({
            ...Aa,
            ...a.value,
            ...g.value
          }), requestAnimationFrame(() => {
            if (l.value) {
              if (l.value.scrollHeight === 0) return C();
              b = l.value.scrollHeight, c({
                ...al(l),
                height: `${b}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (rl(l) || (v("collapsing"), r("collapse"), c({
            ...g.value,
            height: `${l.value.scrollHeight}px`
          }), l.value.scrollHeight === 0)) return A();
          requestAnimationFrame(() => {
            l.value && c({
              ...a.value,
              ...al(l),
              willChange: "height"
            });
          });
        }
    }), He(i, (L) => {
      o.value || (L > 0 ? c({ display: void 0, height: `${L}px` }) : c({ display: "none" }));
    });
    function I(L) {
      l.value && L.target && L.target === l.value && L.propertyName === "height" && (o.value ? Math.abs(l.value.scrollHeight - nl(l)) < 1 ? C() : b < l.value.scrollHeight && c({
        height: `${l.value.scrollHeight}px`
      }) : Math.abs(i.value - nl(l)) < 1 && A());
    }
    return (L, E) => ($(), xe(Nt(n.as), {
      ref_key: "collapseRef",
      ref: l,
      style: Et(f.value),
      onTransitionend: I,
      "data-collapse": h.value
    }, {
      default: _e(() => [
        ve(L.$slots, "default", Ot(Pt({ state: h.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), No = /* @__PURE__ */ Se({
  __name: "InternalCollapse",
  props: {
    animated: { type: Boolean },
    as: { default: "div" },
    when: { type: Boolean }
  },
  emits: ["collapse", "collapsed", "expand", "expanded"],
  setup(e) {
    return (t, n) => e.animated ? ($(), xe(Z(Iu), Ce({
      key: 0,
      class: "lc-collapse"
    }, { as: e.as, when: e.when }, {
      onCollapse: n[0] || (n[0] = (r) => t.$emit("collapse")),
      onCollapsed: n[1] || (n[1] = (r) => t.$emit("collapsed")),
      onExpand: n[2] || (n[2] = (r) => t.$emit("expand")),
      onExpanded: n[3] || (n[3] = (r) => t.$emit("expanded"))
    }), {
      default: _e(() => [
        ve(t.$slots, "default")
      ]),
      _: 3
    }, 16)) : ($(), xe(Nt(e.as), { key: 1 }, {
      default: _e(() => [
        ve(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Du = /* @__PURE__ */ Se({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? ($(), xe(pa, {
      key: 0,
      to: e.to
    }, [
      ve(t.$slots, "default")
    ], 8, ["to"])) : ve(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), Ou = ["height", "width"], Mu = ["r", "stroke-width"], Ru = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], Fo = /* @__PURE__ */ Se({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = W(() => Math.min(100, Math.max(0, e.progress))), n = W(() => e.radius - e.strokeWidth), r = W(() => 2 * Math.PI * n.value), o = W(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => ($(), j("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ne("circle", {
        class: ye(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, Mu),
      ne("circle", {
        class: ye(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": o.value,
        "stroke-width": e.strokeWidth
      }, null, 10, Ru)
    ], 8, Ou));
  }
}), Nu = { class: "lc-timer-circle" }, Fu = ["aria-valuenow"], Pu = { class: "lc-timer-circle__content" }, Bu = /* @__PURE__ */ Se({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = pe(0), n = sc(t, {
      duration: e.durationInMs,
      transition: cc.linear
    });
    return St(() => {
      t.value = 100;
    }), (r, o) => ($(), j("div", Nu, [
      ne("div", {
        "aria-valuenow": Z(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Re(Z(Fo), Ce({ progress: Z(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, Fu),
      ne("div", Pu, [
        ve(r.$slots, "default")
      ])
    ]));
  }
}), zu = (e, t) => e in t, tn = (e, t) => typeof e == "string" && Object.values(t).includes(e), Vu = "left", Hu = "large", Uu = "primary", $1 = ["left", "right"], I1 = ["large", "medium", "small"], D1 = ["button", "reset", "submit"], O1 = ["click", "long-press"], M1 = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var Gr = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(Gr || {});
const qu = ["aria-valuenow"], ju = { class: "lc-button__content" }, Zu = {
  key: 0,
  class: "lc-button__label-bubble"
}, Wu = {
  key: 0,
  class: "lc-button__overlay"
}, Xu = { class: "lc-button__long-press-hint" }, Yu = {
  key: 1,
  class: "lc-button__overlay"
}, Gu = {
  key: 0,
  class: "lc-button__loading-text"
}, il = 1e3 / 25, Tt = /* @__PURE__ */ Se({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: () => Vu },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => Ze.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: () => Hu },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: () => Uu }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = cn(), o = pe(!!r.default), i = pe(!1), a = pe(!1), s = pe(!1), l = pe(!1), h = pe(0), v = pe(null);
    let u, f, m;
    const c = W(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": p.value,
        "lc-button--icon-only": !o.value,
        "lc-button--link": x.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && s.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), p = W(() => e.disabled || e.loading), x = W(() => !!(e.href || e.to) && !p.value), g = W(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = W(() => l.value || !!v.value), C = W(() => typeof e.to == "string" ? void 0 : e.to?.replace), A = W(() => {
      const H = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? H : {
        ...H,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = W(() => x.value ? Yn(e.to) : "button"), L = () => {
      i.value = !1, s.value = !1, V(), _();
    }, E = (H) => {
      p.value || tn(H.key, Gr) && (v.value || (v.value = H.key, U()));
    }, F = (H) => {
      tn(H.key, Gr) && H.key === v.value && (V(), !l.value && B());
    }, U = (H = !1) => {
      e.trigger !== "click" && (H && window.addEventListener("pointerup", O), clearTimeout(m), s.value = !0);
    }, K = () => {
      p.value || (l.value = !0, U(!0));
    }, O = () => {
      window.removeEventListener("pointerup", O), _(), !v.value && B();
    }, V = () => {
      v.value = null;
    }, B = () => {
      !s.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, s.value = !1);
    }, _ = () => {
      l.value = !1;
    }, T = () => {
      p.value || U();
    }, R = () => {
      _(), B();
    };
    return fo(() => {
      o.value = !!r.default;
    }), In(() => {
      clearInterval(u), clearTimeout(f), clearTimeout(m);
    }), He(s, (H) => {
      if (!p.value) {
        if (!H) {
          clearInterval(u), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, u = setInterval(() => {
          h.value += il / e.longPressDelay * 100;
        }, il), f = setTimeout(() => {
          clearInterval(u), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (H, q) => ($(), xe(Nt(I.value), Ce(H.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: A.value,
      replace: C.value
    }, {
      "aria-busy": e.loading,
      class: c.value,
      disabled: p.value,
      onBlur: L,
      onContextmenu: q[0] || (q[0] = ca(() => {
      }, ["prevent"])),
      onKeydown: E,
      onKeyup: F,
      onPointerdown: K,
      onPointerup: O,
      onTouchend: R,
      onTouchstartPassive: T
    }), {
      default: _e(() => [
        e.trigger === "long-press" ? ($(), j("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, qu)) : se("", !0),
        ne("div", ju, [
          e.icon ? ($(), xe(Z(Je), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : se("", !0),
          Re(kn, { name: "font-size-fade" }, {
            default: _e(() => [
              H.$slots.default ? ($(), j("span", Zu, [
                ve(H.$slots, "default"),
                Re(Z(Wr), Ce({ count: e.count }, {
                  class: "lc-button__count-text",
                  variant: "info"
                }), null, 16)
              ])) : se("", !0)
            ]),
            _: 3
          }),
          H.$slots.default ? se("", !0) : ($(), xe(Z(Wr), Ce({ key: 1 }, { count: e.count }, {
            class: "lc-button__count",
            variant: "info"
          }), null, 16))
        ]),
        Re(Z(ua), { name: "fade" }, {
          default: _e(() => [
            g.value ? ($(), j("div", Wu, [
              ne("span", Xu, Ie(e.longPressHint), 1)
            ])) : se("", !0),
            e.loading ? ($(), j("div", Yu, [
              Re(Z(Je), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? ($(), j("span", Gu, Ie(e.loadingText), 1)) : se("", !0)
            ])) : se("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), Ku = "default", R1 = ["dashed", "default"], hi = /* @__PURE__ */ Se({
  __name: "LcSeparator",
  props: {
    variant: { default: () => Ku }
  },
  setup(e) {
    return (t, n) => ($(), j("hr", {
      class: ye(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), $t = (e) => {
  if (e) return `lc-${e}`;
  const t = ya(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, vi = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Ju = {}, Qu = { viewBox: "0 0 752 8" }, ed = { id: "perforation" }, td = ["cx"];
function nd(e, t) {
  return $(), j("svg", Qu, [
    ne("mask", ed, [
      t[0] || (t[0] = ne("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), j(rt, null, yt(new Array(21), (n, r) => ($(), j("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, td))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const ad = /* @__PURE__ */ vi(Ju, [["render", nd]]), rd = {}, id = { viewBox: "0 0 752 8" }, ld = { id: "perforation" }, od = ["points"];
function sd(e, t) {
  return $(), j("svg", id, [
    ne("mask", ld, [
      t[0] || (t[0] = ne("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), j(rt, null, yt(new Array(150), (n, r) => ($(), j("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, od))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const ll = /* @__PURE__ */ vi(rd, [["render", sd]]), cd = ["id"], ud = {
  key: 0,
  class: "lc-card__background"
}, dd = {
  key: 1,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--top"])
}, fd = {
  key: 0,
  class: "lc-card__toggle"
}, hd = {
  key: 2,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--bottom"])
}, wa = /* @__PURE__ */ Se({
  __name: "LcCard",
  props: /* @__PURE__ */ Cn({
    animated: { type: Boolean },
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => Ze.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Cn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = cn(), n = $t(e.id), r = pe(!!t.default), o = Ya(e, "modelValue"), i = W(() => !!e.animated && (!!e.expandable || o.value)), a = W(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--animated": i.value,
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": o.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), s = () => {
      e.expandable && (o.value = !o.value);
    };
    return fo(() => {
      r.value = !!t.default;
    }), (l, h) => ($(), j("article", {
      id: Z(n),
      class: ye(a.value)
    }, [
      l.$slots.background ? ($(), j("div", ud, [
        ve(l.$slots, "background")
      ])) : se("", !0),
      e.variant === "transaction" ? ($(), j("div", dd, [
        Re(ll)
      ])) : se("", !0),
      l.$slots.header || e.expandable ? ($(), xe(Nt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${Z(n)}-region` : void 0,
        "aria-expanded": e.expandable ? o.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: s
      }, {
        default: _e(() => [
          e.headerTo && !e.expandable ? ($(), xe(Z(fi), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: _e(() => [
              ne("header", {
                class: ye(["lc-card__header", e.headerClass])
              }, [
                ve(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : ($(), j("header", {
            key: 1,
            class: ye(["lc-card__header", e.headerClass])
          }, [
            ve(l.$slots, "header"),
            e.expandable ? ($(), j(rt, { key: 0 }, [
              l.$slots.toggle ? ($(), j("div", fd, [
                ve(l.$slots, "toggle")
              ])) : ($(), xe(Z(Je), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : se("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : se("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || i.value || o.value) ? ($(), xe(Z(No), Ce({
        key: 3,
        id: `${Z(n)}-region`
      }, { when: o.value }, {
        animated: i.value,
        class: "lc-card__body-wrap",
        onCollapse: h[0] || (h[0] = (v) => l.$emit("collapse")),
        onCollapsed: h[1] || (h[1] = (v) => l.$emit("collapsed")),
        onExpand: h[2] || (h[2] = (v) => l.$emit("expand")),
        onExpanded: h[3] || (h[3] = (v) => l.$emit("expanded"))
      }), {
        default: _e(() => [
          l.$slots.default ? ($(), j("div", {
            key: 0,
            class: ye(["lc-card__body", e.bodyClass])
          }, [
            ve(l.$slots, "default")
          ], 2)) : se("", !0),
          l.$slots.footer ? ($(), j("footer", {
            key: 1,
            class: ye(["lc-card__footer", e.footerClass])
          }, [
            e.showSeparator ? ($(), xe(Z(hi), {
              key: 0,
              variant: "dashed"
            })) : se("", !0),
            ve(l.$slots, "footer")
          ], 2)) : se("", !0),
          e.variant !== "default" ? ($(), j("div", hd, [
            e.variant == "order" ? ($(), xe(ad, { key: 0 })) : ($(), xe(ll, { key: 1 }))
          ])) : se("", !0)
        ]),
        _: 3
      }, 16, ["id", "animated"])) : se("", !0)
    ], 10, cd));
  }
}), N1 = ["large", "medium", "none"], F1 = ["large", "none", "small"], P1 = ["default", "order", "transaction"], tr = () => typeof window < "u", Kr = /* @__PURE__ */ new Set();
let Sr;
const vd = () => {
  Sr ??= Ys(!0).run(() => po(() => document.documentElement)), Sr && (Sr.value = Kr.size > 0);
}, md = (e) => {
  const t = /* @__PURE__ */ Symbol("lc-scroll-lock-owner"), n = (r) => {
    tr() && (r ? Kr.add(t) : Kr.delete(t), vd());
  };
  He(() => at(e), n, { immediate: !0 }), bo(() => n(!1));
}, gd = ".lc-modal__bg:not([inert]):not(.fade-leave-active)", Po = (e) => e ? [...document.querySelectorAll(gd)].some(
  (t) => t !== e && !e.contains(t) && !!(e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING)
) : !1, bd = ["aria-hidden", "inert"], pd = { class: "lc-modal__card-header-wrap" }, yd = { class: "lc-modal__card-header-actions" }, Bo = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => Ze.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => Ze.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => Ze.lcModal.noFocusTrap },
    spacing: { default: () => Ze.lcModal.spacing },
    stackDepth: {},
    to: { default: () => Ze.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = pe(), o = nt("background"), i = W(() => (e.stackDepth ?? 0) > 0), a = W(() => u("close-button")), s = W(
      () => e.stackDepth === void 0 ? void 0 : { "--lc-modal-stack-depth": e.stackDepth }
    ), v = {
      allowOutsideClick: (c) => {
        const p = c.target;
        return p ? at(e.ignoreOutsideClickOn).some((x) => (typeof x == "string" ? document.querySelector(x) : go(x))?.contains(p) ?? !1) : !1;
      },
      // passed as a function, so the element is only created in the browser when the trap activates
      fallbackFocus: () => {
        const c = document.createElement("button");
        return c.id = "lc-modal-fallback-focus", c.hidden = !0, c;
      },
      immediate: !0
    }, u = (c) => e.closeTriggers.includes(c), f = (c) => {
      i.value || u(c) && (Po(o.value) || n("close"));
    }, m = (c) => {
      r.value = c;
    };
    return Qa(r, () => f("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), yo("Escape", () => f("escape")), md(() => e.isVisible), (c, p) => e.isVisible ? ($(), xe(pa, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Re(Z(ua), { name: "fade" }, {
        default: _e(() => [
          ne("div", {
            ref: "background",
            "aria-hidden": i.value || void 0,
            class: ye([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize,
                "lc-modal__bg--no-backdrop": i.value
              },
              e.backgroundClass
            ]),
            inert: i.value || void 0,
            style: Et(s.value)
          }, [
            Re(Z(ua), Ce(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: _e(() => [
                ($(), xe(Nt(e.noFocusTrap ? "div" : Z($o)), {
                  options: e.noFocusTrap ? null : v
                }, {
                  default: _e(() => [
                    ve(c.$slots, "modal", Ot(Pt({ setRef: m })), () => [
                      Re(Z(wa), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: ye([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: _e(() => [
                          c.$slots.header || a.value ? ($(), j("header", {
                            key: 0,
                            class: ye(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": a.value || e.fullSize
                            }])
                          }, [
                            ne("div", pd, [
                              ve(c.$slots, "header")
                            ]),
                            ne("div", yd, [
                              ve(c.$slots, "actions"),
                              a.value ? ($(), xe(Z(Tt), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: p[0] || (p[0] = (x) => f("close-button"))
                              })) : se("", !0)
                            ])
                          ], 2)) : se("", !0),
                          ve(c.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 14, bd)
        ]),
        _: 3
      })
    ], 8, ["to"])) : se("", !0);
  }
}), B1 = ["click-outside", "close-button", "escape"], z1 = ["large", "medium", "small"], wd = 30, xd = 0.3, ol = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const o = parseFloat(t[1]);
    return t[2] === "px" ? o : o / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, kd = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const o = pe(0), i = pe(0), a = pe(!1), s = pe(0), l = pe(0), h = pe(0), v = pe(0), u = W(
    () => at(t)[s.value] ?? at(t)[0]
  ), f = W(() => s.value < at(t).length - 1), m = () => {
    i.value = 0, o.value = 0, a.value = !1;
  }, c = () => {
    s.value = 0;
  }, p = (C, A) => (A > 0 ? C / A : 0) > xd || C > wd, x = () => {
    if (!a.value) return;
    const C = v.value - h.value, A = Date.now() - l.value, I = Math.abs(C), L = C > 0 ? "down" : "up", E = at(t);
    if (L === "up" && f.value && p(I, A)) {
      const U = ol(E[s.value]) + I;
      let K = s.value + 1, O = 1 / 0;
      for (let V = s.value + 1; V < E.length; V++) {
        const B = Math.abs(ol(E[V]) - U);
        B < O && (O = B, K = V);
      }
      s.value = K, m();
      return;
    }
    if (L === "down" && p(I, A) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (C) => {
    if (C.target.closest('button, a, [role="button"]')) return;
    C.currentTarget.setPointerCapture(C.pointerId), h.value = C.clientY, v.value = C.clientY, l.value = Date.now(), a.value = !0;
  }, b = (C) => {
    if (!a.value) return;
    v.value = C.clientY;
    const A = v.value - h.value;
    A < 0 && f.value ? (i.value = -A, o.value = 0) : (i.value = 0, o.value = Math.max(0, A));
  };
  return qt(e, "pointerdown", g), qt(e, "pointermove", b), qt(e, "pointerup", x), qt(e, "pointercancel", x), qt(e, "lostpointercapture", x), {
    currentSnapHeight: u,
    currentSnapIndex: s,
    dismissOffset: o,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: c,
    snapTransitionOffset: i
  };
}, Sd = { class: "lc-bottom-sheet-modal__header" }, _d = { class: "lc-bottom-sheet-modal__header-actions" }, Cd = {
  key: 0,
  class: "lc-bottom-sheet-modal__footer"
}, Ed = {
  ref: "sheetRoot",
  class: "lc-bottom-sheet"
}, Td = ["aria-labelledby"], Ad = { class: "lc-bottom-sheet__header-actions" }, Ld = {
  key: 0,
  class: "lc-bottom-sheet__footer"
}, La = 300, sl = "lc-bottom-sheet__drag-area", $d = "(width < 496px)", V1 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    maxHeight: {},
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => Ze.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${sl}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], o = t;
    let i;
    const s = `${$t()}-header`, l = nt("dragArea"), h = nt("sheetRoot"), v = pe(!1), u = pe(!1), f = pe(!0), m = uc($d), c = po(() => tr() ? document.documentElement : null), {
      currentSnapHeight: p,
      dismissOffset: x,
      isDragging: g,
      resetDrag: b,
      resetSnapIndex: C,
      snapTransitionOffset: A
    } = kd({
      canClose: () => K("swipe-down"),
      dragAreaRef: l,
      onClose: () => F(),
      snapHeights: W(() => e.snapHeights)
    }), I = W(
      () => e.closeTriggers.filter(
        (V) => r.includes(V)
      )
    ), L = () => {
      if (g.value) {
        const B = A.value !== 0;
        return {
          height: B ? `calc(${p.value} + ${A.value}px)` : p.value,
          transform: B ? "translateY(0)" : `translateY(${Math.max(0, x.value)}px)`,
          transition: "none"
        };
      }
      if (v.value)
        return {
          height: p.value,
          transform: "translateY(100%)",
          transition: `transform ${La}ms ease`
        };
      const V = f.value;
      return {
        height: p.value,
        transform: V ? "translateY(100%)" : "translateY(0)",
        transition: f.value ? "none" : `height ${La}ms ease, transform ${La}ms ease`
      };
    }, E = W(() => ({ maxHeight: e.maxHeight, ...L() })), F = () => {
      v.value || (v.value = !0, i = setTimeout(() => {
        v.value = !1, b(), C(), o("update:modelValue", !1);
      }, La));
    }, U = () => {
      K("click-outside") && F();
    }, K = (V) => e.closeTriggers.includes(V), O = (V) => {
      const B = V.target;
      u.value = B.scrollTop > 0;
    };
    return He(
      () => e.modelValue,
      async (V) => {
        if (!V) return c.value = !1;
        clearTimeout(i), v.value = !1, b(), u.value = !1, f.value = !0, c.value = !0, await Ga(), requestAnimationFrame(() => {
          f.value = !1;
        });
      },
      { immediate: !0 }
    ), yo("Escape", () => {
      !m.value || !e.modelValue || !K("escape") || Po(h.value) || F();
    }), In(() => {
      clearTimeout(i), c.value = !1;
    }), (V, B) => Z(m) ? e.modelValue ? ($(), xe(pa, {
      key: 1,
      to: e.to
    }, [
      ne("div", Ed, [
        ne("div", {
          class: ye(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": v.value }]),
          role: "presentation",
          onClick: U
        }, null, 2),
        Re(Z($o), { options: n }, {
          default: _e(() => [
            ne("div", {
              "aria-labelledby": V.$slots.title ? s : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Et(E.value)
            }, [
              ne("div", {
                ref: "dragArea",
                class: ye([
                  sl,
                  { "lc-bottom-sheet__drag-area--scrolled": u.value }
                ])
              }, [
                B[1] || (B[1] = ne("div", { class: "lc-bottom-sheet__handle" }, [
                  ne("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                V.$slots.title || K("close-button") ? ($(), j("div", {
                  key: 0,
                  id: s,
                  class: "lc-bottom-sheet__header"
                }, [
                  ve(V.$slots, "title"),
                  ne("div", Ad, [
                    ve(V.$slots, "actions"),
                    K("close-button") ? ($(), xe(Z(Tt), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: F
                    })) : se("", !0)
                  ])
                ])) : se("", !0)
              ], 2),
              ne("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: O
              }, [
                ve(V.$slots, "default")
              ], 544),
              V.$slots.footer ? ($(), j("div", Ld, [
                ve(V.$slots, "footer")
              ])) : se("", !0)
            ], 12, Td)
          ]),
          _: 3
        })
      ], 512)
    ], 8, ["to"])) : se("", !0) : ($(), xe(Z(Bo), Ce({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${u.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": I.value,
      spacing: "small",
      onClose: B[0] || (B[0] = (_) => o("update:modelValue", !1))
    }), Ka({
      default: _e(() => [
        ne("div", {
          class: ye(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": u.value }]),
          onScroll: O
        }, [
          ve(V.$slots, "default")
        ], 34),
        V.$slots.footer ? ($(), j("div", Cd, [
          ve(V.$slots, "footer")
        ])) : se("", !0)
      ]),
      _: 2
    }, [
      V.$slots.title ? {
        name: "header",
        fn: _e(() => [
          ne("div", Sd, [
            ve(V.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      V.$slots.actions ? {
        name: "actions",
        fn: _e(() => [
          ne("div", _d, [
            ve(V.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), H1 = ["swipe-down", "click-outside", "escape"];
function zo(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function o(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: u
    } = t.internalEngine();
    v !== "y" && (n = u.map((f) => f.height), r.forEach((f) => t.on(f, s)), s());
  }
  function i() {
    r.forEach((v) => t.off(v, s));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((u) => n[u]).reduce((u, f) => Math.max(u, f), 0) : null;
  }
  function s() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: o,
    destroy: i
  };
}
zo.globalOptions = void 0;
const Id = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Qn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function ea(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function $a(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function nr(e = {}) {
  let t, n, r, o, i = [], a = [];
  const s = ["select"], l = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function u(b, C) {
    n = b;
    const {
      mergeOptions: A,
      optionsAtMedia: I
    } = C, L = A(Id, nr.globalOptions), E = A(L, e);
    t = I(E), r = n.rootNode(), o = n.slideNodes();
    const {
      watchDrag: F,
      loop: U
    } = n.internalEngine().options, K = !!F;
    t.loop && U && (v.loop = Qn(t.loop), $a(r, v.loop)), t.draggable && K && (v.draggable = Qn(t.draggable), $a(r, v.draggable)), t.dragging && (v.dragging = Qn(t.dragging), l.forEach((O) => n.on(O, m))), t.snapped && (v.snapped = Qn(t.snapped), s.forEach((O) => n.on(O, p)), p()), t.inView && (v.inView = Qn(t.inView), h.forEach((O) => n.on(O, x)), x());
  }
  function f() {
    l.forEach((b) => n.off(b, m)), s.forEach((b) => n.off(b, p)), h.forEach((b) => n.off(b, x)), ea(r, v.loop), ea(r, v.draggable), ea(r, v.dragging), c([], i, v.snapped), c([], a, v.inView), Object.keys(v).forEach((b) => {
      const C = b;
      v[C] = [];
    });
  }
  function m(b, C) {
    (C === "pointerDown" ? $a : ea)(r, v.dragging);
  }
  function c(b = [], C = [], A) {
    const I = C.map((E) => o[E]), L = b.map((E) => o[E]);
    return I.forEach((E) => ea(E, A)), L.forEach((E) => $a(E, A)), b;
  }
  function p() {
    const {
      slideRegistry: b
    } = n.internalEngine(), C = b[n.selectedScrollSnap()];
    i = c(C, i, v.snapped);
  }
  function x() {
    const b = n.slidesInView();
    a = c(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: u,
    destroy: f
  };
}
nr.globalOptions = void 0;
function cl(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function _r(e) {
  return typeof e == "number" && !isNaN(e);
}
function Vo(e = {}) {
  let o, i = [], a, s = 0, l = 0, h = 0, v = !1, u, f;
  function m(_) {
    o = _;
    const T = o.selectedScrollSnap(), {
      scrollBody: R,
      containerRect: H,
      axis: q
    } = o.internalEngine(), G = q.measureSize(H);
    a = cl(G * 0.75, 200, 500), v = !1, i = o.scrollSnapList().map((ie, X) => X === T ? 1 : 0), u = R.settled, f = o.scrollProgress, R.settled = O, o.scrollProgress = V, o.on("select", b).on("slideFocus", p).on("pointerDown", g).on("pointerUp", x), A(), p();
  }
  function c() {
    const {
      scrollBody: _
    } = o.internalEngine();
    _.settled = u, o.scrollProgress = f, o.off("select", b).off("slideFocus", p).off("pointerDown", g).off("pointerUp", x), o.slideNodes().forEach((T) => {
      const R = T.style;
      R.opacity = "", R.transform = "", R.pointerEvents = "", T.getAttribute("style") || T.removeAttribute("style");
    });
  }
  function p() {
    const _ = o.selectedScrollSnap();
    L(_, 1);
  }
  function x() {
    v = !1;
  }
  function g() {
    v = !1, s = 0, l = 0;
  }
  function b() {
    const _ = o.internalEngine().scrollBody.duration();
    l = _ ? 0 : 1, v = !0, _ || p();
  }
  function C(_) {
    const {
      axis: T
    } = o.internalEngine();
    return `translate${T.scroll.toUpperCase()}(${T.direction(_)}px)`;
  }
  function A() {
    const {
      translate: _,
      slideLooper: T
    } = o.internalEngine();
    _.clear(), _.toggleActive(!1), T.loopPoints.forEach(({
      translate: R
    }) => {
      R.clear(), R.toggleActive(!1);
    });
  }
  function I(_) {
    const {
      scrollSnaps: T,
      location: R,
      target: H
    } = o.internalEngine();
    !_r(_) || i[_] < 0.5 || (R.set(T[_]), H.set(R));
  }
  function L(_, T) {
    o.scrollSnapList().forEach((H, q) => {
      const G = Math.abs(T), ie = i[q], X = q === _, oe = X ? ie + G : ie - G, ue = cl(oe, 0, 1);
      i[q] = ue;
      const he = X && v, be = o.previousScrollSnap();
      he && (i[be] = 1 - ue), X && F(_, ue), E(q);
    });
  }
  function E(_) {
    const T = o.internalEngine().slideRegistry[_], {
      scrollSnaps: R,
      containerRect: H
    } = o.internalEngine(), q = i[_];
    T.forEach((G) => {
      const ie = o.slideNodes()[G].style, X = parseFloat(q.toFixed(2)), oe = X > 0, ue = oe ? R[_] : H.width + 2, he = C(ue);
      oe && (ie.transform = he), ie.opacity = X.toString(), ie.pointerEvents = q > 0.5 ? "auto" : "none", oe || (ie.transform = he);
    });
  }
  function F(_, T) {
    const {
      index: R,
      dragHandler: H,
      scrollSnaps: q
    } = o.internalEngine(), G = H.pointerDown(), ie = 1 / (q.length - 1);
    let X = _, oe = G ? o.selectedScrollSnap() : o.previousScrollSnap();
    if (G && X === oe) {
      const be = Math.sign(s) * -1;
      X = oe, oe = R.clone().set(oe).add(be).get();
    }
    const ue = oe * ie, he = (X - oe) * ie;
    h = ue + he * T;
  }
  function U() {
    const {
      dragHandler: _,
      index: T,
      scrollBody: R
    } = o.internalEngine(), H = o.selectedScrollSnap();
    if (!_.pointerDown()) return H;
    const q = Math.sign(R.velocity()), G = Math.sign(s), ie = T.clone().set(H).add(q * -1).get();
    return !q || !G ? null : G === q ? ie : H;
  }
  function K(_) {
    const {
      dragHandler: T,
      scrollBody: R
    } = _.internalEngine(), H = T.pointerDown(), q = R.velocity(), G = R.duration(), ie = U(), X = !_r(ie);
    if (H) {
      if (!q) return;
      s += q, l = Math.abs(q / a), I(ie);
    }
    if (!H) {
      if (!G || X) return;
      l += (1 - i[ie]) / G, l *= 0.68;
    }
    X || L(ie, l);
  }
  function O() {
    const {
      target: _,
      location: T
    } = o.internalEngine(), R = _.get() - T.get(), H = Math.abs(R) >= 1, q = U(), G = !_r(q);
    return K(o), G || H ? !1 : i[q] > 0.999;
  }
  function V() {
    return h;
  }
  return {
    name: "fade",
    options: e,
    init: m,
    destroy: c
  };
}
Vo.globalOptions = void 0;
function Dd(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ul(e) {
  return Dd(e) || Array.isArray(e);
}
function Od() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function mi(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== i ? !1 : n.every((a) => {
    const s = e[a], l = t[a];
    return typeof s == "function" ? `${s}` == `${l}` : !ul(s) || !ul(l) ? s === l : mi(s, l);
  });
}
function dl(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function Md(e, t) {
  if (e.length !== t.length) return !1;
  const n = dl(e), r = dl(t);
  return n.every((o, i) => {
    const a = r[i];
    return mi(o, a);
  });
}
function gi(e) {
  return typeof e == "number";
}
function Jr(e) {
  return typeof e == "string";
}
function ar(e) {
  return typeof e == "boolean";
}
function fl(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function dt(e) {
  return Math.abs(e);
}
function bi(e) {
  return Math.sign(e);
}
function oa(e, t) {
  return dt(e - t);
}
function Rd(e, t) {
  if (e === 0 || t === 0 || dt(e) <= dt(t)) return 0;
  const n = oa(dt(e), dt(t));
  return dt(n / e);
}
function Nd(e) {
  return Math.round(e * 100) / 100;
}
function da(e) {
  return fa(e).map(Number);
}
function jt(e) {
  return e[xa(e)];
}
function xa(e) {
  return Math.max(0, e.length - 1);
}
function pi(e, t) {
  return t === xa(e);
}
function hl(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function fa(e) {
  return Object.keys(e);
}
function Ho(e, t) {
  return [e, t].reduce((n, r) => (fa(r).forEach((o) => {
    const i = n[o], a = r[o], s = fl(i) && fl(a);
    n[o] = s ? Ho(i, a) : a;
  }), n), {});
}
function Qr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function Fd(e, t) {
  const n = {
    start: r,
    center: o,
    end: i
  };
  function r() {
    return 0;
  }
  function o(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, h) {
    return Jr(e) ? n[e](l) : e(t, l, h);
  }
  return {
    measure: a
  };
}
function ha() {
  let e = [];
  function t(o, i, a, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(i, a, s), l = () => o.removeEventListener(i, a, s);
    else {
      const h = o;
      h.addListener(a), l = () => h.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function Pd(e, t, n, r) {
  const o = ha(), i = 1e3 / 60;
  let a = null, s = 0, l = 0;
  function h() {
    o.add(e, "visibilitychange", () => {
      e.hidden && c();
    });
  }
  function v() {
    m(), o.clear();
  }
  function u(x) {
    if (!l) return;
    a || (a = x, n(), n());
    const g = x - a;
    for (a = x, s += g; s >= i; )
      n(), s -= i;
    const b = s / i;
    r(b), l && (l = t.requestAnimationFrame(u));
  }
  function f() {
    l || (l = t.requestAnimationFrame(u));
  }
  function m() {
    t.cancelAnimationFrame(l), a = null, s = 0, l = 0;
  }
  function c() {
    a = null, s = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function Bd(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, s = v(), l = u();
  function h(c) {
    const {
      height: p,
      width: x
    } = c;
    return r ? p : x;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(c) {
    return c * a;
  }
  return {
    scroll: o,
    cross: i,
    startEdge: s,
    endEdge: l,
    measureSize: h,
    direction: f
  };
}
function Tn(e = 0, t = 0) {
  const n = dt(e - t);
  function r(h) {
    return h < e;
  }
  function o(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || o(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function s(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function Uo(e, t, n) {
  const {
    constrain: r
  } = Tn(0, e), o = e + 1;
  let i = a(t);
  function a(f) {
    return n ? dt((o + f) % o) : r(f);
  }
  function s() {
    return i;
  }
  function l(f) {
    return i = a(f), u;
  }
  function h(f) {
    return v().set(s() + f);
  }
  function v() {
    return Uo(e, s(), n);
  }
  const u = {
    get: s,
    set: l,
    add: h,
    clone: v
  };
  return u;
}
function zd(e, t, n, r, o, i, a, s, l, h, v, u, f, m, c, p, x, g, b) {
  const {
    cross: C,
    direction: A
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, E = ha(), F = ha(), U = Tn(50, 225).constrain(m.measure(20)), K = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, V = c ? 43 : 25;
  let B = !1, _ = 0, T = 0, R = !1, H = !1, q = !1, G = !1;
  function ie(de) {
    if (!b) return;
    function Ne(je) {
      (ar(b) || b(de, je)) && fe(je);
    }
    const qe = t;
    E.add(qe, "dragstart", (je) => je.preventDefault(), L).add(qe, "touchmove", () => {
    }, L).add(qe, "touchend", () => {
    }).add(qe, "touchstart", Ne).add(qe, "mousedown", Ne).add(qe, "touchcancel", Ae).add(qe, "contextmenu", Ae).add(qe, "click", Oe, !0);
  }
  function X() {
    E.clear(), F.clear();
  }
  function oe() {
    const de = G ? n : t;
    F.add(de, "touchmove", we, L).add(de, "touchend", Ae).add(de, "mousemove", we, L).add(de, "mouseup", Ae);
  }
  function ue(de) {
    const Ne = de.nodeName || "";
    return I.includes(Ne);
  }
  function he() {
    return (c ? O : K)[G ? "mouse" : "touch"];
  }
  function be(de, Ne) {
    const qe = u.add(bi(de) * -1), je = v.byDistance(de, !c).distance;
    return c || dt(de) < U ? je : x && Ne ? je * 0.5 : v.byIndex(qe.get(), 0).distance;
  }
  function fe(de) {
    const Ne = Qr(de, r);
    G = Ne, q = c && Ne && !de.buttons && B, B = oa(o.get(), a.get()) >= 2, !(Ne && de.button !== 0) && (ue(de.target) || (R = !0, i.pointerDown(de), h.useFriction(0).useDuration(0), o.set(a), oe(), _ = i.readPoint(de), T = i.readPoint(de, C), f.emit("pointerDown")));
  }
  function we(de) {
    if (!Qr(de, r) && de.touches.length >= 2) return Ae(de);
    const qe = i.readPoint(de), je = i.readPoint(de, C), Xe = oa(qe, _), Ve = oa(je, T);
    if (!H && !G && (!de.cancelable || (H = Xe > Ve, !H)))
      return Ae(de);
    const Pe = i.pointerMove(de);
    Xe > p && (q = !0), h.useFriction(0.3).useDuration(0.75), s.start(), o.add(A(Pe)), de.preventDefault();
  }
  function Ae(de) {
    const qe = v.byDistance(0, !1).index !== u.get(), je = i.pointerUp(de) * he(), Xe = be(A(je), qe), Ve = Rd(je, Xe), Pe = V - 10 * Ve, it = g + Ve / 50;
    H = !1, R = !1, F.clear(), h.useDuration(Pe).useFriction(it), l.distance(Xe, !c), G = !1, f.emit("pointerUp");
  }
  function Oe(de) {
    q && (de.stopPropagation(), de.preventDefault(), q = !1);
  }
  function We() {
    return R;
  }
  return {
    init: ie,
    destroy: X,
    pointerDown: We
  };
}
function Vd(e, t) {
  let r, o;
  function i(u) {
    return u.timeStamp;
  }
  function a(u, f) {
    const c = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Qr(u, t) ? u : u.touches[0])[c];
  }
  function s(u) {
    return r = u, o = u, a(u);
  }
  function l(u) {
    const f = a(u) - a(o), m = i(u) - i(r) > 170;
    return o = u, m && (r = u), f;
  }
  function h(u) {
    if (!r || !o) return 0;
    const f = a(o) - a(r), m = i(u) - i(r), c = i(u) - i(o) > 170, p = f / m;
    return m && !c && dt(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: h,
    readPoint: a
  };
}
function Hd() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: o + i,
      bottom: r + a,
      left: o,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function Ud(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function qd(e, t, n, r, o, i, a) {
  const s = [e].concat(r);
  let l, h, v = [], u = !1;
  function f(x) {
    return o.measureSize(a.measure(x));
  }
  function m(x) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const C of b) {
        if (u) return;
        const A = C.target === e, I = r.indexOf(C.target), L = A ? h : v[I], E = f(A ? e : r[I]);
        if (dt(E - L) >= 0.5) {
          x.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (ar(i) || i(x, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      s.forEach((b) => l.observe(b));
    });
  }
  function c() {
    u = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: c
  };
}
function jd(e, t, n, r, o, i) {
  let a = 0, s = 0, l = o, h = i, v = e.get(), u = 0;
  function f() {
    const L = r.get() - e.get(), E = !l;
    let F = 0;
    return E ? (a = 0, n.set(r), e.set(r), F = L) : (n.set(e), a += L / l, a *= h, v += a, e.add(a), F = v - u), s = bi(F), u = v, I;
  }
  function m() {
    const L = r.get() - t.get();
    return dt(L) < 1e-3;
  }
  function c() {
    return l;
  }
  function p() {
    return s;
  }
  function x() {
    return a;
  }
  function g() {
    return C(o);
  }
  function b() {
    return A(i);
  }
  function C(L) {
    return l = L, I;
  }
  function A(L) {
    return h = L, I;
  }
  const I = {
    direction: p,
    duration: c,
    velocity: x,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: A,
    useDuration: C
  };
  return I;
}
function Zd(e, t, n, r, o) {
  const i = o.measure(10), a = o.measure(50), s = Tn(0.1, 0.99);
  let l = !1;
  function h() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const c = e.reachedMin(t.get()) ? "min" : "max", p = dt(e[c] - t.get()), x = n.get() - t.get(), g = s.constrain(p / a);
    n.subtract(x * g), !m && dt(x) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function u(m) {
    l = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: u
  };
}
function Wd(e, t, n, r, o) {
  const i = Tn(-t + e, 0), a = u(), s = v(), l = f();
  function h(c, p) {
    return oa(c, p) <= 1;
  }
  function v() {
    const c = a[0], p = jt(a), x = a.lastIndexOf(c), g = a.indexOf(p) + 1;
    return Tn(x, g);
  }
  function u() {
    return n.map((c, p) => {
      const {
        min: x,
        max: g
      } = i, b = i.constrain(c), C = !p, A = pi(n, p);
      return C ? g : A || h(x, b) ? x : h(g, b) ? g : b;
    }).map((c) => parseFloat(c.toFixed(3)));
  }
  function f() {
    if (t <= e + o) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: c,
      max: p
    } = s;
    return a.slice(c, p);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function Xd(e, t, n) {
  const r = t[0], o = n ? r - e : jt(t);
  return {
    limit: Tn(o, r)
  };
}
function Yd(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = Tn(i, a);
  function h(f) {
    return f === 1 ? l(n.get()) : f === -1 ? s(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((c) => c.add(m));
  }
  return {
    loop: v
  };
}
function Gd(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function Kd(e, t, n, r, o) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: s
  } = o, l = u().map(t.measure), h = f(), v = m();
  function u() {
    return s(r).map((p) => jt(p)[a] - p[0][i]).map(dt);
  }
  function f() {
    return r.map((p) => n[i] - p[i]).map((p) => -dt(p));
  }
  function m() {
    return s(h).map((p) => p[0]).map((p, x) => p + l[x]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function Jd(e, t, n, r, o, i) {
  const {
    groupSlides: a
  } = o, {
    min: s,
    max: l
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(s, l).map((c, p, x) => {
      const g = !p, b = pi(x, p);
      if (g) {
        const C = jt(x[0]) + 1;
        return hl(C);
      }
      if (b) {
        const C = xa(i) - jt(x)[0] + 1;
        return hl(C, jt(x)[0]);
      }
      return c;
    });
  }
  return {
    slideRegistry: h
  };
}
function Qd(e, t, n, r, o) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: s
  } = r;
  function l(c) {
    return c.concat().sort((p, x) => dt(p) - dt(x))[0];
  }
  function h(c) {
    const p = e ? a(c) : s(c), x = t.map((b, C) => ({
      diff: v(b - p, 0),
      index: C
    })).sort((b, C) => dt(b.diff) - dt(C.diff)), {
      index: g
    } = x[0];
    return {
      index: g,
      distance: p
    };
  }
  function v(c, p) {
    const x = [c, c + n, c - n];
    if (!e) return c;
    if (!p) return l(x);
    const g = x.filter((b) => bi(b) === p);
    return g.length ? l(g) : jt(x) - n;
  }
  function u(c, p) {
    const x = t[c] - o.get(), g = v(x, p);
    return {
      index: c,
      distance: g
    };
  }
  function f(c, p) {
    const x = o.get() + c, {
      index: g,
      distance: b
    } = h(x), C = !e && i(x);
    if (!p || C) return {
      index: g,
      distance: c
    };
    const A = t[g] - b, I = c + v(A, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: v
  };
}
function ef(e, t, n, r, o, i, a) {
  function s(u) {
    const f = u.distance, m = u.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(u.index), a.emit("select"));
  }
  function l(u, f) {
    const m = o.byDistance(u, f);
    s(m);
  }
  function h(u, f) {
    const m = t.clone().set(u), c = o.byIndex(m.get(), f);
    s(c);
  }
  return {
    distance: l,
    index: h
  };
}
function tf(e, t, n, r, o, i, a, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!s) return;
    function c(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((C) => C.includes(p));
      gi(b) && (o.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", u, !1), t.forEach((p, x) => {
      i.add(p, "focus", (g) => {
        (ar(s) || s(m, g)) && c(x);
      }, l);
    });
  }
  function u(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function aa(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function o(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return gi(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: i
  };
}
function qo(e, t) {
  const n = e.scroll === "x" ? a : s, r = t.style;
  let o = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function s(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (i) return;
    const m = Nd(e.direction(f));
    m !== o && (r.transform = n(m), o = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: l,
    toggleActive: h
  };
}
function nf(e, t, n, r, o, i, a, s, l) {
  const v = da(o), u = da(o).reverse(), f = g().concat(b());
  function m(E, F) {
    return E.reduce((U, K) => U - o[K], F);
  }
  function c(E, F) {
    return E.reduce((U, K) => m(U, F) > 0 ? U.concat([K]) : U, []);
  }
  function p(E) {
    return i.map((F, U) => ({
      start: F - r[U] + 0.5 + E,
      end: F + t - 0.5 + E
    }));
  }
  function x(E, F, U) {
    const K = p(F);
    return E.map((O) => {
      const V = U ? 0 : -n, B = U ? n : 0, _ = U ? "end" : "start", T = K[O][_];
      return {
        index: O,
        loopPoint: T,
        slideLocation: aa(-1),
        translate: qo(e, l[O]),
        target: () => s.get() > T ? V : B
      };
    });
  }
  function g() {
    const E = a[0], F = c(u, E);
    return x(F, n, !1);
  }
  function b() {
    const E = t - a[0] - 1, F = c(v, E);
    return x(F, -n, !0);
  }
  function C() {
    return f.every(({
      index: E
    }) => {
      const F = v.filter((U) => U !== E);
      return m(F, t) <= 0.1;
    });
  }
  function A() {
    f.forEach((E) => {
      const {
        target: F,
        translate: U,
        slideLocation: K
      } = E, O = F();
      O !== K.get() && (U.to(O), K.set(O));
    });
  }
  function I() {
    f.forEach((E) => E.translate.clear());
  }
  return {
    canLoop: C,
    clear: I,
    loop: A,
    loopPoints: f
  };
}
function af(e, t, n) {
  let r, o = !1;
  function i(l) {
    if (!n) return;
    function h(v) {
      for (const u of v)
        if (u.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      o || (ar(n) || n(l, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function rf(e, t, n, r) {
  const o = {};
  let i = null, a = null, s, l = !1;
  function h() {
    s = new IntersectionObserver((c) => {
      l || (c.forEach((p) => {
        const x = t.indexOf(p.target);
        o[x] = p;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((c) => s.observe(c));
  }
  function v() {
    s && s.disconnect(), l = !0;
  }
  function u(c) {
    return fa(o).reduce((p, x) => {
      const g = parseInt(x), {
        isIntersecting: b
      } = o[g];
      return (c && b || !c && !b) && p.push(g), p;
    }, []);
  }
  function f(c = !0) {
    if (c && i) return i;
    if (!c && a) return a;
    const p = u(c);
    return c && (i = p), c || (a = p), p;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function lf(e, t, n, r, o, i) {
  const {
    measureSize: a,
    startEdge: s,
    endEdge: l
  } = e, h = n[0] && o, v = c(), u = p(), f = n.map(a), m = x();
  function c() {
    if (!h) return 0;
    const b = n[0];
    return dt(t[s] - b[s]);
  }
  function p() {
    if (!h) return 0;
    const b = i.getComputedStyle(jt(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function x() {
    return n.map((b, C, A) => {
      const I = !C, L = pi(A, C);
      return I ? f[C] + v : L ? f[C] + u : A[C + 1][s] - b[s];
    }).map(dt);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: u
  };
}
function of(e, t, n, r, o, i, a, s, l) {
  const {
    startEdge: h,
    endEdge: v,
    direction: u
  } = e, f = gi(n);
  function m(g, b) {
    return da(g).filter((C) => C % b === 0).map((C) => g.slice(C, C + b));
  }
  function c(g) {
    return g.length ? da(g).reduce((b, C, A) => {
      const I = jt(b) || 0, L = I === 0, E = C === xa(g), F = o[h] - i[I][h], U = o[h] - i[C][v], K = !r && L ? u(a) : 0, O = !r && E ? u(s) : 0, V = dt(U - O - (F + K));
      return A && V > t + l && b.push(C), E && b.push(g.length), b;
    }, []).map((b, C, A) => {
      const I = Math.max(A[C - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function p(g) {
    return f ? m(g, n) : c(g);
  }
  return {
    groupSlides: p
  };
}
function sf(e, t, n, r, o, i, a) {
  const {
    align: s,
    axis: l,
    direction: h,
    startIndex: v,
    loop: u,
    duration: f,
    dragFree: m,
    dragThreshold: c,
    inViewThreshold: p,
    slidesToScroll: x,
    skipSnaps: g,
    containScroll: b,
    watchResize: C,
    watchSlides: A,
    watchDrag: I,
    watchFocus: L
  } = i, E = 2, F = Hd(), U = F.measure(t), K = n.map(F.measure), O = Bd(l, h), V = O.measureSize(U), B = Ud(V), _ = Fd(s, V), T = !u && !!b, R = u || !!b, {
    slideSizes: H,
    slideSizesWithGaps: q,
    startGap: G,
    endGap: ie
  } = lf(O, U, K, n, R, o), X = of(O, V, x, u, U, K, G, ie, E), {
    snaps: oe,
    snapsAligned: ue
  } = Kd(O, _, U, K, X), he = -jt(oe) + jt(q), {
    snapsContained: be,
    scrollContainLimit: fe
  } = Wd(V, he, ue, b, E), we = T ? be : ue, {
    limit: Ae
  } = Xd(he, we, u), Oe = Uo(xa(we), v, u), We = Oe.clone(), Fe = da(n), de = ({
    dragHandler: S,
    scrollBody: w,
    scrollBounds: J,
    options: {
      loop: M
    }
  }) => {
    M || J.constrain(S.pointerDown()), w.seek();
  }, Ne = ({
    scrollBody: S,
    translate: w,
    location: J,
    offsetLocation: M,
    previousLocation: re,
    scrollLooper: D,
    slideLooper: Q,
    dragHandler: y,
    animation: ce,
    eventHandler: Te,
    scrollBounds: d,
    options: {
      loop: ae
    }
  }, te) => {
    const k = S.settled(), P = !d.shouldConstrain(), ee = ae ? k : k && P, $e = ee && !y.pointerDown();
    $e && ce.stop();
    const ke = J.get() * te + re.get() * (1 - te);
    M.set(ke), ae && (D.loop(S.direction()), Q.loop()), w.to(M.get()), $e && Te.emit("settle"), ee || Te.emit("scroll");
  }, qe = Pd(r, o, () => de(N), (S) => Ne(N, S)), je = 0.68, Xe = we[Oe.get()], Ve = aa(Xe), Pe = aa(Xe), it = aa(Xe), ut = aa(Xe), ge = jd(Ve, it, Pe, ut, f, je), Be = Qd(u, we, he, Ae, ut), ze = ef(qe, Oe, We, ge, Be, ut, a), Ke = Gd(Ae), Qe = ha(), ht = rf(t, n, a, p), {
    slideRegistry: vt
  } = Jd(T, b, we, fe, X, Fe), et = tf(e, n, vt, ze, ge, Qe, a, L), N = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: a,
    containerRect: U,
    slideRects: K,
    animation: qe,
    axis: O,
    dragHandler: zd(O, e, r, o, ut, Vd(O, o), Ve, qe, ze, ge, Be, Oe, a, B, m, c, g, je, I),
    eventStore: Qe,
    percentOfView: B,
    index: Oe,
    indexPrevious: We,
    limit: Ae,
    location: Ve,
    offsetLocation: it,
    previousLocation: Pe,
    options: i,
    resizeHandler: qd(t, a, o, n, O, C, F),
    scrollBody: ge,
    scrollBounds: Zd(Ae, it, ut, ge, B),
    scrollLooper: Yd(he, Ae, it, [Ve, it, Pe, ut]),
    scrollProgress: Ke,
    scrollSnapList: we.map(Ke.get),
    scrollSnaps: we,
    scrollTarget: Be,
    scrollTo: ze,
    slideLooper: nf(O, V, he, H, q, oe, we, it, n),
    slideFocus: et,
    slidesHandler: af(t, a, A),
    slidesInView: ht,
    slideIndexes: Fe,
    slideRegistry: vt,
    slidesToScroll: X,
    target: ut,
    translate: qo(O, t)
  };
  return N;
}
function cf() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function o(h) {
    return r(h).forEach((v) => v(t, h)), l;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), l;
  }
  function a(h, v) {
    return e[h] = r(h).filter((u) => u !== v), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: a,
    on: i,
    clear: s
  };
  return l;
}
const uf = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function df(e) {
  function t(i, a) {
    return Ho(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, s = fa(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, h) => t(l, h), {});
    return t(i, s);
  }
  function r(i) {
    return i.map((a) => fa(a.breakpoints || {})).reduce((a, s) => a.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function ff(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(i, e)), a.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function ja(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, i = df(o), a = ff(i), s = ha(), l = cf(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: u
  } = i, {
    on: f,
    off: m,
    emit: c
  } = l, p = O;
  let x = !1, g, b = h(uf, ja.globalOptions), C = h(b), A = [], I, L, E;
  function F() {
    const {
      container: Fe,
      slides: de
    } = C;
    L = (Jr(Fe) ? e.querySelector(Fe) : Fe) || e.children[0];
    const qe = Jr(de) ? L.querySelectorAll(de) : de;
    E = [].slice.call(qe || L.children);
  }
  function U(Fe) {
    const de = sf(e, L, E, r, o, Fe, l);
    if (Fe.loop && !de.slideLooper.canLoop()) {
      const Ne = Object.assign({}, Fe, {
        loop: !1
      });
      return U(Ne);
    }
    return de;
  }
  function K(Fe, de) {
    x || (b = h(b, Fe), C = v(b), A = de || A, F(), g = U(C), u([b, ...A.map(({
      options: Ne
    }) => Ne)]).forEach((Ne) => s.add(Ne, "change", O)), C.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(We), g.eventHandler.init(We), g.resizeHandler.init(We), g.slidesHandler.init(We), g.options.loop && g.slideLooper.loop(), L.offsetParent && E.length && g.dragHandler.init(We), I = a.init(We, A)));
  }
  function O(Fe, de) {
    const Ne = X();
    V(), K(h({
      startIndex: Ne
    }, Fe), de), l.emit("reInit");
  }
  function V() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), s.clear();
  }
  function B() {
    x || (x = !0, s.clear(), V(), l.emit("destroy"), l.clear());
  }
  function _(Fe, de, Ne) {
    !C.active || x || (g.scrollBody.useBaseFriction().useDuration(de === !0 ? 0 : C.duration), g.scrollTo.index(Fe, Ne || 0));
  }
  function T(Fe) {
    const de = g.index.add(1).get();
    _(de, Fe, -1);
  }
  function R(Fe) {
    const de = g.index.add(-1).get();
    _(de, Fe, 1);
  }
  function H() {
    return g.index.add(1).get() !== X();
  }
  function q() {
    return g.index.add(-1).get() !== X();
  }
  function G() {
    return g.scrollSnapList;
  }
  function ie() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function X() {
    return g.index.get();
  }
  function oe() {
    return g.indexPrevious.get();
  }
  function ue() {
    return g.slidesInView.get();
  }
  function he() {
    return g.slidesInView.get(!1);
  }
  function be() {
    return I;
  }
  function fe() {
    return g;
  }
  function we() {
    return e;
  }
  function Ae() {
    return L;
  }
  function Oe() {
    return E;
  }
  const We = {
    canScrollNext: H,
    canScrollPrev: q,
    containerNode: Ae,
    internalEngine: fe,
    destroy: B,
    off: m,
    on: f,
    emit: c,
    plugins: be,
    previousScrollSnap: oe,
    reInit: p,
    rootNode: we,
    scrollNext: T,
    scrollPrev: R,
    scrollProgress: ie,
    scrollSnapList: G,
    scrollTo: _,
    selectedScrollSnap: X,
    slideNodes: Oe,
    slidesInView: ue,
    slidesNotInView: he
  };
  return K(t, n), setTimeout(() => l.emit("init"), 0), We;
}
ja.globalOptions = void 0;
function rr(e = {}, t = []) {
  const n = Ui(e), r = Ui(t);
  let o = n ? e.value : e, i = r ? t.value : t;
  const a = _n(), s = _n();
  function l() {
    s.value && s.value.reInit(o, i);
  }
  return St(() => {
    !Od() || !a.value || (ja.globalOptions = rr.globalOptions, s.value = ja(a.value, o, i));
  }), si(() => {
    s.value && s.value.destroy();
  }), n && He(e, (h) => {
    mi(o, h) || (o = h, l());
  }), r && He(t, (h) => {
    Md(i, h) || (i = h, l());
  }), [a, s];
}
rr.globalOptions = void 0;
const U1 = ["default", "highlight"], q1 = ["click", "keyboard"], ei = /* @__PURE__ */ Symbol();
var Ra = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Ra || {});
const hf = ["tabindex"], vf = {
  key: 0,
  class: "lc-carousel__arrows"
}, mf = ["aria-controls", "aria-current", "aria-label", "onClick"], gf = { class: "lc-carousel__dot-indicator" }, bf = ["aria-label", "aria-pressed"], vl = 1.08, pf = /* @__PURE__ */ Se({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    arrows: { type: Boolean },
    autoPlay: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    fade: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    pagination: { type: Boolean },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = W(() => e.slides.length > 1), i = W(() => !e.disableSwipe && o.value), a = {
      align: "start",
      containScroll: "trimSnaps"
    }, s = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, l = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: i.value,
      watchResize: ({ containerNode: M, emit: re, reInit: D }, Q) => {
        if (!e.adaptiveHeight) return !0;
        for (const y of Q) {
          if (M() === y.target) return !0;
          requestAnimationFrame(() => {
            D(), re("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? s : a
    }, h = Ze.lcCarousel.autoPlayDelayInSeconds * 1e3, v = (M = e.fade) => [
      ...e.adaptiveHeight ? [zo()] : [],
      ...M ? [Vo()] : [],
      nr({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [u, f] = rr(
      {
        ...l,
        startIndex: e.defaultIndex
      },
      v()
    ), m = $n(ei, () => null, !0), c = wo(), p = pe(0), x = pe(0), g = pe(!i.value), b = pe(!1), C = pe(!1), A = pe(!1), I = pe(!1), L = pe(!1), E = pe(), F = pe(e.defaultIndex), U = pe(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((M, re) => re)
      )
    );
    let K = h, O, V, B, _, T, R;
    const H = W(() => Ze.lcCarousel), q = W(
      () => !!e.autoPlay && o.value && !I.value && !A.value && !b.value
    ), G = W(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--arrows": !!e.arrows && o.value,
        "lc-carousel--auto-play": !!e.autoPlay && o.value,
        "lc-carousel--auto-play-paused": !!e.autoPlay && !q.value,
        "lc-carousel--draggable": !g.value,
        "lc-carousel--fade": e.fade,
        "lc-carousel--keyboard-enabled": ze("keyboard"),
        "lc-carousel--swipe-hint": L.value
      }
    ]), ie = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !1
      }), g.value = !0);
    }, X = () => {
      i.value && (f.value?.reInit({
        ...l,
        watchDrag: !0
      }), g.value = !1);
    }, oe = (M, re) => e.keyExtractor ? e.keyExtractor(M, re) : e.keyProp && zu(e.keyProp, M) ? String(M[e.keyProp]) : String(re), ue = (M) => {
      const re = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return Ke(M) ? re : {
        ...re,
        "aria-hidden": "true",
        inert: "true"
      };
    }, he = ({ clientX: M }) => {
      if (!f.value || !ze("click") || g.value) return;
      const D = f.value.slideNodes().map((Q) => Q.getBoundingClientRect());
      for (const [Q, { left: y, right: ce }] of D.entries())
        if (!(M < y || M > ce)) {
          vt(Q);
          break;
        }
    }, be = () => {
      C.value = !0, w(), J(), je(), r("ready");
    }, fe = (M) => {
      if (!(!tn(M.key, Ra) || !ze("keyboard") || g.value))
        switch (M.preventDefault(), M.stopPropagation(), M.key) {
          case Ra.ArrowLeft:
            N();
            break;
          case Ra.ArrowRight:
            et();
            break;
        }
    }, we = () => {
      m?.disable(), Ne();
    }, Ae = () => {
      m?.enable(), je();
    }, Oe = () => {
      w(), J();
    }, We = () => {
      const M = f.value?.selectedScrollSnap() ?? 0;
      F.value = M, r("changed", M);
    }, Fe = () => {
      clearTimeout(V), V = void 0, O = void 0;
    }, de = () => {
      clearTimeout(V), O = Date.now(), V = setTimeout(() => Xe(1), K);
    }, Ne = () => {
      !V || O === void 0 || (K = Math.max(0, K - (Date.now() - O)), Fe());
    }, qe = () => {
      !q.value || V || de();
    }, je = () => {
      if (K = h, p.value += 1, !q.value) {
        Fe();
        return;
      }
      de();
    }, Xe = (M) => {
      const re = M > 0;
      if (!(re ? f.value?.canScrollNext() : f.value?.canScrollPrev())) {
        Ve((F.value + M + e.slides.length) % e.slides.length);
        return;
      }
      re ? et() : N(), je();
    }, Ve = (M) => {
      f.value?.scrollTo(M, Qe(!0)), je();
    }, Pe = (M) => H.value.slideAriaLabel.replace("{slide}", String(M + 1)), it = () => {
      if (q.value) {
        I.value = !0;
        return;
      }
      I.value = !1, A.value = !1;
    }, ut = () => {
      b.value = document.visibilityState === "hidden", ht();
    }, ge = [
      ["focusin", () => A.value = !0],
      ["focusout", () => A.value = !1],
      ["mouseenter", () => A.value = !0],
      ["mouseleave", () => A.value = !1]
    ], Be = () => {
      clearTimeout(T), T = setTimeout(() => f.value?.reInit(), 50);
    }, ze = (M) => e.moveTriggers.includes(M), Ke = (M) => U.value.has(M), Qe = (M) => !M || c.value === "reduce", ht = () => {
      const M = E.value?.querySelector(".lc-carousel__dot-progress")?.getAnimations?.().at(0);
      if (M) {
        if (q.value) {
          M.play();
          return;
        }
        M.pause();
      }
    }, vt = (M, re = !0) => {
      f.value?.scrollTo(M, Qe(re));
    }, et = (M = !0) => {
      f.value?.scrollNext(Qe(M));
    }, N = (M = !0) => {
      f.value?.scrollPrev(Qe(M));
    }, S = async () => {
      L.value || (L.value = !0, await new Promise((M) => {
        R = setTimeout(() => {
          L.value = !1, M();
        }, 1800);
      }));
    }, w = () => {
      if (!f.value || e.variant !== "highlight") return;
      const { rootNode: M, slideNodes: re } = f.value, D = re(), y = M().getBoundingClientRect(), ce = y.left + y.width / 2;
      let Te = D[0], d = 1 / 0;
      D.forEach((P) => {
        const ee = P.getBoundingClientRect(), $e = ee.left + ee.width / 2, ke = Math.abs($e - ce);
        ke < d && (Te = P, d = ke);
      });
      const k = Te.offsetWidth * (vl - 1) / 2;
      D.forEach((P, ee) => {
        if (P === Te) {
          x.value = ee, P.style.transform = `scale(${vl.toString()}) translateX(0px)`, P.style.zIndex = "1";
          return;
        }
        const $e = P.getBoundingClientRect(), Le = $e.left + $e.width / 2 < ce ? -1 : 1;
        P.style.transform = `scale(1) translateX(${(Le * k).toString()}px)`, P.style.zIndex = "0";
      });
    }, J = () => {
      if (!f.value) return;
      const M = f.value.slidesInView();
      if (!M.length) return;
      const re = e.slides.length, D = /* @__PURE__ */ new Set();
      M.forEach((Q) => {
        for (let y = -e.visibleSlideBuffer; y <= e.visibleSlideBuffer; y++) {
          const ce = (Q + y + re) % re;
          D.add(ce);
        }
      }), U.value = D;
    };
    return St(() => {
      document.addEventListener("visibilitychange", ut), f.value && (f.value.on("init", be).on("pointerDown", we).on("pointerUp", Ae).on("reInit", Oe).on("resize", J).on("scroll", w).on("select", We).on("slidesChanged", w).on("slidesInView", J), _ = f.value.rootNode(), ge.forEach(
        ([M, re]) => _?.addEventListener(M, re)
      ), e.adaptiveHeight && (B = new ResizeObserver(Be), f.value.slideNodes().forEach((M) => B?.observe(M))));
    }), In(() => {
      document.removeEventListener("visibilitychange", ut), ge.forEach(
        ([M, re]) => _?.removeEventListener(M, re)
      ), Fe(), clearTimeout(R), clearTimeout(T), B?.disconnect();
    }), He(
      [i, () => e.fade, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([M, re, D, Q, y]) => {
        g.value = !M, f.value?.reInit(
          {
            ...l,
            loop: D,
            skipSnaps: Q,
            watchDrag: M,
            ...y === "highlight" ? s : a
          },
          v(re)
        );
      }
    ), He(q, (M) => M ? qe() : Ne()), t({
      disable: ie,
      enable: X,
      moveToIndex: vt,
      next: et,
      prev: N,
      showSwipeHint: S
    }), Ja(ei, {
      disable: ie,
      enable: X
    }), (M, re) => ($(), j("div", {
      class: ye(G.value),
      style: Et(
        e.autoPlay ? { "--lc-carousel-auto-play-delay": `${h}ms` } : void 0
      ),
      tabindex: ze("keyboard") ? 0 : void 0,
      onClickPassive: he,
      onKeydown: fe
    }, [
      ne("div", {
        ref_key: "emblaRef",
        ref: u,
        class: "lc-carousel__container"
      }, [
        ne("div", Ce({ id: e.id }, { class: "lc-carousel__wrap" }), [
          ($(!0), j(rt, null, yt(e.slides, (D, Q) => ve(M.$slots, "slide", Ce({ ref_for: !0 }, { slide: D, index: Q }, {
            key: oe(D, Q),
            attributes: ue(Q),
            isHighlighted: x.value === Q,
            isVisible: Ke(Q)
          }))), 128))
        ], 16),
        e.arrows && o.value ? ($(), j("nav", vf, [
          Re(Z(Tt), {
            "aria-controls": e.id,
            "aria-label": H.value.prevSlideAriaLabel,
            icon: "chevron-left",
            size: "small",
            variant: "filled",
            onClick: re[0] || (re[0] = (D) => Xe(-1))
          }, null, 8, ["aria-controls", "aria-label"]),
          Re(Z(Tt), {
            "aria-controls": e.id,
            "aria-label": H.value.nextSlideAriaLabel,
            icon: "chevron-right",
            size: "small",
            variant: "filled",
            onClick: re[1] || (re[1] = (D) => Xe(1))
          }, null, 8, ["aria-controls", "aria-label"])
        ])) : se("", !0)
      ], 512),
      e.pagination && o.value ? ($(), j("div", {
        key: 0,
        ref_key: "paginationElement",
        ref: E,
        class: "lc-carousel__pagination"
      }, [
        ($(!0), j(rt, null, yt(e.slides, (D, Q) => ($(), j("button", {
          key: oe(D, Q),
          "aria-controls": e.id,
          "aria-current": F.value === Q ? "true" : void 0,
          "aria-label": Pe(Q),
          class: ye(["lc-carousel__dot", { "lc-carousel__dot--active": F.value === Q }]),
          type: "button",
          onClick: (y) => Ve(Q)
        }, [
          ne("span", gf, [
            e.autoPlay && F.value === Q ? ($(), j("span", {
              key: p.value,
              class: "lc-carousel__dot-progress"
            })) : se("", !0)
          ])
        ], 10, mf))), 128)),
        e.autoPlay ? ($(), j("button", {
          key: 0,
          "aria-label": q.value ? H.value.pauseAriaLabel : H.value.playAriaLabel,
          "aria-pressed": q.value ? "false" : "true",
          class: "lc-carousel__auto-play-toggle",
          type: "button",
          onClick: it
        }, [
          Re(Z(Je), {
            name: q.value ? "pause" : "play-filled",
            size: "small"
          }, null, 8, ["name"])
        ], 8, bf)) : se("", !0)
      ], 512)) : se("", !0)
    ], 46, hf));
  }
}), yf = ["for"], wf = { class: "lc-checkbox__control" }, xf = ["id", "data-click-name"], kf = ["id"], j1 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), { vibrate: o } = xo(), i = W(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = W({
      get: () => e.value,
      set: (s) => {
        n("update:value", s), o();
      }
    });
    return (s, l) => ($(), j("div", {
      class: ye([i.value, s.$attrs.class])
    }, [
      ne("label", {
        class: "lc-checkbox__wrap",
        for: Z(r)
      }, [
        ne("div", wf, [
          Qt(ne("input", Ce({ id: Z(r) }, {
            ...en(s.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: l[1] || (l[1] = ci((h) => a.value = !a.value, ["enter"]))
          }), null, 16, xf), [
            [ho, a.value]
          ]),
          Re(Z(Je), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(r)}-label`,
          class: "lc-checkbox__label"
        }, Ie(e.label), 9, kf)) : se("", !0)
      ], 8, yf),
      e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), jo = () => typeof window > "u";
function Sf(e, t) {
  const n = ya(), r = typeof e == "string" ? e : void 0, o = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, o) : n.useState(o);
  const i = o ? at(o()) : void 0;
  return pe(i);
}
const yi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, Zo = (e, t) => gu({
  end: new Date(t),
  start: new Date(e)
}), Wo = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...yi[t],
  timeZone: r
}).format(new Date(e)), Cr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), _f = 2147483647, Cf = /* @__PURE__ */ Se({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, o = jo(), i = Sf(() => /* @__PURE__ */ new Date()), a = pe(!1);
    let s, l;
    const h = W(() => {
      if (a.value) return n;
      const { hours: A, minutes: I, seconds: L } = Zo(i.value, m.value);
      return {
        ...n,
        hours: A || 0,
        minutes: I || 0,
        seconds: L || 0
      };
    }), v = W(() => u.value ? m.value.toISOString() : void 0), u = W(() => qa(m.value)), f = W(() => {
      const { hours: A, minutes: I, seconds: L } = h.value, E = `${Cr(I)}:${Cr(L)}`;
      return e.variant === "without-hours" ? E : `${Cr(A)}:${E}`;
    }), m = W(() => new Date(e.expiresAt)), c = () => {
      clearInterval(s), clearTimeout(l);
    }, p = () => {
      a.value || (a.value = !0, r("expired"), c());
    }, x = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, g = () => bu(m.value), b = () => {
      if (!u.value) return;
      const A = m.value.getTime() - Date.now();
      A > _f || (l = setTimeout(p, Math.max(0, A)));
    }, C = () => {
      c(), b(), s = setInterval(() => {
        g() ? p() : x();
      }, 1e3);
    };
    return si(() => {
      c();
    }), He(
      v,
      () => {
        o || (a.value = !1, C());
      },
      {
        immediate: !0
      }
    ), (A, I) => u.value ? ($(), j("time", Ce({ key: 0 }, { datetime: v.value }, { class: "lc-countdown" }), Ie(f.value), 17)) : se("", !0);
  }
}), Z1 = ["default", "without-hours"], Ef = { class: "lc-data-list" }, W1 = /* @__PURE__ */ Se({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => ($(), j("ul", Ef, [
      ve(t.$slots, "default")
    ]));
  }
}), Tf = { class: "lc-data-list-item" }, Af = { class: "lc-data-list-item__content" }, Lf = {
  key: 0,
  class: "lc-data-list-item__headline"
}, $f = {
  key: 0,
  class: "lc-data-list-item__text"
}, If = { key: 0 }, Df = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, X1 = /* @__PURE__ */ Se({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => ($(), j("li", Tf, [
      ne("div", Af, [
        ne("section", null, [
          e.headline ? ($(), j("span", Lf, Ie(e.headline), 1)) : se("", !0),
          ve(t.$slots, "default", {}, () => [
            e.text ? ($(), j("p", $f, Ie(e.text), 1)) : se("", !0)
          ])
        ]),
        t.$slots.suffix ? ($(), j("aside", If, [
          ve(t.$slots, "suffix")
        ])) : se("", !0)
      ]),
      t.$slots.underneath ? ($(), j("div", Df, [
        ve(t.$slots, "underneath")
      ])) : se("", !0)
    ]));
  }
});
var Of = Object.defineProperty, Mf = (e, t, n) => t in e ? Of(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, sa = (e, t, n) => Mf(e, typeof t != "symbol" ? t + "" : t, n);
const ml = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, gl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), bl = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, Rf = (e, t = !0, n) => {
  var r, o, i, a;
  const s = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((o = n.number) == null ? void 0 : o.fraction) ?? 0;
  let h = bl(0, l, n);
  const v = h.formatToParts(1000.12), u = ((i = v.find((x) => x.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((x) => x.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = gl(e, u, f);
  if (Number.isNaN(parseFloat(m))) return s;
  const c = m.split(".");
  if (c[1] != null && c[1].length >= 1) {
    const x = c[1].length <= l ? c[1].length : l;
    h = bl(x, l, n);
  }
  let p = h.format(parseFloat(m));
  return t ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (p += f) : p = gl(p, u, f), s + p;
}, Xo = (e) => JSON.parse(e.replaceAll("'", '"')), Nf = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = Ff(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = Ia(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = Ia(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = Ia(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = Pf(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = Ia(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, Ia = (e) => e !== "" ? !!JSON.parse(e) : !0, Ff = (e) => e.startsWith("[") && e.endsWith("]") ? Xo(e) : e, Pf = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Xo(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: Yo() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Yo = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class Bf {
  constructor(t = {}) {
    sa(this, "opts", {}), sa(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...ml, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = Yo() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = ml;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, o) => r.length - o.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((o) => this.process(t, o, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((o, i) => {
      o === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(o);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return Rf(t, r, this.opts);
    if (n == null) return t;
    const o = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(o)) return this.memo.get(o);
    const { mask: i, escaped: a } = this.escapeMask(n), s = [], l = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => x > -1 && g > -1 : () => x < i.length && g < t.length, m = (C) => !this.isReversed() && C <= u || this.isReversed() && C >= u;
    let c, p = -1, x = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const C = i.charAt(x), A = l[C], I = A?.transform != null ? A.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(x) && A != null ? (I.match(A.pattern) != null ? (s[v](I), A.repeated ? (p === -1 ? p = x : x === u && x !== p && (x = p - h), u === p && (x -= h)) : A.multiple && (b = !0, x -= h), x += h) : A.multiple ? b && (x += h, g -= h, b = !1) : I === c ? c = void 0 : A.optional && (x += h, g -= h), g += h) : (r && !this.isEager() && s[v](C), I === C && !this.isEager() ? g += h : c = C, this.isEager() || (x += h)), this.isEager())
        for (; m(x) && (l[i.charAt(x)] == null || a.includes(x)); ) {
          if (r) {
            if (s[v](i.charAt(x)), t.charAt(g) === i.charAt(x)) {
              x += h, g += h;
              continue;
            }
          } else i.charAt(x) === t.charAt(g) && (g += h);
          x += h;
        }
    }
    return this.memo.set(o, s.join("")), this.memo.get(o);
  }
}
const Go = ["text", "search", "url", "tel", "password"];
let zf = class {
  constructor(t, n = {}) {
    sa(this, "items", /* @__PURE__ */ new Map()), sa(this, "eventAbortController"), sa(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const o = r.target, i = this.items.get(o);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), s = i.isEager(), l = a && s && i.unmasked(o.value) === "" ? "" : o.value;
      this.fixCursor(o, a, () => this.setValue(o, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!Go.includes(r.type)) return;
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const o = new Bf(Nf(r, n));
      this.items.set(r, o), queueMicrotask(() => this.updateValue(r));
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: o, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var o, i, a;
    const s = t.selectionStart, l = t.value;
    if (r(), s === null || s === l.length && !n) return;
    const h = t.value, v = l.slice(0, s), u = h.slice(0, s), f = (o = this.processInput(t, v)) == null ? void 0 : o.unmasked, m = (i = this.processInput(t, u)) == null ? void 0 : i.unmasked;
    if (f === void 0 || m === void 0) return;
    let c = s;
    if (v !== u)
      if (n)
        c += h.length - l.length;
      else if (f.length === 0)
        c = 0;
      else {
        c = h.length;
        for (let p = 1; p <= h.length; p++)
          if ((((a = this.processInput(t, h.slice(0, p))) == null ? void 0 : a.unmasked) ?? "").length >= f.length) {
            c = p;
            break;
          }
      }
    t.setSelectionRange(c, c);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((o) => o(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let o = n ?? t.value;
    this.options.preProcess != null && (o = this.options.preProcess(o));
    let i = r.masked(o);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(o),
      completed: r.completed(o)
    };
  }
};
const Er = /* @__PURE__ */ new WeakMap(), Vf = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, Hf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || !Go.includes(r.type)) return;
  let o = {};
  if (t.value != null && (o = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const s = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      Vf(t, s);
    };
    o.onMaska = o.onMaska == null ? i : Array.isArray(o.onMaska) ? [...o.onMaska, i] : [o.onMaska, i];
  }
  Er.has(r) ? (n = Er.get(r)) == null || n.update(o) : Er.set(r, new zf(r, o));
}, Uf = ["for"], qf = ["id"], jf = { class: "lc-input__input-wrap" }, Zf = ["data-testid"], Wf = ["data-testid"], ir = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, o = n, i = nt("input"), a = $t(e.id), s = pe(!1), l = W(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = W(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => s.value = !0,
      onFocusout: () => s.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = W(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": s.value || !!e.value || typeof e.value == "number"
      }
    ]), u = W(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = W({
      get: () => e.value,
      set: (c) => {
        o("update:value", c);
      }
    }), m = (c) => c.mask !== void 0;
    return St(() => {
      e.autofocus && i.value?.focus(), e.value && o("update:value", e.value);
    }), t({ ref: i }), (c, p) => ($(), j("div", {
      class: ye([l.value, c.$attrs.class])
    }, [
      ne("label", {
        class: "lc-input__wrap",
        for: Z(a)
      }, [
        e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(a)}-label`,
          class: ye(v.value)
        }, Ie(e.label), 11, qf)) : se("", !0),
        ne("div", jf, [
          c.$slots.prefix ? ($(), j("div", {
            key: 0,
            class: ye(["lc-input__prefix", e.prefixClass])
          }, [
            ve(c.$slots, "prefix")
          ], 2)) : se("", !0),
          e.mask ? Qt(($(), j("input", Ce({
            key: 1,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[0] || (p[0] = (x) => f.value = x),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, Zf)), [
            [qi, f.value],
            [Z(Hf), u.value]
          ]) : Qt(($(), j("input", Ce({
            key: 2,
            ref: "input"
          }, {
            ...en(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[1] || (p[1] = (x) => f.value = x),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, Wf)), [
            [qi, f.value]
          ]),
          c.$slots.suffix ? ($(), j("div", {
            key: 3,
            class: ye(["lc-input__suffix", e.suffixClass])
          }, [
            ve(c.$slots, "suffix")
          ], 2)) : se("", !0)
        ])
      ], 8, Uf),
      e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), G1 = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], K1 = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], J1 = /* @__PURE__ */ Se({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ba(e, ["mask", "placeholder"]);
    return (n, r) => ($(), xe(Z(ir), Ce({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), Xf = { class: "lc-description-list" }, Q1 = /* @__PURE__ */ Se({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => ($(), j("dl", Xf, [
      ve(t.$slots, "default")
    ]));
  }
}), Ko = /* @__PURE__ */ Symbol();
var ln = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(ln || {});
const e2 = /* @__PURE__ */ Se({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = ba(e, ["index"]), i = nt("input"), a = $n(Ko, () => null, !0), s = W(() => at(a?.config)), l = W(() => o.disabled || !!at(a?.disabled)), h = W(() => l.value ? "*" : "#"), v = W({
      get: () => l.value ? "X" : f.value,
      set: (c) => {
        if (l.value || c === "X") return;
        const p = typeof c == "number" ? c : null;
        r("update:value", p), a?.updateValue(e.index, p);
      }
    }), u = W(() => a ? `${at(a.name)}_input_${e.index}` : o.name), f = W(() => a ? at(a.value)?.[e.index] : o.value), m = (c) => {
      if (tn(c.key, ln))
        switch (c.key !== ln.Dead && c.preventDefault(), c.key) {
          case ln.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case ln.ArrowRight:
            a?.focusNext(e.index);
            break;
          case ln.Backspace:
          case ln.Delete:
            v.value = null;
            break;
          case ln.Dead: {
            const p = c.target;
            p?.blur(), setTimeout(() => p?.focus(), 1);
            break;
          }
          default: {
            const p = parseInt(c.key);
            v.value = p, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: l,
      index: e.index,
      inputRef: i
    }), (c, p) => ($(), xe(Z(ir), Ce({ ref: "input" }, { ...c.$attrs, ...o, ...s.value, disabled: l.value, mask: h.value, name: u.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: l.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), Yf = ["id"], Gf = ["id"], Kf = ["aria-labelledby"], t2 = /* @__PURE__ */ Se({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = pe([]), i = $t(e.id), a = (f, m) => {
      const c = [...e.value ?? []];
      c[f] = m, r("update:value", c);
    }, s = () => {
      const f = o.value.findIndex((m) => !m.disabled);
      o.value[f]?.inputRef?.ref?.focus();
    }, l = (f) => {
      if (f < 0 || f >= o.value.length) return;
      const m = o.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const p = o.value.slice(0, f).reverse().find(({ disabled: x }) => !x)?.index;
      typeof p == "number" && (l(p), a(p, null));
    }, v = (f, m = !0) => {
      const c = m ? f + 1 : f - 1;
      if (c < 0 || c >= o.value.length) return;
      const p = o.value[c];
      if (p.disabled) {
        v(c, m);
        return;
      }
      p.inputRef?.ref?.focus();
    }, u = (f) => {
      const m = f;
      m?.inputRef?.ref && (o.value[m.index] = m);
    };
    return St(s), t({ focusFirstEnabledInput: s, focusInputByIndex: l }), Ja(Ko, {
      config: vo(
        W(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => ($(), j("fieldset", Ce(f.$attrs, {
      id: Z(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? ($(), j("legend", {
        key: 0,
        id: `${Z(i)}-label`,
        class: ye(["lc-digit-input-group__label", e.legendClass])
      }, [
        ve(f.$slots, "legend")
      ], 10, Gf)) : se("", !0),
      ne("div", {
        "aria-labelledby": f.$slots.legend ? `${Z(i)}-label` : void 0,
        class: ye(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        ve(f.$slots, "default", Ot(Pt({ setRef: u })))
      ], 10, Kf),
      e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, Yf));
  }
}), Jf = ["id"], Qf = ["aria-expanded"], e0 = ["aria-expanded"], t0 = /* @__PURE__ */ Se({
  __name: "LcExpandable",
  props: /* @__PURE__ */ Cn({
    actionClass: {},
    animated: { type: Boolean },
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    hideIcon: { type: Boolean },
    headerTag: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Cn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = cn(), n = $t(e.id), r = `${n}-region`, o = Ya(e, "modelValue"), i = W(() => [
      "lc-expandable",
      {
        "lc-expandable--animated": e.animated,
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": o.value,
        "lc-expandable--with-action": !!t.action
      }
    ]), a = W(() => ["lc-expandable__action", e.actionClass]), s = W(() => ["lc-expandable__content", e.contentClass]), l = () => {
      o.value = !o.value;
    };
    return (h, v) => ($(), j("article", Ce(h.$attrs, {
      id: Z(n),
      class: i.value
    }), [
      e.headerTag ? ($(), xe(Nt(e.headerTag), {
        key: 0,
        class: "lc-expandable__heading"
      }, {
        default: _e(() => [
          ne("button", Ce({ "aria-controls": r }, { disabled: e.disabled }, {
            "aria-expanded": o.value,
            class: ["lc-expandable__header", e.headerClass],
            type: "button",
            onClickPassive: l
          }), [
            ve(h.$slots, "header"),
            e.disabled ? se("", !0) : ($(), xe(Z(Je), {
              key: 0,
              class: "lc-expandable__header-icon",
              name: "chevron-down"
            }))
          ], 16, Qf)
        ]),
        _: 3
      })) : ($(), j("button", Ce({
        key: 1,
        "aria-controls": r
      }, { disabled: e.disabled }, {
        "aria-expanded": o.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: l
      }), [
        ve(h.$slots, "header"),
        !e.disabled && !e.hideIcon ? ($(), xe(Z(Je), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        })) : se("", !0)
      ], 16, e0)),
      t.action ? ($(), j("div", {
        key: 2,
        class: ye(a.value)
      }, [
        ve(h.$slots, "action")
      ], 2)) : se("", !0),
      e.animated ? ($(), xe(Z(No), {
        key: 3,
        animated: "",
        class: "lc-expandable__collapse",
        when: o.value,
        onCollapse: v[0] || (v[0] = (u) => h.$emit("collapse")),
        onCollapsed: v[1] || (v[1] = (u) => h.$emit("collapsed")),
        onExpand: v[2] || (v[2] = (u) => h.$emit("expand")),
        onExpanded: v[3] || (v[3] = (u) => h.$emit("expanded"))
      }, {
        default: _e(() => [
          ne("section", {
            id: r,
            class: ye(s.value),
            role: "region"
          }, [
            ve(h.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["when"])) : Qt(($(), j("section", {
        key: 4,
        id: r,
        class: ye(s.value),
        role: "region"
      }, [
        ve(h.$slots, "default")
      ], 2)), [
        [ui, o.value]
      ])
    ], 16, Jf));
  }
}), n0 = { class: "lc-expandable-list" }, n2 = /* @__PURE__ */ Se({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => ($(), j("div", n0, [
      ve(t.$slots, "default")
    ]));
  }
}), a0 = () => {
  const e = pe(!1);
  return St(() => {
    e.value = !0;
  }), In(() => {
    e.value = !1;
  }), e;
}, r0 = {
  key: 0,
  class: "lc-fly-out__illustration"
}, i0 = { class: "lc-fly-out__message" }, a2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => Ze.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => Ze.lcFlyOut.to },
    visibleInSeconds: { default: () => Ze.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = a0(), o = W(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = na(
      () => {
        n("update:isVisible", !1);
      },
      o,
      { immediate: !1 }
    );
    return In(a), He(
      () => e.isVisible,
      (s) => {
        s ? i() : a();
      },
      { immediate: !0 }
    ), (s, l) => Z(r) ? ($(), xe(pa, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Re(Z(ua), { name: "slide-down-lg" }, {
        default: _e(() => [
          e.isVisible ? ($(), j("div", Ce({ key: 0 }, s.$attrs, { class: "lc-fly-out__container" }), [
            Re(Z(Bu), {
              class: "lc-fly-out__timer",
              "duration-in-ms": o.value
            }, {
              default: _e(() => [
                Re(Z(Tt), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: l[0] || (l[0] = (h) => s.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            s.$slots.default ? ($(), j("div", r0, [
              ve(s.$slots, "default")
            ])) : se("", !0),
            ne("p", i0, Ie(e.message), 1)
          ], 16)) : se("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : se("", !0);
  }
});
const va = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function pl(e) {
  return Number(e) >= 0;
}
function l0(e) {
  return typeof e == "object" && e !== null;
}
function o0(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function yl(e) {
  if (!l0(e) || o0(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Jo(e, t) {
  return Object.keys(t).forEach((n) => {
    if (yl(t[n]) && yl(e[n])) {
      e[n] || (e[n] = {}), Jo(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function s0(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var o;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((o = a.inner) === null || o === void 0) && o.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const s = a.inner.reduce((l, h) => {
          const v = h.path || "";
          return l[v] || (l[v] = { errors: [], path: v }), l[v].errors.push(...h.errors), l;
        }, {});
        return { errors: Object.values(s) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return va(i) && va(r) ? Jo(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return wl(e.spec);
        const o = c0(r, e);
        return o ? wl(o) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function wl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function c0(e, t) {
  if (!xl(t))
    return null;
  if (vc(e)) {
    const o = t.fields[mc(e)];
    return o?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let o = 0; o < n.length; o++) {
    const i = n[o];
    if (xl(r) && i in r.fields ? r = r.fields[i] : u0(r) && pl(i) ? r = r.spec.types[Number(i)] : pl(i) && d0(r) && (r = r.innerType), o === n.length - 1)
      return r.spec;
  }
  return null;
}
function u0(e) {
  return va(e) && e.type === "tuple";
}
function xl(e) {
  return va(e) && e.type === "object";
}
function d0(e) {
  return va(e) && e.type === "array";
}
const r2 = /* @__PURE__ */ Se({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, {
      isFieldValid: r,
      isSubmitting: o,
      meta: i,
      resetField: a,
      resetForm: s,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    } = gc({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? s0(n.validationSchema) : void 0
    }), f = async (m) => {
      m.preventDefault();
      try {
        o.value = !0;
        const { valid: c, values: p } = await v();
        c && n.onSubmit && await n.onSubmit(p), c && n.resetOnSubmit && s();
      } finally {
        o.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: o,
      meta: i,
      resetField: a,
      resetForm: s,
      setErrors: l,
      setValues: h,
      validate: v,
      values: u
    }), (m, c) => ($(), j("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: f
    }, [
      ve(m.$slots, "default", Ot(Pt({ isSubmitting: Z(o), meta: Z(i), values: Z(u) })))
    ], 32));
  }
}), i2 = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Qo = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Qo || {});
const Bt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, f0 = { class: "lc-form-field" }, l2 = /* @__PURE__ */ Se({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Bt.Blur, Bt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Bt.Update] : [Bt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Bt.Update] : [Bt.Change],
      lazy: () => [Bt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: o,
      handleChange: i,
      meta: a,
      value: s
    } = bc(() => e.name, {}, { validateOnValueUpdate: !1 }), l = {
      [Bt.Blur]: (f) => u(f, !0),
      [Bt.Change]: (f) => i(f, !0),
      [Bt.Update]: (f) => i(f, !0)
    }, h = W(() => ({
      errorMessage: r.value,
      name: e.name,
      value: s.value,
      ...v.value
    })), v = W(() => {
      const f = {
        [Bt.Blur]: (m) => u(m, !1),
        [Bt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = l[m];
      }), f;
    }), u = async (f, m) => {
      if (o(f, m), await Ga(), !f) return;
      const c = new CustomEvent(Qo.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(c);
    };
    return t({ field: h }), (f, m) => ($(), j("div", f0, [
      ve(f.$slots, "default", Ot(Pt({ field: h.value })))
    ]));
  }
}), h0 = ["id"], v0 = { ref: "wrapper" }, m0 = { class: "lc-header__wrap" }, g0 = { class: "lc-header__left-button-wrap" }, b0 = { class: "lc-header__headline-wrap" }, p0 = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, y0 = ["id", "aria-labelledby"], w0 = { class: "lc-header__fly-out-content-container" }, o2 = /* @__PURE__ */ Se({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [Ze.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => Ze.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => Ze.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = nt("wrapper"), n = $t(e.id), r = pe(!1), o = W(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Qa(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...at(e.ignoreOutsideClickOn)] }
    ), (a, s) => ($(), j("header", {
      id: Z(n),
      class: ye(o.value)
    }, [
      ne("div", v0, [
        ne("div", m0, [
          ne("div", g0, [
            Re(Z(Tt), Ce({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: s[0] || (s[0] = (l) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ne("div", b0, [
            ne("h1", {
              class: ye(["lc-header__headline", e.headlineClass])
            }, [
              ve(a.$slots, "headline")
            ], 2)
          ]),
          ve(a.$slots, "right", {}, () => [
            e.withFlyOut ? ($(), j("div", p0, [
              Re(Z(Tt), {
                id: `${Z(n)}-toggle`,
                "aria-controls": `${Z(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: ye(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: _e(() => [
                  ve(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : se("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? ($(), j("div", {
          key: 0,
          id: `${Z(n)}-region`,
          "aria-labelledby": `${Z(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ne("div", w0, [
            ne("div", {
              class: ye(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              ve(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, y0)) : se("", !0)
      ], 512),
      ve(a.$slots, "default")
    ], 10, h0));
  }
}), x0 = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = W(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => ($(), j("div", {
      class: ye(t.value),
      style: Et({
        "--ball-opacity": e.opacity
      })
    }, Ie(e.content), 7));
  }
}), k0 = { class: "lc-high-frequency-ball-background" }, es = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", k0, [
      ($(!0), j(rt, null, yt(e.ballConfig, (r, o) => ($(), xe(x0, {
        key: o,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Et({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ne("div", {
        class: ye(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), S0 = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, _0 = { class: "lc-lottery-jackpot__value" }, C0 = { class: "lc-lottery-jackpot__currency" }, E0 = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, kl = 10 ** 9, Sl = 10 ** 6, T0 = "mil millones", A0 = "mil M", ts = /* @__PURE__ */ Se({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => Ze.general.currency },
    locale: { default: () => Ze.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = kl * 100, n = Sl * 100, r = W(() => {
      let a;
      const s = e.value >= t, l = e.value >= n;
      switch (!0) {
        case s:
          a = Math.floor(e.value / kl) / 100;
          break;
        case l:
          a = Math.floor(e.value / Sl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), u = v.replace(/0+$/, ""), f = l || s;
      let m = u;
      !f && u.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && u.length > 1 && (m = u.slice(0, 1));
      const c = m.length > 0 ? [h, m].join(".") : h, p = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: p,
        minimumFractionDigits: p
      }).format(Number(c));
    }), o = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = W(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === T0 ? A0 : a;
    });
    return (a, s) => ($(), j("div", {
      class: ye([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? ($(), j("span", S0, Ie(e.placeholder), 1)) : ($(), j(rt, { key: 1 }, [
        ne("span", _0, [
          ne("span", C0, Ie(o.value), 1),
          ne("span", null, Ie(r.value), 1)
        ]),
        i.value ? ($(), j("span", E0, Ie(i.value), 1)) : se("", !0)
      ], 64))
    ], 2));
  }
}), s2 = ["large", "medium", "small"], L0 = { class: "lc-info-button__modal" }, $0 = { class: "lc-info-button__modal-header" }, I0 = { class: "lc-info-button__modal-headline" }, D0 = { class: "lc-info-button__modal-text" }, ns = /* @__PURE__ */ Se({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => Ze.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => Ze.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = tr(), n = pe(!1), r = () => {
      n.value = !1;
    }, o = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => ($(), j("div", {
      class: ye(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Re(Z(Tt), Ce({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: o
      }), null, 16, ["aria-label"]),
      Z(t) && n.value ? ($(), xe(Z(Bo), Ce({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClose: r
      }), {
        default: _e(() => [
          ne("div", L0, [
            ne("header", $0, [
              ne("span", I0, Ie(e.headline), 1),
              Re(Z(Tt), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            ve(i.$slots, "default", {}, () => [
              ne("p", D0, Ie(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : se("", !0)
    ], 2));
  }
}), c2 = ["default", "prominent"], O0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", M0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", R0 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", N0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", F0 = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, P0 = ["src"], B0 = {
  key: 2,
  class: "lc-teaser-badge__text"
}, z0 = ["src"], V0 = 8, rn = 10, H0 = 20, U0 = /* @__PURE__ */ Se({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = W(() => o.value.length > 1), r = W(() => {
      switch (e.variant) {
        case "fire":
          return O0;
        case "pie":
          return R0;
        case "star":
          return N0;
        default:
          return null;
      }
    }), o = W(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, H0);
      if (i.length <= V0) return [i];
      const s = i.split(" ").filter(Boolean);
      if (s.length === 1)
        return [
          i.slice(0, rn),
          i.slice(rn)
        ];
      let l = "";
      const h = [];
      return s.forEach((v) => {
        if (l.length + v.length + (l.length ? 1 : 0) <= rn) {
          l.length > 0 && (l += " "), l += v;
          return;
        }
        if (v.length > rn) {
          if (l.length > 0) {
            let u = 0;
            l.length < rn && (l += " ", u = rn - l.length, l += v.slice(0, u)), h.push(l), h.push(v.slice(u)), l = "";
            return;
          }
          h.push(v.slice(0, rn)), l = v.slice(rn);
          return;
        }
        h.push(l), l = v;
      }), l.length > 0 && h.push(l), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => ($(), j("div", {
      class: ye(t.value)
    }, [
      e.variant === "price-tag" ? ($(), j("svg", F0, [...a[0] || (a[0] = [
        ne("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : se("", !0),
      r.value ? ($(), j("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, P0)) : se("", !0),
      e.variant !== "new" ? ($(), j("span", B0, Ie(o.value.join(`
`)), 1)) : ($(), j("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: Z(M0),
        width: "48"
      }, null, 8, z0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? ($(), xe(Z(ns), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${Z(Ze).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : se("", !0)
    ], 2));
  }
}), u2 = ["fire", "lightning", "money", "star"], d2 = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], f2 = ["bottom-m", "bottom-xl", "top-m", "top-xl"], as = ["badge", "default", "hero"];
var rs = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(rs || {});
const q0 = { class: "lc-teaser-hero-badge__text-wrap" }, j0 = /* @__PURE__ */ Se({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => rs.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => ($(), j("div", {
      class: ye(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Et({
        "--teaser-badge-color": e.color
      })
    }, [
      ne("div", q0, [
        ne("span", null, Ie(e.title), 1),
        ne("span", null, Ie(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? ($(), xe(Z(ns), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${Z(Ze).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : se("", !0)
    ], 6));
  }
}), Z0 = (e) => !!e.title && !!e.subtitle, W0 = { class: "lc-teaser__background" }, lr = /* @__PURE__ */ Se({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = cn(), n = W(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, o) => ($(), xe(Z(wa), Ce({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Ka({
      default: _e(() => [
        ve(r.$slots, "default"),
        e.badge ? ($(), j(rt, { key: 0 }, [
          Z(Z0)(e.badge) ? ($(), xe(j0, Ot(Ce({ key: 0 }, e.badge)), null, 16)) : ($(), xe(U0, Ot(Ce({ key: 1 }, e.badge)), null, 16))
        ], 64)) : se("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: _e(() => [
          ne("div", W0, [
            ve(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: _e(() => [
          ve(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: _e(() => [
          ve(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), X0 = { class: "lc-high-frequency-teaser__background" }, Y0 = { class: "lc-high-frequency-teaser__jackpot-section" }, G0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, K0 = { class: "lc-high-frequency-teaser__button-container" }, J0 = { class: "lc-high-frequency-teaser__button-wrap" }, Q0 = { class: "lc-high-frequency-teaser__hint-container" }, eh = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, h2 = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    cn();
    const t = W(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (r, o) => ($(), xe(Z(lr), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: _e(() => [
        ne("div", X0, [
          Re(Z(es), Ot(Pt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: _e(() => [
        ve(r.$slots, "lottery-logo")
      ]),
      default: _e(() => [
        ne("section", Y0, [
          ($(), xe(Nt(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: _e(() => [
              e.headline ? ($(), j("strong", G0, Ie(e.headline), 1)) : se("", !0),
              Re(Z(ts), Ce(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", K0, [
          ne("div", J0, [
            ve(r.$slots, "primary-button", {}, () => [
              Re(Z(Tt), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: o[0] || (o[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: _e(() => [
                  kt(Ie(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ne("section", Q0, [
          e.hint ? ($(), j("p", eh, [
            ve(r.$slots, "hint", {}, () => [
              kt(Ie(e.hint), 1)
            ])
          ])) : se("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), th = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, nh = ["stroke"], ah = ["stroke"], _l = "lc-high-frequency-teaser-watch-arrows-gradient-1", Cl = "lc-high-frequency-teaser-watch-arrows-gradient-2", rh = /* @__PURE__ */ Se({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => ($(), j("svg", th, [
      ne("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${_l})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, nh),
      n[2] || (n[2] = ne("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${Cl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, ah),
      n[3] || (n[3] = ne("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("defs", null, [
        ne("linearGradient", {
          id: _l,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        ne("linearGradient", {
          id: Cl,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ih = {}, lh = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function oh(e, t) {
  return $(), j("svg", lh, [...t[0] || (t[0] = [
    Gs('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const sh = /* @__PURE__ */ vi(ih, [["render", oh], ["__scopeId", "data-v-0c679bcf"]]), ch = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, uh = ["fill"], El = "lc-high-frequency-teaser-watch-play-button-gradient", dh = /* @__PURE__ */ Se({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => ($(), j("svg", ch, [
      n[1] || (n[1] = ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${El})`
      }, null, 8, uh),
      ne("defs", null, [
        ne("radialGradient", {
          id: El,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          ne("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ta = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, fh = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, hh = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, vh = { class: "lc-high-frequency-teaser-watch__game-badge" }, mh = { class: "lc-high-frequency-teaser-watch__game-label" }, gh = { class: "lc-high-frequency-teaser-watch__game-number" }, bh = { class: "lc-high-frequency-teaser-watch__game-icon" }, ph = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, yh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, wh = { class: "lc-high-frequency-teaser-watch__timer-value" }, xh = { class: "lc-high-frequency-teaser-watch__timer-unit" }, kh = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, Sh = { class: "lc-high-frequency-teaser-watch__main" }, _h = { class: "lc-high-frequency-teaser-watch__title" }, v2 = /* @__PURE__ */ Se({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = pe("idle"), n = pe(e.gameNumber), r = pe(!1), o = pe(0), i = W(() => e.to ? Yn(e.to) : "div"), a = W(() => String(n.value).split("")), s = W(() => t.value === "spinning"), l = W(() => t.value === "idle" || s.value), h = W(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": s.value
    })), v = W(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": s.value
    })), u = W(() => ({
      "lc-high-frequency-teaser-watch__arrows--idle-spin": o.value > 0 && t.value === "idle",
      "lc-high-frequency-teaser-watch__arrows--spinning": s.value
    })), f = W(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: c } = ko(
      () => {
        t.value === "idle" && e.isOperational && o.value++;
      },
      ta.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: p, stop: x } = na(
      () => {
        t.value = "spinning";
      },
      ta.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = na(
      () => t.value = "paused",
      ta.PAUSE_DELAY,
      { immediate: !1 }
    ), C = pe(e.gameNumber), { start: A, stop: I } = na(
      () => {
        t.value = "label", n.value = C.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      ta.LABEL_DELAY,
      { immediate: !1 }
    ), { start: L, stop: E } = na(
      () => {
        t.value = "idle", r.value = !1, c();
      },
      ta.IDLE_DELAY,
      { immediate: !1 }
    ), F = () => {
      x(), b(), I(), E();
    };
    return He(
      () => e.isOperational,
      (U) => {
        U ? c() : (F(), m(), t.value = "idle", r.value = !1);
      }
    ), He(
      () => e.gameNumber,
      (U, K) => {
        if (U === K || !e.isOperational) {
          n.value = U;
          return;
        }
        F(), m(), C.value = U, t.value = "idle", p(), g(), A(), L();
      }
    ), (U, K) => ($(), xe(Nt(i.value), Ot(Pt({ to: e.to })), {
      default: _e(() => [
        Re(Z(lr), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: _e(() => [
            ne("div", fh, [
              Re(Z(es), Ce({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: _e(() => [
            ne("div", hh, [
              ne("div", vh, [
                ne("span", mh, Ie(e.gameLabel), 1),
                ne("span", gh, [
                  ($(!0), j(rt, null, yt(a.value, (O, V) => ($(), j("span", {
                    key: `pos-${V}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Re(Ks, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: _e(() => [
                        ($(), j("span", {
                          key: O,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Et({ transitionDelay: `${V * 35}ms` })
                        }, Ie(O), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ne("div", bh, [
                Re(kn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: _e(() => [
                    e.isOperational ? se("", !0) : ($(), j("div", ph, [
                      Re(sh)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? ($(), j("div", yh, [
                  Re(kn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: _e(() => [
                      l.value ? ($(), j("div", {
                        key: 0,
                        class: ye(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ne("span", {
                          class: ye(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ne("span", wh, Ie(e.timerValueLabel), 1),
                          ne("span", xh, Ie(e.timerUnitLabel), 1)
                        ], 2),
                        ($(), j("div", {
                          key: `arrows-${o.value}`,
                          class: ye(["lc-high-frequency-teaser-watch__arrows", u.value])
                        }, [
                          Re(rh)
                        ], 2))
                      ], 2)) : se("", !0)
                    ]),
                    _: 1
                  }),
                  Re(kn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: _e(() => [
                      t.value === "label" ? ($(), j("div", kh, [
                        ve(U.$slots, "new-game-label")
                      ])) : se("", !0)
                    ]),
                    _: 3
                  })
                ])) : se("", !0)
              ])
            ])
          ]),
          footer: _e(() => [
            ve(U.$slots, "message")
          ]),
          default: _e(() => [
            ne("div", Sh, [
              ne("div", {
                class: ye(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Re(dh)
              ], 2),
              ne("span", _h, Ie(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var zn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ch = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Da = 0; Da < zn.length; Da++)
  Ch[zn.charCodeAt(Da)] = Da;
var Eh = function(e) {
  var t = new Uint8Array(e), n, r = t.length, o = "";
  for (n = 0; n < r; n += 3)
    o += zn[t[n] >> 2], o += zn[(t[n] & 3) << 4 | t[n + 1] >> 4], o += zn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], o += zn[t[n + 2] & 63];
  return r % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : r % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
}, Th = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], ra = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], o = Th.indexOf(r);
    t = t * 83 + o;
  }
  return t;
}, Tr = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, Ar = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, Ah = (e) => e < 0 ? -1 : 1, Lr = (e, t) => Ah(e) * Math.pow(Math.abs(e), t), Tl = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, Lh = (e) => {
  if (!e || e.length < 6) throw new Tl("The blurhash string must be at least 6 characters");
  let t = ra(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new Tl(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, $h = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [Tr(t), Tr(n), Tr(r)];
}, Ih = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, o = e % 19;
  return [Lr((n - 9) / 9, 2) * t, Lr((r - 9) / 9, 2) * t, Lr((o - 9) / 9, 2) * t];
}, Dh = (e, t, n, r) => {
  Lh(e), r = r | 1;
  let o = ra(e[0]), i = Math.floor(o / 9) + 1, a = o % 9 + 1, s = (ra(e[1]) + 1) / 166, l = new Array(a * i);
  for (let u = 0; u < l.length; u++) if (u === 0) {
    let f = ra(e.substring(2, 6));
    l[u] = $h(f);
  } else {
    let f = ra(e.substring(4 + u * 2, 6 + u * 2));
    l[u] = Ih(f, s * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let u = 0; u < n; u++) for (let f = 0; f < t; f++) {
    let m = 0, c = 0, p = 0;
    for (let C = 0; C < i; C++) for (let A = 0; A < a; A++) {
      let I = Math.cos(Math.PI * f * A / t) * Math.cos(Math.PI * u * C / n), L = l[A + C * a];
      m += L[0] * I, c += L[1] * I, p += L[2] * I;
    }
    let x = Ar(m), g = Ar(c), b = Ar(p);
    v[4 * f + 0 + u * h] = x, v[4 * f + 1 + u * h] = g, v[4 * f + 2 + u * h] = b, v[4 * f + 3 + u * h] = 255;
  }
  return v;
}, Oh = Dh;
function Mh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Rh(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var $r = { exports: {} }, Ir = {}, Al;
function dn() {
  return Al || (Al = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var s = a.shift();
        if (s) {
          if (typeof s != "object")
            throw new TypeError(s + "must be non-object");
          for (var l in s)
            n(s, l) && (i[l] = s[l]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, s, l, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(s, s + l), h);
          return;
        }
        for (var v = 0; v < l; v++)
          i[h + v] = a[s + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, s, l, h, v, u;
        for (l = 0, a = 0, s = i.length; a < s; a++)
          l += i[a].length;
        for (u = new Uint8Array(l), h = 0, a = 0, s = i.length; a < s; a++)
          v = i[a], u.set(v, h), h += v.length;
        return u;
      }
    }, o = {
      arraySet: function(i, a, s, l, h) {
        for (var v = 0; v < l; v++)
          i[h + v] = a[s + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, o));
    }, e.setTyped(t);
  })(Ir)), Ir;
}
var Fn = {}, Ht = {}, gn = {}, Ll;
function Nh() {
  if (Ll) return gn;
  Ll = 1;
  var e = dn(), t = 4, n = 0, r = 1, o = 2;
  function i(w) {
    for (var J = w.length; --J >= 0; )
      w[J] = 0;
  }
  var a = 0, s = 1, l = 2, h = 3, v = 258, u = 29, f = 256, m = f + 1 + u, c = 30, p = 19, x = 2 * m + 1, g = 15, b = 16, C = 7, A = 256, I = 16, L = 17, E = 18, F = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), U = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), K = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), O = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], V = 512, B = new Array((m + 2) * 2);
  i(B);
  var _ = new Array(c * 2);
  i(_);
  var T = new Array(V);
  i(T);
  var R = new Array(v - h + 1);
  i(R);
  var H = new Array(u);
  i(H);
  var q = new Array(c);
  i(q);
  function G(w, J, M, re, D) {
    this.static_tree = w, this.extra_bits = J, this.extra_base = M, this.elems = re, this.max_length = D, this.has_stree = w && w.length;
  }
  var ie, X, oe;
  function ue(w, J) {
    this.dyn_tree = w, this.max_code = 0, this.stat_desc = J;
  }
  function he(w) {
    return w < 256 ? T[w] : T[256 + (w >>> 7)];
  }
  function be(w, J) {
    w.pending_buf[w.pending++] = J & 255, w.pending_buf[w.pending++] = J >>> 8 & 255;
  }
  function fe(w, J, M) {
    w.bi_valid > b - M ? (w.bi_buf |= J << w.bi_valid & 65535, be(w, w.bi_buf), w.bi_buf = J >> b - w.bi_valid, w.bi_valid += M - b) : (w.bi_buf |= J << w.bi_valid & 65535, w.bi_valid += M);
  }
  function we(w, J, M) {
    fe(
      w,
      M[J * 2],
      M[J * 2 + 1]
      /*.Len*/
    );
  }
  function Ae(w, J) {
    var M = 0;
    do
      M |= w & 1, w >>>= 1, M <<= 1;
    while (--J > 0);
    return M >>> 1;
  }
  function Oe(w) {
    w.bi_valid === 16 ? (be(w, w.bi_buf), w.bi_buf = 0, w.bi_valid = 0) : w.bi_valid >= 8 && (w.pending_buf[w.pending++] = w.bi_buf & 255, w.bi_buf >>= 8, w.bi_valid -= 8);
  }
  function We(w, J) {
    var M = J.dyn_tree, re = J.max_code, D = J.stat_desc.static_tree, Q = J.stat_desc.has_stree, y = J.stat_desc.extra_bits, ce = J.stat_desc.extra_base, Te = J.stat_desc.max_length, d, ae, te, k, P, ee, $e = 0;
    for (k = 0; k <= g; k++)
      w.bl_count[k] = 0;
    for (M[w.heap[w.heap_max] * 2 + 1] = 0, d = w.heap_max + 1; d < x; d++)
      ae = w.heap[d], k = M[M[ae * 2 + 1] * 2 + 1] + 1, k > Te && (k = Te, $e++), M[ae * 2 + 1] = k, !(ae > re) && (w.bl_count[k]++, P = 0, ae >= ce && (P = y[ae - ce]), ee = M[ae * 2], w.opt_len += ee * (k + P), Q && (w.static_len += ee * (D[ae * 2 + 1] + P)));
    if ($e !== 0) {
      do {
        for (k = Te - 1; w.bl_count[k] === 0; )
          k--;
        w.bl_count[k]--, w.bl_count[k + 1] += 2, w.bl_count[Te]--, $e -= 2;
      } while ($e > 0);
      for (k = Te; k !== 0; k--)
        for (ae = w.bl_count[k]; ae !== 0; )
          te = w.heap[--d], !(te > re) && (M[te * 2 + 1] !== k && (w.opt_len += (k - M[te * 2 + 1]) * M[te * 2], M[te * 2 + 1] = k), ae--);
    }
  }
  function Fe(w, J, M) {
    var re = new Array(g + 1), D = 0, Q, y;
    for (Q = 1; Q <= g; Q++)
      re[Q] = D = D + M[Q - 1] << 1;
    for (y = 0; y <= J; y++) {
      var ce = w[y * 2 + 1];
      ce !== 0 && (w[y * 2] = Ae(re[ce]++, ce));
    }
  }
  function de() {
    var w, J, M, re, D, Q = new Array(g + 1);
    for (M = 0, re = 0; re < u - 1; re++)
      for (H[re] = M, w = 0; w < 1 << F[re]; w++)
        R[M++] = re;
    for (R[M - 1] = re, D = 0, re = 0; re < 16; re++)
      for (q[re] = D, w = 0; w < 1 << U[re]; w++)
        T[D++] = re;
    for (D >>= 7; re < c; re++)
      for (q[re] = D << 7, w = 0; w < 1 << U[re] - 7; w++)
        T[256 + D++] = re;
    for (J = 0; J <= g; J++)
      Q[J] = 0;
    for (w = 0; w <= 143; )
      B[w * 2 + 1] = 8, w++, Q[8]++;
    for (; w <= 255; )
      B[w * 2 + 1] = 9, w++, Q[9]++;
    for (; w <= 279; )
      B[w * 2 + 1] = 7, w++, Q[7]++;
    for (; w <= 287; )
      B[w * 2 + 1] = 8, w++, Q[8]++;
    for (Fe(B, m + 1, Q), w = 0; w < c; w++)
      _[w * 2 + 1] = 5, _[w * 2] = Ae(w, 5);
    ie = new G(B, F, f + 1, m, g), X = new G(_, U, 0, c, g), oe = new G(new Array(0), K, 0, p, C);
  }
  function Ne(w) {
    var J;
    for (J = 0; J < m; J++)
      w.dyn_ltree[J * 2] = 0;
    for (J = 0; J < c; J++)
      w.dyn_dtree[J * 2] = 0;
    for (J = 0; J < p; J++)
      w.bl_tree[J * 2] = 0;
    w.dyn_ltree[A * 2] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
  }
  function qe(w) {
    w.bi_valid > 8 ? be(w, w.bi_buf) : w.bi_valid > 0 && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
  }
  function je(w, J, M, re) {
    qe(w), be(w, M), be(w, ~M), e.arraySet(w.pending_buf, w.window, J, M, w.pending), w.pending += M;
  }
  function Xe(w, J, M, re) {
    var D = J * 2, Q = M * 2;
    return w[D] < w[Q] || w[D] === w[Q] && re[J] <= re[M];
  }
  function Ve(w, J, M) {
    for (var re = w.heap[M], D = M << 1; D <= w.heap_len && (D < w.heap_len && Xe(J, w.heap[D + 1], w.heap[D], w.depth) && D++, !Xe(J, re, w.heap[D], w.depth)); )
      w.heap[M] = w.heap[D], M = D, D <<= 1;
    w.heap[M] = re;
  }
  function Pe(w, J, M) {
    var re, D, Q = 0, y, ce;
    if (w.last_lit !== 0)
      do
        re = w.pending_buf[w.d_buf + Q * 2] << 8 | w.pending_buf[w.d_buf + Q * 2 + 1], D = w.pending_buf[w.l_buf + Q], Q++, re === 0 ? we(w, D, J) : (y = R[D], we(w, y + f + 1, J), ce = F[y], ce !== 0 && (D -= H[y], fe(w, D, ce)), re--, y = he(re), we(w, y, M), ce = U[y], ce !== 0 && (re -= q[y], fe(w, re, ce)));
      while (Q < w.last_lit);
    we(w, A, J);
  }
  function it(w, J) {
    var M = J.dyn_tree, re = J.stat_desc.static_tree, D = J.stat_desc.has_stree, Q = J.stat_desc.elems, y, ce, Te = -1, d;
    for (w.heap_len = 0, w.heap_max = x, y = 0; y < Q; y++)
      M[y * 2] !== 0 ? (w.heap[++w.heap_len] = Te = y, w.depth[y] = 0) : M[y * 2 + 1] = 0;
    for (; w.heap_len < 2; )
      d = w.heap[++w.heap_len] = Te < 2 ? ++Te : 0, M[d * 2] = 1, w.depth[d] = 0, w.opt_len--, D && (w.static_len -= re[d * 2 + 1]);
    for (J.max_code = Te, y = w.heap_len >> 1; y >= 1; y--)
      Ve(w, M, y);
    d = Q;
    do
      y = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[
        1
        /*SMALLEST*/
      ] = w.heap[w.heap_len--], Ve(
        w,
        M,
        1
        /*SMALLEST*/
      ), ce = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[--w.heap_max] = y, w.heap[--w.heap_max] = ce, M[d * 2] = M[y * 2] + M[ce * 2], w.depth[d] = (w.depth[y] >= w.depth[ce] ? w.depth[y] : w.depth[ce]) + 1, M[y * 2 + 1] = M[ce * 2 + 1] = d, w.heap[
        1
        /*SMALLEST*/
      ] = d++, Ve(
        w,
        M,
        1
        /*SMALLEST*/
      );
    while (w.heap_len >= 2);
    w.heap[--w.heap_max] = w.heap[
      1
      /*SMALLEST*/
    ], We(w, J), Fe(M, Te, w.bl_count);
  }
  function ut(w, J, M) {
    var re, D = -1, Q, y = J[1], ce = 0, Te = 7, d = 4;
    for (y === 0 && (Te = 138, d = 3), J[(M + 1) * 2 + 1] = 65535, re = 0; re <= M; re++)
      Q = y, y = J[(re + 1) * 2 + 1], !(++ce < Te && Q === y) && (ce < d ? w.bl_tree[Q * 2] += ce : Q !== 0 ? (Q !== D && w.bl_tree[Q * 2]++, w.bl_tree[I * 2]++) : ce <= 10 ? w.bl_tree[L * 2]++ : w.bl_tree[E * 2]++, ce = 0, D = Q, y === 0 ? (Te = 138, d = 3) : Q === y ? (Te = 6, d = 3) : (Te = 7, d = 4));
  }
  function ge(w, J, M) {
    var re, D = -1, Q, y = J[1], ce = 0, Te = 7, d = 4;
    for (y === 0 && (Te = 138, d = 3), re = 0; re <= M; re++)
      if (Q = y, y = J[(re + 1) * 2 + 1], !(++ce < Te && Q === y)) {
        if (ce < d)
          do
            we(w, Q, w.bl_tree);
          while (--ce !== 0);
        else Q !== 0 ? (Q !== D && (we(w, Q, w.bl_tree), ce--), we(w, I, w.bl_tree), fe(w, ce - 3, 2)) : ce <= 10 ? (we(w, L, w.bl_tree), fe(w, ce - 3, 3)) : (we(w, E, w.bl_tree), fe(w, ce - 11, 7));
        ce = 0, D = Q, y === 0 ? (Te = 138, d = 3) : Q === y ? (Te = 6, d = 3) : (Te = 7, d = 4);
      }
  }
  function Be(w) {
    var J;
    for (ut(w, w.dyn_ltree, w.l_desc.max_code), ut(w, w.dyn_dtree, w.d_desc.max_code), it(w, w.bl_desc), J = p - 1; J >= 3 && w.bl_tree[O[J] * 2 + 1] === 0; J--)
      ;
    return w.opt_len += 3 * (J + 1) + 5 + 5 + 4, J;
  }
  function ze(w, J, M, re) {
    var D;
    for (fe(w, J - 257, 5), fe(w, M - 1, 5), fe(w, re - 4, 4), D = 0; D < re; D++)
      fe(w, w.bl_tree[O[D] * 2 + 1], 3);
    ge(w, w.dyn_ltree, J - 1), ge(w, w.dyn_dtree, M - 1);
  }
  function Ke(w) {
    var J = 4093624447, M;
    for (M = 0; M <= 31; M++, J >>>= 1)
      if (J & 1 && w.dyn_ltree[M * 2] !== 0)
        return n;
    if (w.dyn_ltree[18] !== 0 || w.dyn_ltree[20] !== 0 || w.dyn_ltree[26] !== 0)
      return r;
    for (M = 32; M < f; M++)
      if (w.dyn_ltree[M * 2] !== 0)
        return r;
    return n;
  }
  var Qe = !1;
  function ht(w) {
    Qe || (de(), Qe = !0), w.l_desc = new ue(w.dyn_ltree, ie), w.d_desc = new ue(w.dyn_dtree, X), w.bl_desc = new ue(w.bl_tree, oe), w.bi_buf = 0, w.bi_valid = 0, Ne(w);
  }
  function vt(w, J, M, re) {
    fe(w, (a << 1) + (re ? 1 : 0), 3), je(w, J, M);
  }
  function et(w) {
    fe(w, s << 1, 3), we(w, A, B), Oe(w);
  }
  function N(w, J, M, re) {
    var D, Q, y = 0;
    w.level > 0 ? (w.strm.data_type === o && (w.strm.data_type = Ke(w)), it(w, w.l_desc), it(w, w.d_desc), y = Be(w), D = w.opt_len + 3 + 7 >>> 3, Q = w.static_len + 3 + 7 >>> 3, Q <= D && (D = Q)) : D = Q = M + 5, M + 4 <= D && J !== -1 ? vt(w, J, M, re) : w.strategy === t || Q === D ? (fe(w, (s << 1) + (re ? 1 : 0), 3), Pe(w, B, _)) : (fe(w, (l << 1) + (re ? 1 : 0), 3), ze(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, y + 1), Pe(w, w.dyn_ltree, w.dyn_dtree)), Ne(w), re && qe(w);
  }
  function S(w, J, M) {
    return w.pending_buf[w.d_buf + w.last_lit * 2] = J >>> 8 & 255, w.pending_buf[w.d_buf + w.last_lit * 2 + 1] = J & 255, w.pending_buf[w.l_buf + w.last_lit] = M & 255, w.last_lit++, J === 0 ? w.dyn_ltree[M * 2]++ : (w.matches++, J--, w.dyn_ltree[(R[M] + f + 1) * 2]++, w.dyn_dtree[he(J) * 2]++), w.last_lit === w.lit_bufsize - 1;
  }
  return gn._tr_init = ht, gn._tr_stored_block = vt, gn._tr_flush_block = N, gn._tr_tally = S, gn._tr_align = et, gn;
}
var Dr, $l;
function is() {
  if ($l) return Dr;
  $l = 1;
  function e(t, n, r, o) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, s = 0; r !== 0; ) {
      s = r > 2e3 ? 2e3 : r, r -= s;
      do
        i = i + n[o++] | 0, a = a + i | 0;
      while (--s);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Dr = e, Dr;
}
var Or, Il;
function ls() {
  if (Il) return Or;
  Il = 1;
  function e() {
    for (var r, o = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      o[i] = r;
    }
    return o;
  }
  var t = e();
  function n(r, o, i, a) {
    var s = t, l = a + i;
    r ^= -1;
    for (var h = a; h < l; h++)
      r = r >>> 8 ^ s[(r ^ o[h]) & 255];
    return r ^ -1;
  }
  return Or = n, Or;
}
var Mr, Dl;
function wi() {
  return Dl || (Dl = 1, Mr = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Mr;
}
var Ol;
function Fh() {
  if (Ol) return Ht;
  Ol = 1;
  var e = dn(), t = Nh(), n = is(), r = ls(), o = wi(), i = 0, a = 1, s = 3, l = 4, h = 5, v = 0, u = 1, f = -2, m = -3, c = -5, p = -1, x = 1, g = 2, b = 3, C = 4, A = 0, I = 2, L = 8, E = 9, F = 15, U = 8, K = 29, O = 256, V = O + 1 + K, B = 30, _ = 19, T = 2 * V + 1, R = 15, H = 3, q = 258, G = q + H + 1, ie = 32, X = 42, oe = 69, ue = 73, he = 91, be = 103, fe = 113, we = 666, Ae = 1, Oe = 2, We = 3, Fe = 4, de = 3;
  function Ne(d, ae) {
    return d.msg = o[ae], ae;
  }
  function qe(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function je(d) {
    for (var ae = d.length; --ae >= 0; )
      d[ae] = 0;
  }
  function Xe(d) {
    var ae = d.state, te = ae.pending;
    te > d.avail_out && (te = d.avail_out), te !== 0 && (e.arraySet(d.output, ae.pending_buf, ae.pending_out, te, d.next_out), d.next_out += te, ae.pending_out += te, d.total_out += te, d.avail_out -= te, ae.pending -= te, ae.pending === 0 && (ae.pending_out = 0));
  }
  function Ve(d, ae) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, ae), d.block_start = d.strstart, Xe(d.strm);
  }
  function Pe(d, ae) {
    d.pending_buf[d.pending++] = ae;
  }
  function it(d, ae) {
    d.pending_buf[d.pending++] = ae >>> 8 & 255, d.pending_buf[d.pending++] = ae & 255;
  }
  function ut(d, ae, te, k) {
    var P = d.avail_in;
    return P > k && (P = k), P === 0 ? 0 : (d.avail_in -= P, e.arraySet(ae, d.input, d.next_in, P, te), d.state.wrap === 1 ? d.adler = n(d.adler, ae, P, te) : d.state.wrap === 2 && (d.adler = r(d.adler, ae, P, te)), d.next_in += P, d.total_in += P, P);
  }
  function ge(d, ae) {
    var te = d.max_chain_length, k = d.strstart, P, ee, $e = d.prev_length, ke = d.nice_match, Le = d.strstart > d.w_size - G ? d.strstart - (d.w_size - G) : 0, Ye = d.window, wt = d.w_mask, ot = d.prev, Ge = d.strstart + q, mt = Ye[k + $e - 1], _t = Ye[k + $e];
    d.prev_length >= d.good_match && (te >>= 2), ke > d.lookahead && (ke = d.lookahead);
    do
      if (P = ae, !(Ye[P + $e] !== _t || Ye[P + $e - 1] !== mt || Ye[P] !== Ye[k] || Ye[++P] !== Ye[k + 1])) {
        k += 2, P++;
        do
          ;
        while (Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && Ye[++k] === Ye[++P] && k < Ge);
        if (ee = q - (Ge - k), k = Ge - q, ee > $e) {
          if (d.match_start = ae, $e = ee, ee >= ke)
            break;
          mt = Ye[k + $e - 1], _t = Ye[k + $e];
        }
      }
    while ((ae = ot[ae & wt]) > Le && --te !== 0);
    return $e <= d.lookahead ? $e : d.lookahead;
  }
  function Be(d) {
    var ae = d.w_size, te, k, P, ee, $e;
    do {
      if (ee = d.window_size - d.lookahead - d.strstart, d.strstart >= ae + (ae - G)) {
        e.arraySet(d.window, d.window, ae, ae, 0), d.match_start -= ae, d.strstart -= ae, d.block_start -= ae, k = d.hash_size, te = k;
        do
          P = d.head[--te], d.head[te] = P >= ae ? P - ae : 0;
        while (--k);
        k = ae, te = k;
        do
          P = d.prev[--te], d.prev[te] = P >= ae ? P - ae : 0;
        while (--k);
        ee += ae;
      }
      if (d.strm.avail_in === 0)
        break;
      if (k = ut(d.strm, d.window, d.strstart + d.lookahead, ee), d.lookahead += k, d.lookahead + d.insert >= H)
        for ($e = d.strstart - d.insert, d.ins_h = d.window[$e], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[$e + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[$e + H - 1]) & d.hash_mask, d.prev[$e & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = $e, $e++, d.insert--, !(d.lookahead + d.insert < H)); )
          ;
    } while (d.lookahead < G && d.strm.avail_in !== 0);
  }
  function ze(d, ae) {
    var te = 65535;
    for (te > d.pending_buf_size - 5 && (te = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (Be(d), d.lookahead === 0 && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var k = d.block_start + te;
      if ((d.strstart === 0 || d.strstart >= k) && (d.lookahead = d.strstart - k, d.strstart = k, Ve(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - G && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Fe) : (d.strstart > d.block_start && (Ve(d, !1), d.strm.avail_out === 0), Ae);
  }
  function Ke(d, ae) {
    for (var te, k; ; ) {
      if (d.lookahead < G) {
        if (Be(d), d.lookahead < G && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= H && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), te !== 0 && d.strstart - te <= d.w_size - G && (d.match_length = ge(d, te)), d.match_length >= H)
        if (k = t._tr_tally(d, d.strstart - d.match_start, d.match_length - H), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= H) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        k = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (k && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = d.strstart < H - 1 ? d.strstart : H - 1, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Fe) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function Qe(d, ae) {
    for (var te, k, P; ; ) {
      if (d.lookahead < G) {
        if (Be(d), d.lookahead < G && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= H && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = H - 1, te !== 0 && d.prev_length < d.max_lazy_match && d.strstart - te <= d.w_size - G && (d.match_length = ge(d, te), d.match_length <= 5 && (d.strategy === x || d.match_length === H && d.strstart - d.match_start > 4096) && (d.match_length = H - 1)), d.prev_length >= H && d.match_length <= d.prev_length) {
        P = d.strstart + d.lookahead - H, k = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - H), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= P && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = H - 1, d.strstart++, k && (Ve(d, !1), d.strm.avail_out === 0))
          return Ae;
      } else if (d.match_available) {
        if (k = t._tr_tally(d, 0, d.window[d.strstart - 1]), k && Ve(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return Ae;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (k = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < H - 1 ? d.strstart : H - 1, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Fe) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function ht(d, ae) {
    for (var te, k, P, ee, $e = d.window; ; ) {
      if (d.lookahead <= q) {
        if (Be(d), d.lookahead <= q && ae === i)
          return Ae;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= H && d.strstart > 0 && (P = d.strstart - 1, k = $e[P], k === $e[++P] && k === $e[++P] && k === $e[++P])) {
        ee = d.strstart + q;
        do
          ;
        while (k === $e[++P] && k === $e[++P] && k === $e[++P] && k === $e[++P] && k === $e[++P] && k === $e[++P] && k === $e[++P] && k === $e[++P] && P < ee);
        d.match_length = q - (ee - P), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= H ? (te = t._tr_tally(d, 1, d.match_length - H), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), te && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Fe) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function vt(d, ae) {
    for (var te; ; ) {
      if (d.lookahead === 0 && (Be(d), d.lookahead === 0)) {
        if (ae === i)
          return Ae;
        break;
      }
      if (d.match_length = 0, te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, te && (Ve(d, !1), d.strm.avail_out === 0))
        return Ae;
    }
    return d.insert = 0, ae === l ? (Ve(d, !0), d.strm.avail_out === 0 ? We : Fe) : d.last_lit && (Ve(d, !1), d.strm.avail_out === 0) ? Ae : Oe;
  }
  function et(d, ae, te, k, P) {
    this.good_length = d, this.max_lazy = ae, this.nice_length = te, this.max_chain = k, this.func = P;
  }
  var N;
  N = [
    /*      good lazy nice chain */
    new et(0, 0, 0, 0, ze),
    /* 0 store only */
    new et(4, 4, 8, 4, Ke),
    /* 1 max speed, no lazy matches */
    new et(4, 5, 16, 8, Ke),
    /* 2 */
    new et(4, 6, 32, 32, Ke),
    /* 3 */
    new et(4, 4, 16, 16, Qe),
    /* 4 lazy matches */
    new et(8, 16, 32, 32, Qe),
    /* 5 */
    new et(8, 16, 128, 128, Qe),
    /* 6 */
    new et(8, 32, 128, 256, Qe),
    /* 7 */
    new et(32, 128, 258, 1024, Qe),
    /* 8 */
    new et(32, 258, 258, 4096, Qe)
    /* 9 max compression */
  ];
  function S(d) {
    d.window_size = 2 * d.w_size, je(d.head), d.max_lazy_match = N[d.level].max_lazy, d.good_match = N[d.level].good_length, d.nice_match = N[d.level].nice_length, d.max_chain_length = N[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = H - 1, d.match_available = 0, d.ins_h = 0;
  }
  function w() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = L, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(T * 2), this.dyn_dtree = new e.Buf16((2 * B + 1) * 2), this.bl_tree = new e.Buf16((2 * _ + 1) * 2), je(this.dyn_ltree), je(this.dyn_dtree), je(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(R + 1), this.heap = new e.Buf16(2 * V + 1), je(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * V + 1), je(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function J(d) {
    var ae;
    return !d || !d.state ? Ne(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, ae = d.state, ae.pending = 0, ae.pending_out = 0, ae.wrap < 0 && (ae.wrap = -ae.wrap), ae.status = ae.wrap ? X : fe, d.adler = ae.wrap === 2 ? 0 : 1, ae.last_flush = i, t._tr_init(ae), v);
  }
  function M(d) {
    var ae = J(d);
    return ae === v && S(d.state), ae;
  }
  function re(d, ae) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = ae, v);
  }
  function D(d, ae, te, k, P, ee) {
    if (!d)
      return f;
    var $e = 1;
    if (ae === p && (ae = 6), k < 0 ? ($e = 0, k = -k) : k > 15 && ($e = 2, k -= 16), P < 1 || P > E || te !== L || k < 8 || k > 15 || ae < 0 || ae > 9 || ee < 0 || ee > C)
      return Ne(d, f);
    k === 8 && (k = 9);
    var ke = new w();
    return d.state = ke, ke.strm = d, ke.wrap = $e, ke.gzhead = null, ke.w_bits = k, ke.w_size = 1 << ke.w_bits, ke.w_mask = ke.w_size - 1, ke.hash_bits = P + 7, ke.hash_size = 1 << ke.hash_bits, ke.hash_mask = ke.hash_size - 1, ke.hash_shift = ~~((ke.hash_bits + H - 1) / H), ke.window = new e.Buf8(ke.w_size * 2), ke.head = new e.Buf16(ke.hash_size), ke.prev = new e.Buf16(ke.w_size), ke.lit_bufsize = 1 << P + 6, ke.pending_buf_size = ke.lit_bufsize * 4, ke.pending_buf = new e.Buf8(ke.pending_buf_size), ke.d_buf = 1 * ke.lit_bufsize, ke.l_buf = 3 * ke.lit_bufsize, ke.level = ae, ke.strategy = ee, ke.method = te, M(d);
  }
  function Q(d, ae) {
    return D(d, ae, L, F, U, A);
  }
  function y(d, ae) {
    var te, k, P, ee;
    if (!d || !d.state || ae > h || ae < 0)
      return d ? Ne(d, f) : f;
    if (k = d.state, !d.output || !d.input && d.avail_in !== 0 || k.status === we && ae !== l)
      return Ne(d, d.avail_out === 0 ? c : f);
    if (k.strm = d, te = k.last_flush, k.last_flush = ae, k.status === X)
      if (k.wrap === 2)
        d.adler = 0, Pe(k, 31), Pe(k, 139), Pe(k, 8), k.gzhead ? (Pe(
          k,
          (k.gzhead.text ? 1 : 0) + (k.gzhead.hcrc ? 2 : 0) + (k.gzhead.extra ? 4 : 0) + (k.gzhead.name ? 8 : 0) + (k.gzhead.comment ? 16 : 0)
        ), Pe(k, k.gzhead.time & 255), Pe(k, k.gzhead.time >> 8 & 255), Pe(k, k.gzhead.time >> 16 & 255), Pe(k, k.gzhead.time >> 24 & 255), Pe(k, k.level === 9 ? 2 : k.strategy >= g || k.level < 2 ? 4 : 0), Pe(k, k.gzhead.os & 255), k.gzhead.extra && k.gzhead.extra.length && (Pe(k, k.gzhead.extra.length & 255), Pe(k, k.gzhead.extra.length >> 8 & 255)), k.gzhead.hcrc && (d.adler = r(d.adler, k.pending_buf, k.pending, 0)), k.gzindex = 0, k.status = oe) : (Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, 0), Pe(k, k.level === 9 ? 2 : k.strategy >= g || k.level < 2 ? 4 : 0), Pe(k, de), k.status = fe);
      else {
        var $e = L + (k.w_bits - 8 << 4) << 8, ke = -1;
        k.strategy >= g || k.level < 2 ? ke = 0 : k.level < 6 ? ke = 1 : k.level === 6 ? ke = 2 : ke = 3, $e |= ke << 6, k.strstart !== 0 && ($e |= ie), $e += 31 - $e % 31, k.status = fe, it(k, $e), k.strstart !== 0 && (it(k, d.adler >>> 16), it(k, d.adler & 65535)), d.adler = 1;
      }
    if (k.status === oe)
      if (k.gzhead.extra) {
        for (P = k.pending; k.gzindex < (k.gzhead.extra.length & 65535) && !(k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > P && (d.adler = r(d.adler, k.pending_buf, k.pending - P, P)), Xe(d), P = k.pending, k.pending === k.pending_buf_size)); )
          Pe(k, k.gzhead.extra[k.gzindex] & 255), k.gzindex++;
        k.gzhead.hcrc && k.pending > P && (d.adler = r(d.adler, k.pending_buf, k.pending - P, P)), k.gzindex === k.gzhead.extra.length && (k.gzindex = 0, k.status = ue);
      } else
        k.status = ue;
    if (k.status === ue)
      if (k.gzhead.name) {
        P = k.pending;
        do {
          if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > P && (d.adler = r(d.adler, k.pending_buf, k.pending - P, P)), Xe(d), P = k.pending, k.pending === k.pending_buf_size)) {
            ee = 1;
            break;
          }
          k.gzindex < k.gzhead.name.length ? ee = k.gzhead.name.charCodeAt(k.gzindex++) & 255 : ee = 0, Pe(k, ee);
        } while (ee !== 0);
        k.gzhead.hcrc && k.pending > P && (d.adler = r(d.adler, k.pending_buf, k.pending - P, P)), ee === 0 && (k.gzindex = 0, k.status = he);
      } else
        k.status = he;
    if (k.status === he)
      if (k.gzhead.comment) {
        P = k.pending;
        do {
          if (k.pending === k.pending_buf_size && (k.gzhead.hcrc && k.pending > P && (d.adler = r(d.adler, k.pending_buf, k.pending - P, P)), Xe(d), P = k.pending, k.pending === k.pending_buf_size)) {
            ee = 1;
            break;
          }
          k.gzindex < k.gzhead.comment.length ? ee = k.gzhead.comment.charCodeAt(k.gzindex++) & 255 : ee = 0, Pe(k, ee);
        } while (ee !== 0);
        k.gzhead.hcrc && k.pending > P && (d.adler = r(d.adler, k.pending_buf, k.pending - P, P)), ee === 0 && (k.status = be);
      } else
        k.status = be;
    if (k.status === be && (k.gzhead.hcrc ? (k.pending + 2 > k.pending_buf_size && Xe(d), k.pending + 2 <= k.pending_buf_size && (Pe(k, d.adler & 255), Pe(k, d.adler >> 8 & 255), d.adler = 0, k.status = fe)) : k.status = fe), k.pending !== 0) {
      if (Xe(d), d.avail_out === 0)
        return k.last_flush = -1, v;
    } else if (d.avail_in === 0 && qe(ae) <= qe(te) && ae !== l)
      return Ne(d, c);
    if (k.status === we && d.avail_in !== 0)
      return Ne(d, c);
    if (d.avail_in !== 0 || k.lookahead !== 0 || ae !== i && k.status !== we) {
      var Le = k.strategy === g ? vt(k, ae) : k.strategy === b ? ht(k, ae) : N[k.level].func(k, ae);
      if ((Le === We || Le === Fe) && (k.status = we), Le === Ae || Le === We)
        return d.avail_out === 0 && (k.last_flush = -1), v;
      if (Le === Oe && (ae === a ? t._tr_align(k) : ae !== h && (t._tr_stored_block(k, 0, 0, !1), ae === s && (je(k.head), k.lookahead === 0 && (k.strstart = 0, k.block_start = 0, k.insert = 0))), Xe(d), d.avail_out === 0))
        return k.last_flush = -1, v;
    }
    return ae !== l ? v : k.wrap <= 0 ? u : (k.wrap === 2 ? (Pe(k, d.adler & 255), Pe(k, d.adler >> 8 & 255), Pe(k, d.adler >> 16 & 255), Pe(k, d.adler >> 24 & 255), Pe(k, d.total_in & 255), Pe(k, d.total_in >> 8 & 255), Pe(k, d.total_in >> 16 & 255), Pe(k, d.total_in >> 24 & 255)) : (it(k, d.adler >>> 16), it(k, d.adler & 65535)), Xe(d), k.wrap > 0 && (k.wrap = -k.wrap), k.pending !== 0 ? v : u);
  }
  function ce(d) {
    var ae;
    return !d || !d.state ? f : (ae = d.state.status, ae !== X && ae !== oe && ae !== ue && ae !== he && ae !== be && ae !== fe && ae !== we ? Ne(d, f) : (d.state = null, ae === fe ? Ne(d, m) : v));
  }
  function Te(d, ae) {
    var te = ae.length, k, P, ee, $e, ke, Le, Ye, wt;
    if (!d || !d.state || (k = d.state, $e = k.wrap, $e === 2 || $e === 1 && k.status !== X || k.lookahead))
      return f;
    for ($e === 1 && (d.adler = n(d.adler, ae, te, 0)), k.wrap = 0, te >= k.w_size && ($e === 0 && (je(k.head), k.strstart = 0, k.block_start = 0, k.insert = 0), wt = new e.Buf8(k.w_size), e.arraySet(wt, ae, te - k.w_size, k.w_size, 0), ae = wt, te = k.w_size), ke = d.avail_in, Le = d.next_in, Ye = d.input, d.avail_in = te, d.next_in = 0, d.input = ae, Be(k); k.lookahead >= H; ) {
      P = k.strstart, ee = k.lookahead - (H - 1);
      do
        k.ins_h = (k.ins_h << k.hash_shift ^ k.window[P + H - 1]) & k.hash_mask, k.prev[P & k.w_mask] = k.head[k.ins_h], k.head[k.ins_h] = P, P++;
      while (--ee);
      k.strstart = P, k.lookahead = H - 1, Be(k);
    }
    return k.strstart += k.lookahead, k.block_start = k.strstart, k.insert = k.lookahead, k.lookahead = 0, k.match_length = k.prev_length = H - 1, k.match_available = 0, d.next_in = Le, d.input = Ye, d.avail_in = ke, k.wrap = $e, v;
  }
  return Ht.deflateInit = Q, Ht.deflateInit2 = D, Ht.deflateReset = M, Ht.deflateResetKeep = J, Ht.deflateSetHeader = re, Ht.deflate = y, Ht.deflateEnd = ce, Ht.deflateSetDictionary = Te, Ht.deflateInfo = "pako deflate (from Nodeca project)", Ht;
}
var bn = {}, Ml;
function os() {
  if (Ml) return bn;
  Ml = 1;
  var e = dn(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), o = 0; o < 256; o++)
    r[o] = o >= 252 ? 6 : o >= 248 ? 5 : o >= 240 ? 4 : o >= 224 ? 3 : o >= 192 ? 2 : 1;
  r[254] = r[254] = 1, bn.string2buf = function(a) {
    var s, l, h, v, u, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), m += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (s = new e.Buf8(m), u = 0, v = 0; u < m; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), l < 128 ? s[u++] = l : l < 2048 ? (s[u++] = 192 | l >>> 6, s[u++] = 128 | l & 63) : l < 65536 ? (s[u++] = 224 | l >>> 12, s[u++] = 128 | l >>> 6 & 63, s[u++] = 128 | l & 63) : (s[u++] = 240 | l >>> 18, s[u++] = 128 | l >>> 12 & 63, s[u++] = 128 | l >>> 6 & 63, s[u++] = 128 | l & 63);
    return s;
  };
  function i(a, s) {
    if (s < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, s));
    for (var l = "", h = 0; h < s; h++)
      l += String.fromCharCode(a[h]);
    return l;
  }
  return bn.buf2binstring = function(a) {
    return i(a, a.length);
  }, bn.binstring2buf = function(a) {
    for (var s = new e.Buf8(a.length), l = 0, h = s.length; l < h; l++)
      s[l] = a.charCodeAt(l);
    return s;
  }, bn.buf2string = function(a, s) {
    var l, h, v, u, f = s || a.length, m = new Array(f * 2);
    for (h = 0, l = 0; l < f; ) {
      if (v = a[l++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (u = r[v], u > 4) {
        m[h++] = 65533, l += u - 1;
        continue;
      }
      for (v &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && l < f; )
        v = v << 6 | a[l++] & 63, u--;
      if (u > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, bn.utf8border = function(a, s) {
    var l;
    for (s = s || a.length, s > a.length && (s = a.length), l = s - 1; l >= 0 && (a[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? s : l + r[a[l]] > s ? l : s;
  }, bn;
}
var Rr, Rl;
function ss() {
  if (Rl) return Rr;
  Rl = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Rr = e, Rr;
}
var Nl;
function Ph() {
  if (Nl) return Fn;
  Nl = 1;
  var e = Fh(), t = dn(), n = os(), r = wi(), o = ss(), i = Object.prototype.toString, a = 0, s = 4, l = 0, h = 1, v = 2, u = -1, f = 0, m = 8;
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    this.options = t.assign({
      level: u,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var C = this.options;
    C.raw && C.windowBits > 0 ? C.windowBits = -C.windowBits : C.gzip && C.windowBits > 0 && C.windowBits < 16 && (C.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new o(), this.strm.avail_out = 0;
    var A = e.deflateInit2(
      this.strm,
      C.level,
      C.method,
      C.windowBits,
      C.memLevel,
      C.strategy
    );
    if (A !== l)
      throw new Error(r[A]);
    if (C.header && e.deflateSetHeader(this.strm, C.header), C.dictionary) {
      var I;
      if (typeof C.dictionary == "string" ? I = n.string2buf(C.dictionary) : i.call(C.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(C.dictionary) : I = C.dictionary, A = e.deflateSetDictionary(this.strm, I), A !== l)
        throw new Error(r[A]);
      this._dict_set = !0;
    }
  }
  c.prototype.push = function(b, C) {
    var A = this.strm, I = this.options.chunkSize, L, E;
    if (this.ended)
      return !1;
    E = C === ~~C ? C : C === !0 ? s : a, typeof b == "string" ? A.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? A.input = new Uint8Array(b) : A.input = b, A.next_in = 0, A.avail_in = A.input.length;
    do {
      if (A.avail_out === 0 && (A.output = new t.Buf8(I), A.next_out = 0, A.avail_out = I), L = e.deflate(A, E), L !== h && L !== l)
        return this.onEnd(L), this.ended = !0, !1;
      (A.avail_out === 0 || A.avail_in === 0 && (E === s || E === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(A.output, A.next_out))) : this.onData(t.shrinkBuf(A.output, A.next_out)));
    } while ((A.avail_in > 0 || A.avail_out === 0) && L !== h);
    return E === s ? (L = e.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === l) : (E === v && (this.onEnd(l), A.avail_out = 0), !0);
  }, c.prototype.onData = function(b) {
    this.chunks.push(b);
  }, c.prototype.onEnd = function(b) {
    b === l && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function p(b, C) {
    var A = new c(C);
    if (A.push(b, !0), A.err)
      throw A.msg || r[A.err];
    return A.result;
  }
  function x(b, C) {
    return C = C || {}, C.raw = !0, p(b, C);
  }
  function g(b, C) {
    return C = C || {}, C.gzip = !0, p(b, C);
  }
  return Fn.Deflate = c, Fn.deflate = p, Fn.deflateRaw = x, Fn.gzip = g, Fn;
}
var Pn = {}, zt = {}, Nr, Fl;
function Bh() {
  if (Fl) return Nr;
  Fl = 1;
  var e = 30, t = 12;
  return Nr = function(r, o) {
    var i, a, s, l, h, v, u, f, m, c, p, x, g, b, C, A, I, L, E, F, U, K, O, V, B;
    i = r.state, a = r.next_in, V = r.input, s = a + (r.avail_in - 5), l = r.next_out, B = r.output, h = l - (o - r.avail_out), v = l + (r.avail_out - 257), u = i.dmax, f = i.wsize, m = i.whave, c = i.wnext, p = i.window, x = i.hold, g = i.bits, b = i.lencode, C = i.distcode, A = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (x += V[a++] << g, g += 8, x += V[a++] << g, g += 8), L = b[x & A];
        t:
          for (; ; ) {
            if (E = L >>> 24, x >>>= E, g -= E, E = L >>> 16 & 255, E === 0)
              B[l++] = L & 65535;
            else if (E & 16) {
              F = L & 65535, E &= 15, E && (g < E && (x += V[a++] << g, g += 8), F += x & (1 << E) - 1, x >>>= E, g -= E), g < 15 && (x += V[a++] << g, g += 8, x += V[a++] << g, g += 8), L = C[x & I];
              n:
                for (; ; ) {
                  if (E = L >>> 24, x >>>= E, g -= E, E = L >>> 16 & 255, E & 16) {
                    if (U = L & 65535, E &= 15, g < E && (x += V[a++] << g, g += 8, g < E && (x += V[a++] << g, g += 8)), U += x & (1 << E) - 1, U > u) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (x >>>= E, g -= E, E = l - h, U > E) {
                      if (E = U - E, E > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (K = 0, O = p, c === 0) {
                        if (K += f - E, E < F) {
                          F -= E;
                          do
                            B[l++] = p[K++];
                          while (--E);
                          K = l - U, O = B;
                        }
                      } else if (c < E) {
                        if (K += f + c - E, E -= c, E < F) {
                          F -= E;
                          do
                            B[l++] = p[K++];
                          while (--E);
                          if (K = 0, c < F) {
                            E = c, F -= E;
                            do
                              B[l++] = p[K++];
                            while (--E);
                            K = l - U, O = B;
                          }
                        }
                      } else if (K += c - E, E < F) {
                        F -= E;
                        do
                          B[l++] = p[K++];
                        while (--E);
                        K = l - U, O = B;
                      }
                      for (; F > 2; )
                        B[l++] = O[K++], B[l++] = O[K++], B[l++] = O[K++], F -= 3;
                      F && (B[l++] = O[K++], F > 1 && (B[l++] = O[K++]));
                    } else {
                      K = l - U;
                      do
                        B[l++] = B[K++], B[l++] = B[K++], B[l++] = B[K++], F -= 3;
                      while (F > 2);
                      F && (B[l++] = B[K++], F > 1 && (B[l++] = B[K++]));
                    }
                  } else if ((E & 64) === 0) {
                    L = C[(L & 65535) + (x & (1 << E) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((E & 64) === 0) {
              L = b[(L & 65535) + (x & (1 << E) - 1)];
              continue t;
            } else if (E & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < s && l < v);
    F = g >> 3, a -= F, g -= F << 3, x &= (1 << g) - 1, r.next_in = a, r.next_out = l, r.avail_in = a < s ? 5 + (s - a) : 5 - (a - s), r.avail_out = l < v ? 257 + (v - l) : 257 - (l - v), i.hold = x, i.bits = g;
  }, Nr;
}
var Fr, Pl;
function zh() {
  if (Pl) return Fr;
  Pl = 1;
  var e = dn(), t = 15, n = 852, r = 592, o = 0, i = 1, a = 2, s = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], l = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Fr = function(f, m, c, p, x, g, b, C) {
    var A = C.bits, I = 0, L = 0, E = 0, F = 0, U = 0, K = 0, O = 0, V = 0, B = 0, _ = 0, T, R, H, q, G, ie = null, X = 0, oe, ue = new e.Buf16(t + 1), he = new e.Buf16(t + 1), be = null, fe = 0, we, Ae, Oe;
    for (I = 0; I <= t; I++)
      ue[I] = 0;
    for (L = 0; L < p; L++)
      ue[m[c + L]]++;
    for (U = A, F = t; F >= 1 && ue[F] === 0; F--)
      ;
    if (U > F && (U = F), F === 0)
      return x[g++] = 1 << 24 | 64 << 16 | 0, x[g++] = 1 << 24 | 64 << 16 | 0, C.bits = 1, 0;
    for (E = 1; E < F && ue[E] === 0; E++)
      ;
    for (U < E && (U = E), V = 1, I = 1; I <= t; I++)
      if (V <<= 1, V -= ue[I], V < 0)
        return -1;
    if (V > 0 && (f === o || F !== 1))
      return -1;
    for (he[1] = 0, I = 1; I < t; I++)
      he[I + 1] = he[I] + ue[I];
    for (L = 0; L < p; L++)
      m[c + L] !== 0 && (b[he[m[c + L]]++] = L);
    if (f === o ? (ie = be = b, oe = 19) : f === i ? (ie = s, X -= 257, be = l, fe -= 257, oe = 256) : (ie = h, be = v, oe = -1), _ = 0, L = 0, I = E, G = g, K = U, O = 0, H = -1, B = 1 << U, q = B - 1, f === i && B > n || f === a && B > r)
      return 1;
    for (; ; ) {
      we = I - O, b[L] < oe ? (Ae = 0, Oe = b[L]) : b[L] > oe ? (Ae = be[fe + b[L]], Oe = ie[X + b[L]]) : (Ae = 96, Oe = 0), T = 1 << I - O, R = 1 << K, E = R;
      do
        R -= T, x[G + (_ >> O) + R] = we << 24 | Ae << 16 | Oe | 0;
      while (R !== 0);
      for (T = 1 << I - 1; _ & T; )
        T >>= 1;
      if (T !== 0 ? (_ &= T - 1, _ += T) : _ = 0, L++, --ue[I] === 0) {
        if (I === F)
          break;
        I = m[c + b[L]];
      }
      if (I > U && (_ & q) !== H) {
        for (O === 0 && (O = U), G += E, K = I - O, V = 1 << K; K + O < F && (V -= ue[K + O], !(V <= 0)); )
          K++, V <<= 1;
        if (B += 1 << K, f === i && B > n || f === a && B > r)
          return 1;
        H = _ & q, x[H] = U << 24 | K << 16 | G - g | 0;
      }
    }
    return _ !== 0 && (x[G + _] = I - O << 24 | 64 << 16 | 0), C.bits = U, 0;
  }, Fr;
}
var Bl;
function Vh() {
  if (Bl) return zt;
  Bl = 1;
  var e = dn(), t = is(), n = ls(), r = Bh(), o = zh(), i = 0, a = 1, s = 2, l = 4, h = 5, v = 6, u = 0, f = 1, m = 2, c = -2, p = -3, x = -4, g = -5, b = 8, C = 1, A = 2, I = 3, L = 4, E = 5, F = 6, U = 7, K = 8, O = 9, V = 10, B = 11, _ = 12, T = 13, R = 14, H = 15, q = 16, G = 17, ie = 18, X = 19, oe = 20, ue = 21, he = 22, be = 23, fe = 24, we = 25, Ae = 26, Oe = 27, We = 28, Fe = 29, de = 30, Ne = 31, qe = 32, je = 852, Xe = 592, Ve = 15, Pe = Ve;
  function it(D) {
    return (D >>> 24 & 255) + (D >>> 8 & 65280) + ((D & 65280) << 8) + ((D & 255) << 24);
  }
  function ut() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function ge(D) {
    var Q;
    return !D || !D.state ? c : (Q = D.state, D.total_in = D.total_out = Q.total = 0, D.msg = "", Q.wrap && (D.adler = Q.wrap & 1), Q.mode = C, Q.last = 0, Q.havedict = 0, Q.dmax = 32768, Q.head = null, Q.hold = 0, Q.bits = 0, Q.lencode = Q.lendyn = new e.Buf32(je), Q.distcode = Q.distdyn = new e.Buf32(Xe), Q.sane = 1, Q.back = -1, u);
  }
  function Be(D) {
    var Q;
    return !D || !D.state ? c : (Q = D.state, Q.wsize = 0, Q.whave = 0, Q.wnext = 0, ge(D));
  }
  function ze(D, Q) {
    var y, ce;
    return !D || !D.state || (ce = D.state, Q < 0 ? (y = 0, Q = -Q) : (y = (Q >> 4) + 1, Q < 48 && (Q &= 15)), Q && (Q < 8 || Q > 15)) ? c : (ce.window !== null && ce.wbits !== Q && (ce.window = null), ce.wrap = y, ce.wbits = Q, Be(D));
  }
  function Ke(D, Q) {
    var y, ce;
    return D ? (ce = new ut(), D.state = ce, ce.window = null, y = ze(D, Q), y !== u && (D.state = null), y) : c;
  }
  function Qe(D) {
    return Ke(D, Pe);
  }
  var ht = !0, vt, et;
  function N(D) {
    if (ht) {
      var Q;
      for (vt = new e.Buf32(512), et = new e.Buf32(32), Q = 0; Q < 144; )
        D.lens[Q++] = 8;
      for (; Q < 256; )
        D.lens[Q++] = 9;
      for (; Q < 280; )
        D.lens[Q++] = 7;
      for (; Q < 288; )
        D.lens[Q++] = 8;
      for (o(a, D.lens, 0, 288, vt, 0, D.work, { bits: 9 }), Q = 0; Q < 32; )
        D.lens[Q++] = 5;
      o(s, D.lens, 0, 32, et, 0, D.work, { bits: 5 }), ht = !1;
    }
    D.lencode = vt, D.lenbits = 9, D.distcode = et, D.distbits = 5;
  }
  function S(D, Q, y, ce) {
    var Te, d = D.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), ce >= d.wsize ? (e.arraySet(d.window, Q, y - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Te = d.wsize - d.wnext, Te > ce && (Te = ce), e.arraySet(d.window, Q, y - ce, Te, d.wnext), ce -= Te, ce ? (e.arraySet(d.window, Q, y - ce, ce, 0), d.wnext = ce, d.whave = d.wsize) : (d.wnext += Te, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Te))), 0;
  }
  function w(D, Q) {
    var y, ce, Te, d, ae, te, k, P, ee, $e, ke, Le, Ye, wt, ot = 0, Ge, mt, _t, At, hn, an, st, It, xt = new e.Buf8(4), Vt, Ft, ka = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!D || !D.state || !D.output || !D.input && D.avail_in !== 0)
      return c;
    y = D.state, y.mode === _ && (y.mode = T), ae = D.next_out, Te = D.output, k = D.avail_out, d = D.next_in, ce = D.input, te = D.avail_in, P = y.hold, ee = y.bits, $e = te, ke = k, It = u;
    e:
      for (; ; )
        switch (y.mode) {
          case C:
            if (y.wrap === 0) {
              y.mode = T;
              break;
            }
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            if (y.wrap & 2 && P === 35615) {
              y.check = 0, xt[0] = P & 255, xt[1] = P >>> 8 & 255, y.check = n(y.check, xt, 2, 0), P = 0, ee = 0, y.mode = A;
              break;
            }
            if (y.flags = 0, y.head && (y.head.done = !1), !(y.wrap & 1) || /* check if zlib header allowed */
            (((P & 255) << 8) + (P >> 8)) % 31) {
              D.msg = "incorrect header check", y.mode = de;
              break;
            }
            if ((P & 15) !== b) {
              D.msg = "unknown compression method", y.mode = de;
              break;
            }
            if (P >>>= 4, ee -= 4, st = (P & 15) + 8, y.wbits === 0)
              y.wbits = st;
            else if (st > y.wbits) {
              D.msg = "invalid window size", y.mode = de;
              break;
            }
            y.dmax = 1 << st, D.adler = y.check = 1, y.mode = P & 512 ? V : _, P = 0, ee = 0;
            break;
          case A:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            if (y.flags = P, (y.flags & 255) !== b) {
              D.msg = "unknown compression method", y.mode = de;
              break;
            }
            if (y.flags & 57344) {
              D.msg = "unknown header flags set", y.mode = de;
              break;
            }
            y.head && (y.head.text = P >> 8 & 1), y.flags & 512 && (xt[0] = P & 255, xt[1] = P >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), P = 0, ee = 0, y.mode = I;
          /* falls through */
          case I:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            y.head && (y.head.time = P), y.flags & 512 && (xt[0] = P & 255, xt[1] = P >>> 8 & 255, xt[2] = P >>> 16 & 255, xt[3] = P >>> 24 & 255, y.check = n(y.check, xt, 4, 0)), P = 0, ee = 0, y.mode = L;
          /* falls through */
          case L:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            y.head && (y.head.xflags = P & 255, y.head.os = P >> 8), y.flags & 512 && (xt[0] = P & 255, xt[1] = P >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), P = 0, ee = 0, y.mode = E;
          /* falls through */
          case E:
            if (y.flags & 1024) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              y.length = P, y.head && (y.head.extra_len = P), y.flags & 512 && (xt[0] = P & 255, xt[1] = P >>> 8 & 255, y.check = n(y.check, xt, 2, 0)), P = 0, ee = 0;
            } else y.head && (y.head.extra = null);
            y.mode = F;
          /* falls through */
          case F:
            if (y.flags & 1024 && (Le = y.length, Le > te && (Le = te), Le && (y.head && (st = y.head.extra_len - y.length, y.head.extra || (y.head.extra = new Array(y.head.extra_len)), e.arraySet(
              y.head.extra,
              ce,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Le,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              st
            )), y.flags & 512 && (y.check = n(y.check, ce, Le, d)), te -= Le, d += Le, y.length -= Le), y.length))
              break e;
            y.length = 0, y.mode = U;
          /* falls through */
          case U:
            if (y.flags & 2048) {
              if (te === 0)
                break e;
              Le = 0;
              do
                st = ce[d + Le++], y.head && st && y.length < 65536 && (y.head.name += String.fromCharCode(st));
              while (st && Le < te);
              if (y.flags & 512 && (y.check = n(y.check, ce, Le, d)), te -= Le, d += Le, st)
                break e;
            } else y.head && (y.head.name = null);
            y.length = 0, y.mode = K;
          /* falls through */
          case K:
            if (y.flags & 4096) {
              if (te === 0)
                break e;
              Le = 0;
              do
                st = ce[d + Le++], y.head && st && y.length < 65536 && (y.head.comment += String.fromCharCode(st));
              while (st && Le < te);
              if (y.flags & 512 && (y.check = n(y.check, ce, Le, d)), te -= Le, d += Le, st)
                break e;
            } else y.head && (y.head.comment = null);
            y.mode = O;
          /* falls through */
          case O:
            if (y.flags & 512) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              if (P !== (y.check & 65535)) {
                D.msg = "header crc mismatch", y.mode = de;
                break;
              }
              P = 0, ee = 0;
            }
            y.head && (y.head.hcrc = y.flags >> 9 & 1, y.head.done = !0), D.adler = y.check = 0, y.mode = _;
            break;
          case V:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            D.adler = y.check = it(P), P = 0, ee = 0, y.mode = B;
          /* falls through */
          case B:
            if (y.havedict === 0)
              return D.next_out = ae, D.avail_out = k, D.next_in = d, D.avail_in = te, y.hold = P, y.bits = ee, m;
            D.adler = y.check = 1, y.mode = _;
          /* falls through */
          case _:
            if (Q === h || Q === v)
              break e;
          /* falls through */
          case T:
            if (y.last) {
              P >>>= ee & 7, ee -= ee & 7, y.mode = Oe;
              break;
            }
            for (; ee < 3; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            switch (y.last = P & 1, P >>>= 1, ee -= 1, P & 3) {
              case 0:
                y.mode = R;
                break;
              case 1:
                if (N(y), y.mode = oe, Q === v) {
                  P >>>= 2, ee -= 2;
                  break e;
                }
                break;
              case 2:
                y.mode = G;
                break;
              case 3:
                D.msg = "invalid block type", y.mode = de;
            }
            P >>>= 2, ee -= 2;
            break;
          case R:
            for (P >>>= ee & 7, ee -= ee & 7; ee < 32; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            if ((P & 65535) !== (P >>> 16 ^ 65535)) {
              D.msg = "invalid stored block lengths", y.mode = de;
              break;
            }
            if (y.length = P & 65535, P = 0, ee = 0, y.mode = H, Q === v)
              break e;
          /* falls through */
          case H:
            y.mode = q;
          /* falls through */
          case q:
            if (Le = y.length, Le) {
              if (Le > te && (Le = te), Le > k && (Le = k), Le === 0)
                break e;
              e.arraySet(Te, ce, d, Le, ae), te -= Le, d += Le, k -= Le, ae += Le, y.length -= Le;
              break;
            }
            y.mode = _;
            break;
          case G:
            for (; ee < 14; ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            if (y.nlen = (P & 31) + 257, P >>>= 5, ee -= 5, y.ndist = (P & 31) + 1, P >>>= 5, ee -= 5, y.ncode = (P & 15) + 4, P >>>= 4, ee -= 4, y.nlen > 286 || y.ndist > 30) {
              D.msg = "too many length or distance symbols", y.mode = de;
              break;
            }
            y.have = 0, y.mode = ie;
          /* falls through */
          case ie:
            for (; y.have < y.ncode; ) {
              for (; ee < 3; ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              y.lens[ka[y.have++]] = P & 7, P >>>= 3, ee -= 3;
            }
            for (; y.have < 19; )
              y.lens[ka[y.have++]] = 0;
            if (y.lencode = y.lendyn, y.lenbits = 7, Vt = { bits: y.lenbits }, It = o(i, y.lens, 0, 19, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, It) {
              D.msg = "invalid code lengths set", y.mode = de;
              break;
            }
            y.have = 0, y.mode = X;
          /* falls through */
          case X:
            for (; y.have < y.nlen + y.ndist; ) {
              for (; ot = y.lencode[P & (1 << y.lenbits) - 1], Ge = ot >>> 24, mt = ot >>> 16 & 255, _t = ot & 65535, !(Ge <= ee); ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              if (_t < 16)
                P >>>= Ge, ee -= Ge, y.lens[y.have++] = _t;
              else {
                if (_t === 16) {
                  for (Ft = Ge + 2; ee < Ft; ) {
                    if (te === 0)
                      break e;
                    te--, P += ce[d++] << ee, ee += 8;
                  }
                  if (P >>>= Ge, ee -= Ge, y.have === 0) {
                    D.msg = "invalid bit length repeat", y.mode = de;
                    break;
                  }
                  st = y.lens[y.have - 1], Le = 3 + (P & 3), P >>>= 2, ee -= 2;
                } else if (_t === 17) {
                  for (Ft = Ge + 3; ee < Ft; ) {
                    if (te === 0)
                      break e;
                    te--, P += ce[d++] << ee, ee += 8;
                  }
                  P >>>= Ge, ee -= Ge, st = 0, Le = 3 + (P & 7), P >>>= 3, ee -= 3;
                } else {
                  for (Ft = Ge + 7; ee < Ft; ) {
                    if (te === 0)
                      break e;
                    te--, P += ce[d++] << ee, ee += 8;
                  }
                  P >>>= Ge, ee -= Ge, st = 0, Le = 11 + (P & 127), P >>>= 7, ee -= 7;
                }
                if (y.have + Le > y.nlen + y.ndist) {
                  D.msg = "invalid bit length repeat", y.mode = de;
                  break;
                }
                for (; Le--; )
                  y.lens[y.have++] = st;
              }
            }
            if (y.mode === de)
              break;
            if (y.lens[256] === 0) {
              D.msg = "invalid code -- missing end-of-block", y.mode = de;
              break;
            }
            if (y.lenbits = 9, Vt = { bits: y.lenbits }, It = o(a, y.lens, 0, y.nlen, y.lencode, 0, y.work, Vt), y.lenbits = Vt.bits, It) {
              D.msg = "invalid literal/lengths set", y.mode = de;
              break;
            }
            if (y.distbits = 6, y.distcode = y.distdyn, Vt = { bits: y.distbits }, It = o(s, y.lens, y.nlen, y.ndist, y.distcode, 0, y.work, Vt), y.distbits = Vt.bits, It) {
              D.msg = "invalid distances set", y.mode = de;
              break;
            }
            if (y.mode = oe, Q === v)
              break e;
          /* falls through */
          case oe:
            y.mode = ue;
          /* falls through */
          case ue:
            if (te >= 6 && k >= 258) {
              D.next_out = ae, D.avail_out = k, D.next_in = d, D.avail_in = te, y.hold = P, y.bits = ee, r(D, ke), ae = D.next_out, Te = D.output, k = D.avail_out, d = D.next_in, ce = D.input, te = D.avail_in, P = y.hold, ee = y.bits, y.mode === _ && (y.back = -1);
              break;
            }
            for (y.back = 0; ot = y.lencode[P & (1 << y.lenbits) - 1], Ge = ot >>> 24, mt = ot >>> 16 & 255, _t = ot & 65535, !(Ge <= ee); ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            if (mt && (mt & 240) === 0) {
              for (At = Ge, hn = mt, an = _t; ot = y.lencode[an + ((P & (1 << At + hn) - 1) >> At)], Ge = ot >>> 24, mt = ot >>> 16 & 255, _t = ot & 65535, !(At + Ge <= ee); ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              P >>>= At, ee -= At, y.back += At;
            }
            if (P >>>= Ge, ee -= Ge, y.back += Ge, y.length = _t, mt === 0) {
              y.mode = Ae;
              break;
            }
            if (mt & 32) {
              y.back = -1, y.mode = _;
              break;
            }
            if (mt & 64) {
              D.msg = "invalid literal/length code", y.mode = de;
              break;
            }
            y.extra = mt & 15, y.mode = he;
          /* falls through */
          case he:
            if (y.extra) {
              for (Ft = y.extra; ee < Ft; ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              y.length += P & (1 << y.extra) - 1, P >>>= y.extra, ee -= y.extra, y.back += y.extra;
            }
            y.was = y.length, y.mode = be;
          /* falls through */
          case be:
            for (; ot = y.distcode[P & (1 << y.distbits) - 1], Ge = ot >>> 24, mt = ot >>> 16 & 255, _t = ot & 65535, !(Ge <= ee); ) {
              if (te === 0)
                break e;
              te--, P += ce[d++] << ee, ee += 8;
            }
            if ((mt & 240) === 0) {
              for (At = Ge, hn = mt, an = _t; ot = y.distcode[an + ((P & (1 << At + hn) - 1) >> At)], Ge = ot >>> 24, mt = ot >>> 16 & 255, _t = ot & 65535, !(At + Ge <= ee); ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              P >>>= At, ee -= At, y.back += At;
            }
            if (P >>>= Ge, ee -= Ge, y.back += Ge, mt & 64) {
              D.msg = "invalid distance code", y.mode = de;
              break;
            }
            y.offset = _t, y.extra = mt & 15, y.mode = fe;
          /* falls through */
          case fe:
            if (y.extra) {
              for (Ft = y.extra; ee < Ft; ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              y.offset += P & (1 << y.extra) - 1, P >>>= y.extra, ee -= y.extra, y.back += y.extra;
            }
            if (y.offset > y.dmax) {
              D.msg = "invalid distance too far back", y.mode = de;
              break;
            }
            y.mode = we;
          /* falls through */
          case we:
            if (k === 0)
              break e;
            if (Le = ke - k, y.offset > Le) {
              if (Le = y.offset - Le, Le > y.whave && y.sane) {
                D.msg = "invalid distance too far back", y.mode = de;
                break;
              }
              Le > y.wnext ? (Le -= y.wnext, Ye = y.wsize - Le) : Ye = y.wnext - Le, Le > y.length && (Le = y.length), wt = y.window;
            } else
              wt = Te, Ye = ae - y.offset, Le = y.length;
            Le > k && (Le = k), k -= Le, y.length -= Le;
            do
              Te[ae++] = wt[Ye++];
            while (--Le);
            y.length === 0 && (y.mode = ue);
            break;
          case Ae:
            if (k === 0)
              break e;
            Te[ae++] = y.length, k--, y.mode = ue;
            break;
          case Oe:
            if (y.wrap) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, P |= ce[d++] << ee, ee += 8;
              }
              if (ke -= k, D.total_out += ke, y.total += ke, ke && (D.adler = y.check = /*UPDATE(state.check, put - _out, _out);*/
              y.flags ? n(y.check, Te, ke, ae - ke) : t(y.check, Te, ke, ae - ke)), ke = k, (y.flags ? P : it(P)) !== y.check) {
                D.msg = "incorrect data check", y.mode = de;
                break;
              }
              P = 0, ee = 0;
            }
            y.mode = We;
          /* falls through */
          case We:
            if (y.wrap && y.flags) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, P += ce[d++] << ee, ee += 8;
              }
              if (P !== (y.total & 4294967295)) {
                D.msg = "incorrect length check", y.mode = de;
                break;
              }
              P = 0, ee = 0;
            }
            y.mode = Fe;
          /* falls through */
          case Fe:
            It = f;
            break e;
          case de:
            It = p;
            break e;
          case Ne:
            return x;
          case qe:
          /* falls through */
          default:
            return c;
        }
    return D.next_out = ae, D.avail_out = k, D.next_in = d, D.avail_in = te, y.hold = P, y.bits = ee, (y.wsize || ke !== D.avail_out && y.mode < de && (y.mode < Oe || Q !== l)) && S(D, D.output, D.next_out, ke - D.avail_out), $e -= D.avail_in, ke -= D.avail_out, D.total_in += $e, D.total_out += ke, y.total += ke, y.wrap && ke && (D.adler = y.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    y.flags ? n(y.check, Te, ke, D.next_out - ke) : t(y.check, Te, ke, D.next_out - ke)), D.data_type = y.bits + (y.last ? 64 : 0) + (y.mode === _ ? 128 : 0) + (y.mode === oe || y.mode === H ? 256 : 0), ($e === 0 && ke === 0 || Q === l) && It === u && (It = g), It;
  }
  function J(D) {
    if (!D || !D.state)
      return c;
    var Q = D.state;
    return Q.window && (Q.window = null), D.state = null, u;
  }
  function M(D, Q) {
    var y;
    return !D || !D.state || (y = D.state, (y.wrap & 2) === 0) ? c : (y.head = Q, Q.done = !1, u);
  }
  function re(D, Q) {
    var y = Q.length, ce, Te, d;
    return !D || !D.state || (ce = D.state, ce.wrap !== 0 && ce.mode !== B) ? c : ce.mode === B && (Te = 1, Te = t(Te, Q, y, 0), Te !== ce.check) ? p : (d = S(D, Q, y, y), d ? (ce.mode = Ne, x) : (ce.havedict = 1, u));
  }
  return zt.inflateReset = Be, zt.inflateReset2 = ze, zt.inflateResetKeep = ge, zt.inflateInit = Qe, zt.inflateInit2 = Ke, zt.inflate = w, zt.inflateEnd = J, zt.inflateGetHeader = M, zt.inflateSetDictionary = re, zt.inflateInfo = "pako inflate (from Nodeca project)", zt;
}
var Pr, zl;
function cs() {
  return zl || (zl = 1, Pr = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Pr;
}
var Br, Vl;
function Hh() {
  if (Vl) return Br;
  Vl = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Br = e, Br;
}
var Hl;
function Uh() {
  if (Hl) return Pn;
  Hl = 1;
  var e = Vh(), t = dn(), n = os(), r = cs(), o = wi(), i = ss(), a = Hh(), s = Object.prototype.toString;
  function l(u) {
    if (!(this instanceof l)) return new l(u);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, u || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(u && u.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(o[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : s.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(o[m]);
  }
  l.prototype.push = function(u, f) {
    var m = this.strm, c = this.options.chunkSize, p = this.options.dictionary, x, g, b, C, A, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof u == "string" ? m.input = n.binstring2buf(u) : s.call(u) === "[object ArrayBuffer]" ? m.input = new Uint8Array(u) : m.input = u, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(c), m.next_out = 0, m.avail_out = c), x = e.inflate(m, r.Z_NO_FLUSH), x === r.Z_NEED_DICT && p && (x = e.inflateSetDictionary(this.strm, p)), x === r.Z_BUF_ERROR && I === !0 && (x = r.Z_OK, I = !1), x !== r.Z_STREAM_END && x !== r.Z_OK)
        return this.onEnd(x), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || x === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), C = m.next_out - b, A = n.buf2string(m.output, b), m.next_out = C, m.avail_out = c - C, C && t.arraySet(m.output, m.output, b, C, 0), this.onData(A)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && x !== r.Z_STREAM_END);
    return x === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (x = e.inflateEnd(this.strm), this.onEnd(x), this.ended = !0, x === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, l.prototype.onData = function(u) {
    this.chunks.push(u);
  }, l.prototype.onEnd = function(u) {
    u === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = u, this.msg = this.strm.msg;
  };
  function h(u, f) {
    var m = new l(f);
    if (m.push(u, !0), m.err)
      throw m.msg || o[m.err];
    return m.result;
  }
  function v(u, f) {
    return f = f || {}, f.raw = !0, h(u, f);
  }
  return Pn.Inflate = l, Pn.inflate = h, Pn.inflateRaw = v, Pn.ungzip = h, Pn;
}
var zr, Ul;
function qh() {
  if (Ul) return zr;
  Ul = 1;
  var e = dn().assign, t = Ph(), n = Uh(), r = cs(), o = {};
  return e(o, t, n, r), zr = o, zr;
}
var ql;
function jh() {
  return ql || (ql = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof Rh == "function" ? n = qh() : n = window.pako, (function(r, o) {
        r.toRGBA8 = function(i) {
          var a = i.width, s = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, s, i).buffer];
          var l = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * s * 4), u = 0; u < i.frames.length; u++) {
            var f = i.frames[u], m = f.rect.x, c = f.rect.y, p = f.rect.width, x = f.rect.height, g = r.toRGBA8.decodeImage(f.data, p, x, i);
            if (u == 0 ? h = g : f.blend == 0 ? r._copyTile(g, p, x, h, a, s, m, c, 0) : f.blend == 1 && r._copyTile(g, p, x, h, a, s, m, c, 1), l.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, p, x, h, a, s, m, c, 0);
              else if (f.dispose == 2) {
                for (var b = u - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(l[b]).slice(0);
              }
            }
          }
          return l;
        }, r.toRGBA8.decodeImage = function(i, a, s, l) {
          var h = a * s, v = r.decode._getBPP(l), u = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), c = l.ctype, p = l.depth, x = r._bin.readUshort;
          if (c == 6) {
            var g = h << 2;
            if (p == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (p == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (c == 2) {
            var C = l.tabs.tRNS, A = -1, I = -1, L = -1;
            if (C && (A = C[0], I = C[1], L = C[2]), p == 8) for (var b = 0; b < h; b++) {
              var E = b << 2, F = b * 3;
              f[E] = i[F], f[E + 1] = i[F + 1], f[E + 2] = i[F + 2], f[E + 3] = 255, A != -1 && i[F] == A && i[F + 1] == I && i[F + 2] == L && (f[E + 3] = 0);
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var E = b << 2, F = b * 6;
              f[E] = i[F], f[E + 1] = i[F + 2], f[E + 2] = i[F + 4], f[E + 3] = 255, A != -1 && x(i, F) == A && x(i, F + 2) == I && x(i, F + 4) == L && (f[E + 3] = 0);
            }
          } else if (c == 3) {
            var U = l.tabs.PLTE, K = l.tabs.tRNS, O = K ? K.length : 0;
            if (p == 1) for (var V = 0; V < s; V++)
              for (var B = V * u, _ = V * a, b = 0; b < a; b++) {
                var E = _ + b << 2, T = i[B + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, R = 3 * T;
                f[E] = U[R], f[E + 1] = U[R + 1], f[E + 2] = U[R + 2], f[E + 3] = T < O ? K[T] : 255;
              }
            if (p == 2) for (var V = 0; V < s; V++)
              for (var B = V * u, _ = V * a, b = 0; b < a; b++) {
                var E = _ + b << 2, T = i[B + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, R = 3 * T;
                f[E] = U[R], f[E + 1] = U[R + 1], f[E + 2] = U[R + 2], f[E + 3] = T < O ? K[T] : 255;
              }
            if (p == 4) for (var V = 0; V < s; V++)
              for (var B = V * u, _ = V * a, b = 0; b < a; b++) {
                var E = _ + b << 2, T = i[B + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, R = 3 * T;
                f[E] = U[R], f[E + 1] = U[R + 1], f[E + 2] = U[R + 2], f[E + 3] = T < O ? K[T] : 255;
              }
            if (p == 8) for (var b = 0; b < h; b++) {
              var E = b << 2, T = i[b], R = 3 * T;
              f[E] = U[R], f[E + 1] = U[R + 1], f[E + 2] = U[R + 2], f[E + 3] = T < O ? K[T] : 255;
            }
          } else if (c == 4) {
            if (p == 8) for (var b = 0; b < h; b++) {
              var E = b << 2, H = b << 1, q = i[H];
              f[E] = q, f[E + 1] = q, f[E + 2] = q, f[E + 3] = i[H + 1];
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var E = b << 2, H = b << 2, q = i[H];
              f[E] = q, f[E + 1] = q, f[E + 2] = q, f[E + 3] = i[H + 2];
            }
          } else if (c == 0) {
            var A = l.tabs.tRNS ? l.tabs.tRNS : -1;
            if (p == 1) for (var b = 0; b < h; b++) {
              var q = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), G = q == A * 255 ? 0 : 255;
              m[b] = G << 24 | q << 16 | q << 8 | q;
            }
            if (p == 2) for (var b = 0; b < h; b++) {
              var q = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), G = q == A * 85 ? 0 : 255;
              m[b] = G << 24 | q << 16 | q << 8 | q;
            }
            if (p == 4) for (var b = 0; b < h; b++) {
              var q = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), G = q == A * 17 ? 0 : 255;
              m[b] = G << 24 | q << 16 | q << 8 | q;
            }
            if (p == 8) for (var b = 0; b < h; b++) {
              var q = i[b], G = q == A ? 0 : 255;
              m[b] = G << 24 | q << 16 | q << 8 | q;
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var q = i[b << 1], G = x(i, b << 1) == A ? 0 : 255;
              m[b] = G << 24 | q << 16 | q << 8 | q;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), s = 8, l = r._bin, h = l.readUshort, v = l.readUint, u = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, c, p = 0, x = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != x[g]) throw "The input is not a PNG file!";
          for (; s < a.length; ) {
            var b = l.readUint(a, s);
            s += 4;
            var C = l.readASCII(a, s, 4);
            if (s += 4, C == "IHDR")
              r.decode._IHDR(a, s, u);
            else if (C == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[s + g];
              m += b;
            } else if (C == "acTL")
              u.tabs[C] = { num_frames: v(a, s), num_plays: v(a, s + 4) }, c = new Uint8Array(a.length);
            else if (C == "fcTL") {
              if (p != 0) {
                var A = u.frames[u.frames.length - 1];
                A.data = r.decode._decompress(u, c.slice(0, p), A.rect.width, A.rect.height), p = 0;
              }
              var I = { x: v(a, s + 12), y: v(a, s + 16), width: v(a, s + 4), height: v(a, s + 8) }, L = h(a, s + 22);
              L = h(a, s + 20) / (L == 0 ? 100 : L);
              var E = { rect: I, delay: Math.round(L * 1e3), dispose: a[s + 24], blend: a[s + 25] };
              u.frames.push(E);
            } else if (C == "fdAT") {
              for (var g = 0; g < b - 4; g++) c[p + g] = a[s + g + 4];
              p += b - 4;
            } else if (C == "pHYs")
              u.tabs[C] = [l.readUint(a, s), l.readUint(a, s + 4), a[s + 8]];
            else if (C == "cHRM") {
              u.tabs[C] = [];
              for (var g = 0; g < 8; g++) u.tabs[C].push(l.readUint(a, s + g * 4));
            } else if (C == "tEXt") {
              u.tabs[C] == null && (u.tabs[C] = {});
              var F = l.nextZero(a, s), U = l.readASCII(a, s, F - s), K = l.readASCII(a, F + 1, s + b - F - 1);
              u.tabs[C][U] = K;
            } else if (C == "iTXt") {
              u.tabs[C] == null && (u.tabs[C] = {});
              var F = 0, O = s;
              F = l.nextZero(a, O);
              var U = l.readASCII(a, O, F - O);
              O = F + 1, a[O], a[O + 1], O += 2, F = l.nextZero(a, O), l.readASCII(a, O, F - O), O = F + 1, F = l.nextZero(a, O), l.readUTF8(a, O, F - O), O = F + 1;
              var K = l.readUTF8(a, O, b - (O - s));
              u.tabs[C][U] = K;
            } else if (C == "PLTE")
              u.tabs[C] = l.readBytes(a, s, b);
            else if (C == "hIST") {
              var V = u.tabs.PLTE.length / 3;
              u.tabs[C] = [];
              for (var g = 0; g < V; g++) u.tabs[C].push(h(a, s + g * 2));
            } else if (C == "tRNS")
              u.ctype == 3 ? u.tabs[C] = l.readBytes(a, s, b) : u.ctype == 0 ? u.tabs[C] = h(a, s) : u.ctype == 2 && (u.tabs[C] = [h(a, s), h(a, s + 2), h(a, s + 4)]);
            else if (C == "gAMA") u.tabs[C] = l.readUint(a, s) / 1e5;
            else if (C == "sRGB") u.tabs[C] = a[s];
            else if (C == "bKGD")
              u.ctype == 0 || u.ctype == 4 ? u.tabs[C] = [h(a, s)] : u.ctype == 2 || u.ctype == 6 ? u.tabs[C] = [h(a, s), h(a, s + 2), h(a, s + 4)] : u.ctype == 3 && (u.tabs[C] = a[s]);
            else if (C == "IEND") {
              if (p != 0) {
                var A = u.frames[u.frames.length - 1];
                A.data = r.decode._decompress(u, c.slice(0, p), A.rect.width, A.rect.height), p = 0;
              }
              u.data = r.decode._decompress(u, f, u.width, u.height);
              break;
            }
            s += b, l.readUint(a, s), s += 4;
          }
          return delete u.compress, delete u.interlace, delete u.filter, u;
        }, r.decode._decompress = function(i, a, s, l) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, s, l) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return o.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var s = a.width, l = a.height, h = r.decode._getBPP(a), v = h >> 3, u = Math.ceil(s * h / 8), f = new Uint8Array(l * u), m = 0, c = [0, 0, 4, 0, 2, 0, 1], p = [0, 4, 0, 2, 0, 1, 0], x = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var C = x[b], A = g[b], I = 0, L = 0, E = c[b]; E < l; )
              E += C, L++;
            for (var F = p[b]; F < s; )
              F += A, I++;
            var U = Math.ceil(I * h / 8);
            r.decode._filterZero(i, a, m, I, L);
            for (var K = 0, O = c[b]; O < l; ) {
              for (var V = p[b], B = m + K * U << 3; V < s; ) {
                if (h == 1) {
                  var _ = i[B >> 3];
                  _ = _ >> 7 - (B & 7) & 1, f[O * u + (V >> 3)] |= _ << 7 - ((V & 3) << 0);
                }
                if (h == 2) {
                  var _ = i[B >> 3];
                  _ = _ >> 6 - (B & 7) & 3, f[O * u + (V >> 2)] |= _ << 6 - ((V & 3) << 1);
                }
                if (h == 4) {
                  var _ = i[B >> 3];
                  _ = _ >> 4 - (B & 7) & 15, f[O * u + (V >> 1)] |= _ << 4 - ((V & 1) << 2);
                }
                if (h >= 8)
                  for (var T = O * u + V * v, R = 0; R < v; R++) f[T + R] = i[(B >> 3) + R];
                B += h, V += A;
              }
              K++, O += C;
            }
            I * L != 0 && (m += L * (1 + U)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, s, l, h) {
          var v = r.decode._getBPP(a), u = Math.ceil(l * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var c = s + m * u, p = c + m + 1, x = i[p - 1];
            if (x == 0) for (var g = 0; g < u; g++) i[c + g] = i[p + g];
            else if (x == 1) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              for (var g = v; g < u; g++) i[c + g] = i[p + g] + i[c + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[c + g] = i[p + g];
              if (x == 2) for (var g = v; g < u; g++) i[c + g] = i[p + g] & 255;
              if (x == 3) for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - v] >> 1) & 255;
              if (x == 4) for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], 0, 0) & 255;
            } else {
              if (x == 2)
                for (var g = 0; g < u; g++) i[c + g] = i[p + g] + i[c + g - u] & 255;
              if (x == 3) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + (i[c + g - u] >> 1) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + (i[c + g - u] + i[c + g - v] >> 1) & 255;
              }
              if (x == 4) {
                for (var g = 0; g < v; g++) i[c + g] = i[p + g] + f(0, i[c + g - u], 0) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[p + g] + f(i[c + g - v], i[c + g - u], i[c + g - v - u]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, s) {
          var l = i + a - s, h = Math.abs(l - i), v = Math.abs(l - a), u = Math.abs(l - s);
          return h <= v && h <= u ? i : v <= u ? a : s;
        }, r.decode._IHDR = function(i, a, s) {
          var l = r._bin;
          s.width = l.readUint(i, a), a += 4, s.height = l.readUint(i, a), a += 4, s.depth = i[a], a++, s.ctype = i[a], a++, s.compress = i[a], a++, s.filter = i[a], a++, s.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, s) {
            i[a] = s >> 8 & 255, i[a + 1] = s & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, s) {
            i[a] = s >> 24 & 255, i[a + 1] = s >> 16 & 255, i[a + 2] = s >> 8 & 255, i[a + 3] = s & 255;
          },
          readASCII: function(i, a, s) {
            for (var l = "", h = 0; h < s; h++) l += String.fromCharCode(i[a + h]);
            return l;
          },
          writeASCII: function(i, a, s) {
            for (var l = 0; l < s.length; l++) i[a + l] = s.charCodeAt(l);
          },
          readBytes: function(i, a, s) {
            for (var l = [], h = 0; h < s; h++) l.push(i[a + h]);
            return l;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, s) {
            for (var l = "", h, v = 0; v < s; v++) l += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(l);
            } catch {
              return r._bin.readASCII(i, a, s);
            }
            return h;
          }
        }, r._copyTile = function(i, a, s, l, h, v, u, f, m) {
          for (var c = Math.min(a, h), p = Math.min(s, v), x = 0, g = 0, b = 0; b < p; b++)
            for (var C = 0; C < c; C++)
              if (u >= 0 && f >= 0 ? (x = b * a + C << 2, g = (f + b) * h + u + C << 2) : (x = (-f + b) * a - u + C << 2, g = b * h + C << 2), m == 0)
                l[g] = i[x], l[g + 1] = i[x + 1], l[g + 2] = i[x + 2], l[g + 3] = i[x + 3];
              else if (m == 1) {
                var A = i[x + 3] * 0.00392156862745098, I = i[x] * A, L = i[x + 1] * A, E = i[x + 2] * A, F = l[g + 3] * (1 / 255), U = l[g] * F, K = l[g + 1] * F, O = l[g + 2] * F, V = 1 - A, B = A + F * V, _ = B == 0 ? 0 : 1 / B;
                l[g + 3] = 255 * B, l[g + 0] = (I + U * V) * _, l[g + 1] = (L + K * V) * _, l[g + 2] = (E + O * V) * _;
              } else if (m == 2) {
                var A = i[x + 3], I = i[x], L = i[x + 1], E = i[x + 2], F = l[g + 3], U = l[g], K = l[g + 1], O = l[g + 2];
                A == F && I == U && L == K && E == O ? (l[g] = 0, l[g + 1] = 0, l[g + 2] = 0, l[g + 3] = 0) : (l[g] = I, l[g + 1] = L, l[g + 2] = E, l[g + 3] = A);
              } else if (m == 3) {
                var A = i[x + 3], I = i[x], L = i[x + 1], E = i[x + 2], F = l[g + 3], U = l[g], K = l[g + 1], O = l[g + 2];
                if (A == F && I == U && L == K && E == O) continue;
                if (A < 220 && F > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, s, l, h, v) {
          l == null && (l = 0), v == null && (v = !1);
          for (var u = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) u[m] = f[m];
          var c = 8, p = r._bin, x = r.crc.crc, g = p.writeUint, b = p.writeUshort, C = p.writeASCII, A = r.encode.compressPNG(i, a, s, l, v);
          g(u, c, 13), c += 4, C(u, c, "IHDR"), c += 4, g(u, c, a), c += 4, g(u, c, s), c += 4, u[c] = A.depth, c++, u[c] = A.ctype, c++, u[c] = 0, c++, u[c] = 0, c++, u[c] = 0, c++, g(u, c, x(u, c - 17, 17)), c += 4, g(u, c, 1), c += 4, C(u, c, "sRGB"), c += 4, u[c] = 1, c++, g(u, c, x(u, c - 5, 5)), c += 4;
          var I = i.length > 1;
          if (I && (g(u, c, 8), c += 4, C(u, c, "acTL"), c += 4, g(u, c, i.length), c += 4, g(u, c, 0), c += 4, g(u, c, x(u, c - 12, 12)), c += 4), A.ctype == 3) {
            var L = A.plte.length;
            g(u, c, L * 3), c += 4, C(u, c, "PLTE"), c += 4;
            for (var m = 0; m < L; m++) {
              var E = m * 3, F = A.plte[m], U = F & 255, K = F >> 8 & 255, O = F >> 16 & 255;
              u[c + E + 0] = U, u[c + E + 1] = K, u[c + E + 2] = O;
            }
            if (c += L * 3, g(u, c, x(u, c - L * 3 - 4, L * 3 + 4)), c += 4, A.gotAlpha) {
              g(u, c, L), c += 4, C(u, c, "tRNS"), c += 4;
              for (var m = 0; m < L; m++) u[c + m] = A.plte[m] >> 24 & 255;
              c += L, g(u, c, x(u, c - L - 4, L + 4)), c += 4;
            }
          }
          for (var V = 0, B = 0; B < A.frames.length; B++) {
            var _ = A.frames[B];
            I && (g(u, c, 26), c += 4, C(u, c, "fcTL"), c += 4, g(u, c, V++), c += 4, g(u, c, _.rect.width), c += 4, g(u, c, _.rect.height), c += 4, g(u, c, _.rect.x), c += 4, g(u, c, _.rect.y), c += 4, b(u, c, h[B]), c += 2, b(u, c, 1e3), c += 2, u[c] = _.dispose, c++, u[c] = _.blend, c++, g(u, c, x(u, c - 30, 30)), c += 4);
            var T = _.cimg, L = T.length;
            g(u, c, L + (B == 0 ? 0 : 4)), c += 4;
            var R = c;
            C(u, c, B == 0 ? "IDAT" : "fdAT"), c += 4, B != 0 && (g(u, c, V++), c += 4);
            for (var m = 0; m < L; m++) u[c + m] = T[m];
            c += L, g(u, c, x(u, R, c - R)), c += 4;
          }
          return g(u, c, 0), c += 4, C(u, c, "IEND"), c += 4, g(u, c, x(u, c - 4, 4)), c += 4, u.buffer.slice(0, c);
        }, r.encode.compressPNG = function(i, a, s, l, h) {
          for (var v = r.encode.compress(i, a, s, l, !1, h), u = 0; u < i.length; u++) {
            var f = v.frames[u];
            f.rect.width;
            var m = f.rect.height, c = f.bpl, p = f.bpp, x = new Uint8Array(m * c + m);
            f.cimg = r.encode._filterZero(f.img, m, p, c, x);
          }
          return v;
        }, r.encode.compress = function(i, a, s, l, h, v) {
          v == null && (v = !1);
          for (var u = 6, f = 8, m = 4, c = 255, p = 0; p < i.length; p++)
            for (var x = new Uint8Array(i[p]), g = x.length, b = 0; b < g; b += 4) c &= x[b + 3];
          var C = c != 255, A = {}, I = [];
          if (i.length != 0 && (A[0] = 0, I.push(0), l != 0 && l--), l != 0) {
            var L = r.quantize(i, l, h);
            i = L.bufs;
            for (var b = 0; b < L.plte.length; b++) {
              var E = L.plte[b].est.rgba;
              A[E] == null && (A[E] = I.length, I.push(E));
            }
          } else
            for (var p = 0; p < i.length; p++)
              for (var F = new Uint32Array(i[p]), g = F.length, b = 0; b < g; b++) {
                var E = F[b];
                if ((b < a || E != F[b - 1] && E != F[b - a]) && A[E] == null && (A[E] = I.length, I.push(E), I.length >= 300))
                  break;
              }
          var U = C ? h : !1, K = I.length;
          K <= 256 && v == !1 && (K <= 2 ? f = 1 : K <= 4 ? f = 2 : K <= 16 ? f = 4 : f = 8, h && (f = 8), C = !0);
          for (var O = [], p = 0; p < i.length; p++) {
            var V = new Uint8Array(i[p]), B = new Uint32Array(V.buffer), _ = 0, T = 0, R = a, H = s, q = 0;
            if (p != 0 && !U) {
              for (var G = h || p == 1 || O[O.length - 2].dispose == 2 ? 1 : 2, ie = 0, X = 1e9, oe = 0; oe < G; oe++) {
                for (var Fe = new Uint8Array(i[p - 1 - oe]), ue = new Uint32Array(i[p - 1 - oe]), he = a, be = s, fe = -1, we = -1, Ae = 0; Ae < s; Ae++) for (var Oe = 0; Oe < a; Oe++) {
                  var b = Ae * a + Oe;
                  B[b] != ue[b] && (Oe < he && (he = Oe), Oe > fe && (fe = Oe), Ae < be && (be = Ae), Ae > we && (we = Ae));
                }
                var We = fe == -1 ? 1 : (fe - he + 1) * (we - be + 1);
                We < X && (X = We, ie = oe, fe == -1 ? (_ = T = 0, R = H = 1) : (_ = he, T = be, R = fe - he + 1, H = we - be + 1));
              }
              var Fe = new Uint8Array(i[p - 1 - ie]);
              ie == 1 && (O[O.length - 1].dispose = 2);
              var de = new Uint8Array(R * H * 4);
              new Uint32Array(de.buffer), r._copyTile(Fe, a, s, de, R, H, -_, -T, 0), r._copyTile(V, a, s, de, R, H, -_, -T, 3) ? (r._copyTile(V, a, s, de, R, H, -_, -T, 2), q = 1) : (r._copyTile(V, a, s, de, R, H, -_, -T, 0), q = 0), V = de, B = new Uint32Array(V.buffer);
            }
            var Ne = 4 * R;
            if (K <= 256 && v == !1) {
              Ne = Math.ceil(f * R / 8);
              for (var de = new Uint8Array(Ne * H), Ae = 0; Ae < H; Ae++) {
                var b = Ae * Ne, qe = Ae * R;
                if (f == 8) for (var Oe = 0; Oe < R; Oe++) de[b + Oe] = A[B[qe + Oe]];
                else if (f == 4) for (var Oe = 0; Oe < R; Oe++) de[b + (Oe >> 1)] |= A[B[qe + Oe]] << 4 - (Oe & 1) * 4;
                else if (f == 2) for (var Oe = 0; Oe < R; Oe++) de[b + (Oe >> 2)] |= A[B[qe + Oe]] << 6 - (Oe & 3) * 2;
                else if (f == 1) for (var Oe = 0; Oe < R; Oe++) de[b + (Oe >> 3)] |= A[B[qe + Oe]] << 7 - (Oe & 7) * 1;
              }
              V = de, u = 3, m = 1;
            } else if (C == !1 && i.length == 1) {
              for (var de = new Uint8Array(R * H * 3), je = R * H, b = 0; b < je; b++) {
                var Xe = b * 3, Ve = b * 4;
                de[Xe] = V[Ve], de[Xe + 1] = V[Ve + 1], de[Xe + 2] = V[Ve + 2];
              }
              V = de, u = 2, m = 3, Ne = 3 * R;
            }
            O.push({ rect: { x: _, y: T, width: R, height: H }, img: V, bpl: Ne, bpp: m, blend: q, dispose: U ? 1 : 0 });
          }
          return { ctype: u, depth: f, plte: I, gotAlpha: C, frames: O };
        }, r.encode._filterZero = function(i, a, s, l, h) {
          for (var v = [], u = 0; u < 5; u++)
            if (!(a * l > 5e5 && (u == 2 || u == 3 || u == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, l, s, u);
              if (v.push(o.deflate(h)), s == 1) break;
            }
          for (var m, c = 1e9, p = 0; p < v.length; p++) v[p].length < c && (m = p, c = v[p].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, s, l, h, v) {
          var u = s * l, f = u + s, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var c = 0; c < l; c++) i[f + c] = a[u + c];
          else if (v == 1) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            for (var c = h; c < l; c++) i[f + c] = a[u + c] - a[u + c - h] + 256 & 255;
          } else if (s == 0) {
            for (var c = 0; c < h; c++) i[f + c] = a[u + c];
            if (v == 2) for (var c = h; c < l; c++) i[f + c] = a[u + c];
            if (v == 3) for (var c = h; c < l; c++) i[f + c] = a[u + c] - (a[u + c - h] >> 1) + 256 & 255;
            if (v == 4) for (var c = h; c < l; c++) i[f + c] = a[u + c] - m(a[u + c - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var c = 0; c < l; c++) i[f + c] = a[u + c] + 256 - a[u + c - l] & 255;
            if (v == 3) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] >> 1) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - (a[u + c - l] + a[u + c - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var c = 0; c < h; c++) i[f + c] = a[u + c] + 256 - m(0, a[u + c - l], 0) & 255;
              for (var c = h; c < l; c++) i[f + c] = a[u + c] + 256 - m(a[u + c - h], a[u + c - l], a[u + c - h - l]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var s = a, l = 0; l < 8; l++)
                s & 1 ? s = 3988292384 ^ s >>> 1 : s = s >>> 1;
              i[a] = s;
            }
            return i;
          })(),
          update: function(i, a, s, l) {
            for (var h = 0; h < l; h++) i = r.crc.table[(i ^ a[s + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, s) {
            return r.crc.update(4294967295, i, a, s) ^ 4294967295;
          }
        }, r.quantize = function(i, a, s) {
          for (var l = [], h = 0, v = 0; v < i.length; v++)
            l.push(r.encode.alphaMul(new Uint8Array(i[v]), s)), h += i[v].byteLength;
          for (var u = new Uint8Array(h), f = new Uint32Array(u.buffer), m = 0, v = 0; v < l.length; v++) {
            for (var c = l[v], p = c.length, x = 0; x < p; x++) u[m + x] = c[x];
            m += p;
          }
          var g = { i0: 0, i1: u.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(u, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var C = 0, A = 0, v = 0; v < b.length; v++) b[v].est.L > C && (C = b[v].est.L, A = v);
            if (C < 1e-3) break;
            var I = b[A], L = r.quantize.splitPixels(u, f, I.i0, I.i1, I.est.e, I.est.eMq255), E = { i0: I.i0, i1: L, bst: null, est: null, tdst: 0, left: null, right: null };
            E.bst = r.quantize.stats(u, E.i0, E.i1), E.est = r.quantize.estats(E.bst);
            var F = { i0: L, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            F.bst = { R: [], m: [], N: I.bst.N - E.bst.N };
            for (var v = 0; v < 16; v++) F.bst.R[v] = I.bst.R[v] - E.bst.R[v];
            for (var v = 0; v < 4; v++) F.bst.m[v] = I.bst.m[v] - E.bst.m[v];
            F.est = r.quantize.estats(F.bst), I.left = E, I.right = F, b[A] = E, b.push(F);
          }
          b.sort(function(G, ie) {
            return ie.bst.N - G.bst.N;
          });
          for (var U = 0; U < l.length; U++) {
            for (var K = r.quantize.planeDst, O = new Uint8Array(l[U].buffer), V = new Uint32Array(l[U].buffer), B = O.length, v = 0; v < B; v += 4) {
              for (var _ = O[v] * 0.00392156862745098, T = O[v + 1] * (1 / 255), R = O[v + 2] * (1 / 255), H = O[v + 3] * (1 / 255), q = g; q.left; ) q = K(q.est, _, T, R, H) <= 0 ? q.left : q.right;
              V[v >> 2] = q.est.rgba;
            }
            l[U] = V.buffer;
          }
          return { bufs: l, plte: b };
        }, r.quantize.getNearest = function(i, a, s, l, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, s, l, h), i;
          var v = r.quantize.planeDst(i.est, a, s, l, h), u = i.left, f = i.right;
          v > 0 && (u = i.right, f = i.left);
          var m = r.quantize.getNearest(u, a, s, l, h);
          if (m.tdst <= v * v) return m;
          var c = r.quantize.getNearest(f, a, s, l, h);
          return c.tdst < m.tdst ? c : m;
        }, r.quantize.planeDst = function(i, a, s, l, h) {
          var v = i.e;
          return v[0] * a + v[1] * s + v[2] * l + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, s, l, h) {
          var v = a - i[0], u = s - i[1], f = l - i[2], m = h - i[3];
          return v * v + u * u + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, s, l, h, v) {
          var u = r.quantize.vecDot;
          for (l -= 4; s < l; ) {
            for (; u(i, s, h) <= v; ) s += 4;
            for (; u(i, l, h) > v; ) l -= 4;
            if (s >= l) break;
            var f = a[s >> 2];
            a[s >> 2] = a[l >> 2], a[l >> 2] = f, s += 4, l -= 4;
          }
          for (; u(i, s, h) > v; ) s -= 4;
          return s + 4;
        }, r.quantize.vecDot = function(i, a, s) {
          return i[a] * s[0] + i[a + 1] * s[1] + i[a + 2] * s[2] + i[a + 3] * s[3];
        }, r.quantize.stats = function(i, a, s) {
          for (var l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = s - a >> 2, u = a; u < s; u += 4) {
            var f = i[u] * 0.00392156862745098, m = i[u + 1] * (1 / 255), c = i[u + 2] * (1 / 255), p = i[u + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += c, h[3] += p, l[0] += f * f, l[1] += f * m, l[2] += f * c, l[3] += f * p, l[5] += m * m, l[6] += m * c, l[7] += m * p, l[10] += c * c, l[11] += c * p, l[15] += p * p;
          }
          return l[4] = l[1], l[8] = l[2], l[12] = l[3], l[9] = l[6], l[13] = l[7], l[14] = l[11], { R: l, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, s = i.m, l = i.N, h = s[0], v = s[1], u = s[2], f = s[3], m = l == 0 ? 0 : 1 / l, c = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * u * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * u * m,
            a[7] - v * f * m,
            a[8] - u * h * m,
            a[9] - u * v * m,
            a[10] - u * u * m,
            a[11] - u * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * u * m,
            a[15] - f * f * m
          ], p = c, x = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, C = 0;
          if (l != 0)
            for (var A = 0; A < 10 && (g = x.multVec(p, g), C = Math.sqrt(x.dot(g, g)), g = x.sml(1 / C, g), !(Math.abs(C - b) < 1e-9)); A++)
              b = C;
          var I = [h * m, v * m, u * m, f * m], L = x.dot(x.sml(255, I), g), E = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: c,
            q: I,
            e: g,
            L: b,
            eMq255: L,
            eMq: x.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * E) << 16 | Math.round(255 * I[1] * E) << 8 | Math.round(255 * I[0] * E) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var s = new Uint8Array(i.length), l = i.length >> 2, h = 0; h < l; h++) {
            var v = h << 2, u = i[v + 3];
            a && (u = u < 128 ? 0 : 255);
            var f = u * (1 / 255);
            s[v + 0] = i[v + 0] * f, s[v + 1] = i[v + 1] * f, s[v + 2] = i[v + 2] * f, s[v + 3] = u;
          }
          return s;
        };
      })(t, n);
    })();
  })($r)), $r.exports;
}
var Zh = jh();
const Wh = /* @__PURE__ */ Mh(Zh), Xh = () => ya() ? Pa("NuxtImg") : "img", Yh = ["alt", "src"], g2 = /* @__PURE__ */ Se({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = nt("wrapper"), i = Xh(), a = pe(!0), s = W(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), l = W(() => o.value?.clientHeight ?? 0), h = W(() => o.value?.clientWidth ?? 0), v = W(() => e.loading || a.value), u = W(() => {
      if (!e.blurHash) return;
      const m = Oh(e.blurHash, 32, 32), c = new Uint8Array(m), p = Wh.encode([c.buffer], 32, 32, 256);
      return "data:image/png;base64," + Eh(p);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: l,
      clientWidth: h
    }), (m, c) => ($(), j("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Et({ "--image-aspect-ratio": s.value })
    }, [
      ($(), xe(Nt(Z(i)), Ce({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: c[0] || (c[0] = (p) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      u.value ? ($(), xe(kn, {
        key: 0,
        name: "lc-image__transition",
        persisted: ""
      }, {
        default: _e(() => [
          Qt(ne("img", Ce({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: u.value
          }), null, 16, Yh), [
            [ui, v.value]
          ])
        ]),
        _: 1
      })) : se("", !0)
    ], 4));
  }
}), Gh = "medium", Kh = "medium", b2 = ["center", "top"], p2 = ["medium", "small"], Jh = {
  key: 1,
  class: "lc-info-text__content"
}, Qh = {
  key: 0,
  class: "lc-info-text__text"
}, y2 = /* @__PURE__ */ Se({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: () => Gh },
    size: { default: () => Kh },
    text: {}
  },
  setup(e) {
    const t = cn(), n = W(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = W(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (o, i) => ($(), j("article", {
      class: ye(n.value)
    }, [
      Re(Z(Je), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ne("section", null, [
        e.headline ? ($(), j("span", {
          key: 0,
          class: ye(r.value)
        }, Ie(e.headline), 3)) : se("", !0),
        e.text || o.$slots.default ? ($(), j("div", Jh, [
          ve(o.$slots, "default", {}, () => [
            e.text ? ($(), j("p", Qh, Ie(e.text), 1)) : se("", !0)
          ])
        ])) : se("", !0)
      ])
    ], 2));
  }
}), ev = { class: "lc-link-list" }, w2 = /* @__PURE__ */ Se({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => ($(), j("ul", ev, [
      ve(t.$slots, "default")
    ]));
  }
}), tv = { key: 0 }, nv = { class: "lc-link-list-item__headline" }, av = {
  key: 0,
  class: "lc-link-list-item__text"
}, x2 = /* @__PURE__ */ Se({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = W(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => ($(), j("li", {
      class: ye(t.value)
    }, [
      Re(Z(fi), Ce({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: _e(() => [
          n.$slots.default ? ($(), j("div", tv, [
            ve(n.$slots, "default")
          ])) : ($(), j(rt, { key: 1 }, [
            e.icon ? ($(), xe(Z(Je), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : se("", !0),
            ne("div", null, [
              ne("span", nv, Ie(e.headline), 1),
              e.text ? ($(), j("p", av, Ie(e.text), 1)) : se("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), rv = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", iv = { class: "lc-lottery-cutoff-time__headline" }, lv = ["src"], ov = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, sv = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, cv = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, uv = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, dv = 1e3, jl = /* @__PURE__ */ Se({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => Ze.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => Ze.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => Ze.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => Ze.lcLotteryCutoffTime.textTimeToCutoff },
    timeZone: {},
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = jo(), o = pe(!1), i = pe(/* @__PURE__ */ new Date());
    ko(
      () => {
        i.value = /* @__PURE__ */ new Date();
      },
      dv,
      { immediate: !r }
    );
    const a = W(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": u.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), s = W(() => new Date(e.cutoffTime)), l = W(
      () => Wo({
        date: f.value,
        format: "drawingShort",
        locale: e.locale,
        timeZone: e.timeZone
      })
    ), h = W(
      () => qa(s.value) && s.value.getTime() <= i.value.getTime()
    ), v = W(() => m("days") === 0), u = W(() => {
      const p = m("minutes");
      return v.value && p ? p < e.startAnimationTime : !1;
    }), f = W(
      () => h.value && e.nextCutoffTime ? new Date(e.nextCutoffTime) : s.value
    ), m = (p) => {
      if (!qa(s.value)) return null;
      const { days: x = 0, hours: g = 0, minutes: b = 0 } = Zo(i.value, s.value);
      switch (p) {
        case "days":
          return x;
        case "minutes":
          return x * 24 + g * 60 + b;
      }
    }, c = () => {
      r || o.value || (o.value = !0, n("cutoff-time-reached"));
    };
    return He(
      [() => e.cutoffTime, h],
      ([p], [x]) => {
        p !== x && (o.value = !1), h.value && c();
      },
      { immediate: !0 }
    ), (p, x) => ($(), j("div", {
      class: ye(a.value)
    }, [
      ne("span", iv, [
        u.value ? ($(), j("img", {
          key: 0,
          alt: "",
          height: "16",
          src: Z(rv),
          width: "16"
        }, null, 8, lv)) : ($(), xe(Z(Je), {
          key: 1,
          name: v.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        ve(p.$slots, "title", {}, () => [
          ne("span", ov, Ie(v.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ne("span", sv, Ie(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? ($(), j("span", cv, " : ")) : se("", !0),
      ne("div", uv, [
        v.value ? ($(), xe(Z(Cf), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": f.value,
          variant: e.countdownVariant,
          onExpired: c
        }, null, 8, ["expires-at", "variant"])) : ($(), xe(Z(Mo), Ce({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...Z(yi).drawingShort }, { datetime: f.value }), {
          default: _e(() => [
            kt(Ie(l.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), k2 = ["default", "expressive"], fv = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, hv = {
  key: 1,
  class: "lc-lottery-numbers__value"
}, vv = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, mv = "extra", gv = /* @__PURE__ */ Se({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "small" }
  },
  setup(e) {
    const t = W(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = W(() => o.value.flat().length), r = W(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), o = W(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: s, ignored: l, matching: h, value: v }) => ({
          empty: !s && !l && (v === void 0 || v === ""),
          icon: s,
          ignored: l,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => ($(), j("article", {
      class: ye(t.value),
      style: Et({ "--items-per-row": r.value })
    }, [
      ne("ol", {
        class: ye(["lc-lottery-numbers__list", e.listClass])
      }, [
        ($(!0), j(rt, null, yt(o.value, (s, l) => ($(), j(rt, { key: l }, [
          ($(!0), j(rt, null, yt(s, ({ empty: h, icon: v, ignored: u, matching: f, name: m, number: c }, p) => ($(), j(rt, {
            key: `${l}-${p}`
          }, [
            ne("li", {
              class: "lc-lottery-numbers__list-item",
              style: Et({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              ve(i.$slots, `highlight-${m}`),
              ne("div", {
                class: ye(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === mv,
                    "lc-lottery-numbers__number--ignored": u
                  },
                  e.numberClass ? e.numberClass(c, m) : ""
                ]])
              }, [
                f ? ($(), j("div", fv, [
                  Re(Z(Je), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : se("", !0),
                ve(i.$slots, `number-${m}`, Ce({ ref_for: !0 }, { icon: v, number: c }), () => [
                  v ? ($(), xe(Z(Je), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : ($(), j("span", hv, Ie(u ? "X" : c), 1))
                ])
              ], 2)
            ], 4),
            l < o.value.length - 1 && p === s.length - 1 && i.$slots["field-divider"] ? ($(), j("li", vv, [
              ve(i.$slots, "field-divider")
            ])) : se("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), S2 = ["large", "medium", "small"], _2 = ["medium", "small"], C2 = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var Zt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(Zt || {});
const bv = ["id"], pv = { class: "lc-lottery-number-selector__label" }, yv = ["for"], wv = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], E2 = /* @__PURE__ */ Se({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    highlightedNumbers: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    numberClass: { type: Function },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = tr(), o = nt("numberInputs"), i = $t(e.id), a = pe(e.fixedColumns ?? 0), s = pe(0), l = W(() => A(s.value)), h = W(
      () => u.value ? c.value : f.value
    ), v = W(() => E(s.value)), u = W(() => e.value.length >= e.selectableMax), f = W(() => {
      const X = Array.from({ length: b.value }, () => []);
      return m.value.map((oe, ue) => {
        X[E(ue)].push(ue);
      }), T(X);
    }), m = W(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (X, oe) => e.min + oe);
    }), c = W(
      () => f.value.map(
        (X) => X.map(
          (oe) => p.value.includes(oe) ? oe : -1
        )
      )
    ), p = W(() => e.value.map((X) => m.value.indexOf(X))), x = W(() => Math.min(g.value, a.value)), g = W(() => m.value.length), b = W(() => Math.ceil(g.value / x.value)), C = (X) => {
      const oe = h.value.length, ue = h.value[0].length;
      let he = v.value, be = l.value;
      do
        switch (X) {
          case "down":
            he = (he + 1) % oe, he === 0 && (be = (be + 1) % ue);
            break;
          case "left":
            be = (be - 1 + ue) % ue, be === ue - 1 && (he = (he - 1 + oe) % oe);
            break;
          case "right":
            be = (be + 1) % ue, be === 0 && (he = (he + 1) % oe);
            break;
          case "up":
            he = (he - 1 + oe) % oe, he === oe - 1 && (be = (be - 1 + ue) % ue);
            break;
        }
      while (h.value[he][be] === -1);
      return h.value[he][be];
    }, A = (X) => X % x.value, I = (X) => `gridcell-${X}-${i}`, L = (X) => [
      {
        "lc-lottery-number-selector__number": !0,
        "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
        "lc-lottery-number-selector__number--checked": R(X),
        "lc-lottery-number-selector__number--disabled": q(X),
        "lc-lottery-number-selector__number--highlighted": H(X)
      },
      e.numberClass?.(X) ?? ""
    ], E = (X) => Math.floor(X / x.value), F = () => {
      if (u.value) {
        const ue = f.value[v.value].filter(
          (he) => he > s.value && p.value.includes(he)
        ).reverse();
        if (!ue.length) return;
        s.value = ue[0];
        return;
      }
      const X = f.value[v.value];
      s.value = X.at(-1) ?? 0;
    }, U = () => {
      if (u.value) {
        const ue = f.value[v.value].filter(
          (he) => he < s.value && p.value.includes(he)
        );
        if (!ue.length) return;
        s.value = ue[0];
        return;
      }
      const X = f.value[v.value];
      s.value = X[0];
    }, K = () => {
      s.value = u.value ? p.value[0] : 0;
    }, O = () => {
      const X = p.value.at(-1) ?? 0;
      s.value = u.value ? X : g.value - 1;
    }, V = (X) => {
      tn(X.key, Zt) && (X.preventDefault(), X.stopPropagation(), X.ctrlKey ? B(X.key) : _(X.key));
    }, B = (X) => {
      switch (X) {
        case Zt.End:
          O();
          break;
        case Zt.Home:
          K();
          break;
      }
    }, _ = (X) => {
      switch (X) {
        case Zt.ArrowDown:
          s.value = C("down");
          break;
        case Zt.ArrowLeft:
          s.value = C("left");
          break;
        case Zt.ArrowRight:
          s.value = C("right");
          break;
        case Zt.ArrowUp:
          s.value = C("up");
          break;
        case Zt.End:
          F();
          break;
        case Zt.Home:
          U();
          break;
      }
    }, T = (X) => {
      const oe = Math.max(...X.map((ue) => ue.length));
      return X.map((ue) => {
        const he = [...ue];
        for (; he.length < oe; )
          he.push(-1);
        return he;
      });
    }, R = (X) => e.value.includes(X), H = (X) => !!e.highlightedNumbers?.includes(X), q = (X) => e.disabled || !R(X) && u.value || e.allNumbersToggled, G = (X) => {
      const oe = [...e.value], ue = oe.indexOf(X);
      ue > -1 ? oe.splice(ue, 1) : u.value || (oe.push(X), oe.sort((he, be) => m.value.indexOf(he) - m.value.indexOf(be))), n("update:value", oe);
    };
    He(
      () => e.allNumbersToggled,
      () => {
        const X = e.allNumbersToggled ? m.value : [];
        n("update:value", X);
      }
    ), He(s, (X) => {
      o.value?.[X].focus();
    }), He(u, (X) => {
      X && n("complete");
    });
    const ie = dc(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const X = o.value;
      if (!r || !X?.length) return;
      const oe = X[0].getBoundingClientRect().top;
      let ue = 0;
      for (const he of X) {
        if (he.getBoundingClientRect().top !== oe) break;
        ue++;
      }
      a.value = ue;
    }, 100);
    return He(() => e.fixedColumns, ie), St(ie), qt(window, "resize", ie), (X, oe) => ($(), j("fieldset", Ce(X.$attrs, {
      id: Z(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ne("legend", pv, Ie(e.label), 1),
      ($(!0), j(rt, null, yt(m.value, (ue, he) => ($(), j("label", {
        key: ue,
        class: ye(L(ue)),
        for: I(he)
      }, [
        ne("input", {
          id: I(he),
          ref_for: !0,
          ref: "numberInputs",
          checked: R(ue),
          class: "lc-lottery-number-selector__input",
          disabled: q(ue),
          tabindex: s.value === he || R(ue) ? 0 : -1,
          type: "checkbox",
          onChange: () => G(ue),
          onFocusin: (be) => s.value = he,
          onKeydown: [
            V,
            ci(() => G(ue), ["enter"])
          ]
        }, null, 40, wv),
        ve(X.$slots, "cell", Ce({ ref_for: !0 }, {
          checked: R(ue),
          disabled: q(ue),
          number: ue
        }), () => [
          kt(Ie(ue), 1)
        ])
      ], 10, yv))), 128))
    ], 16, bv));
  }
}), xv = { class: "w-full" }, kv = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, Sv = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, _v = { class: "lc-lottery-teaser__button-container" }, Cv = { class: "lc-lottery-teaser__button-wrap" }, Ev = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, Tv = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, Av = { class: "lc-lottery-teaser__draw-date-headline" }, T2 = /* @__PURE__ */ Se({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => Ze.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = cn(), n = W(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": o.value
      }
    ]), r = W(
      () => Wo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), o = W(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = W(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (a, s) => ($(), xe(Z(lr), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Ka({
      header: _e(() => [
        ve(a.$slots, "lottery-logo")
      ]),
      default: _e(() => [
        e.variant === "expressive" ? ($(), xe(Z(jl), Ce({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: s[0] || (s[0] = (l) => a.$emit("outdated"))
        }), null, 16)) : se("", !0),
        ne("section", xv, [
          ($(), xe(Nt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: _e(() => [
              e.headline ? ($(), j("strong", kv, Ie(e.headline), 1)) : se("", !0),
              Re(Z(ts), Ce(e.jackpot, { size: "small" }), null, 16),
              e.subline ? ($(), j("strong", Sv, Ie(e.subline), 1)) : se("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", _v, [
          ne("div", Cv, [
            ve(a.$slots, "primary-button", {}, () => [
              Re(Z(Tt), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: o.value ? "primary-ghost" : "primary",
                onClick: s[1] || (s[1] = (l) => a.$emit("primary-button-click"))
              }), {
                default: _e(() => [
                  kt(Ie(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          o.value ? ($(), j("div", Ev, [
            ve(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? ($(), xe(Z(Tt), Ce({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: s[2] || (s[2] = (l) => a.$emit("secondary-button-click"))
              }), {
                default: _e(() => [
                  kt(Ie(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : se("", !0)
            ])
          ])) : se("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: _e(() => [
          ["default", "badge"].includes(e.variant) ? ($(), j("div", Tv, [
            ne("div", Av, [
              Re(Z(Je), {
                name: "calendar",
                size: "small"
              }),
              ne("span", null, Ie(e.drawDateHeadline), 1)
            ]),
            Re(Z(Mo), Ce({ locale: e.locale, ...Z(yi).drawingShort }, { datetime: e.drawDate }), {
              default: _e(() => [
                kt(Ie(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : se("", !0),
          Re(Z(jl), Ce({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: s[3] || (s[3] = (l) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), A2 = [...as, "expressive"], Lv = { class: "lc-masked-value-display" }, L2 = /* @__PURE__ */ Se({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => ($(), j("span", Lv, [
      ($(!0), j(rt, null, yt(e.parts, (r) => ($(), j("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        ($(!0), j(rt, null, yt(e.masksPerPart, (o) => ($(), j("span", {
          key: o,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      ve(t.$slots, "default")
    ]));
  }
}), ti = Math.min, Vn = Math.max, Za = Math.round, Oa = Math.floor, Jt = (e) => ({
  x: e,
  y: e
}), $v = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Wn(e) {
  return e.split("-")[0];
}
function or(e) {
  return e.split("-")[1];
}
function Iv(e) {
  return e === "x" ? "y" : "x";
}
function us(e) {
  return e === "y" ? "height" : "width";
}
function xn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function ds(e) {
  return Iv(xn(e));
}
function Dv(e, t, n) {
  n === void 0 && (n = !1);
  const r = or(e), o = ds(e), i = us(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Wa(a)), [a, Wa(a)];
}
function Ov(e) {
  const t = Wa(e);
  return [ni(e), t, ni(t)];
}
function ni(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Zl = ["left", "right"], Wl = ["right", "left"], Mv = ["top", "bottom"], Rv = ["bottom", "top"];
function Nv(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Wl : Zl : t ? Zl : Wl;
    case "left":
    case "right":
      return t ? Mv : Rv;
    default:
      return [];
  }
}
function Fv(e, t, n, r) {
  const o = or(e);
  let i = Nv(Wn(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(ni)))), i;
}
function Wa(e) {
  const t = Wn(e);
  return $v[t] + e.slice(t.length);
}
function Pv(e) {
  var t, n, r, o;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (o = e.left) != null ? o : 0
  };
}
function Bv(e) {
  return typeof e != "number" ? Pv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xa(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Xl(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = xn(t), a = ds(t), s = us(a), l = Wn(t), h = i === "y", v = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, f = r[s] / 2 - o[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: v,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const c = or(t);
  return c && (m[a] += f * (c === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function zv(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = xi(t, e), c = Bv(m), x = s[f ? u === "floating" ? "reference" : "floating" : u], g = Xa(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(x))) == null || n ? x : x.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: l
  })), b = u === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), A = await (i.isElement == null ? void 0 : i.isElement(C)) && await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  }, I = Xa(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: C,
    strategy: l
  }) : b);
  return {
    top: (g.top - I.top + c.top) / A.y,
    bottom: (I.bottom - g.bottom + c.bottom) / A.y,
    left: (g.left - I.left + c.left) / A.x,
    right: (I.right - g.right + c.right) / A.x
  };
}
const Vv = 50, Hv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = a.detectOverflow ? a : {
    ...a,
    detectOverflow: zv
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: v,
    y: u
  } = Xl(h, r, l), f = r, m = 0;
  const c = {};
  for (let p = 0; p < i.length; p++) {
    const x = i[p];
    if (!x)
      continue;
    const {
      name: g,
      fn: b
    } = x, {
      x: C,
      y: A,
      data: I,
      reset: L
    } = await b({
      x: v,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: c,
      rects: h,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = C ?? v, u = A ?? u, c[g] = {
      ...c[g],
      ...I
    }, L && m < Vv && (m++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (h = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : L.rects), {
      x: v,
      y: u
    } = Xl(h, f, l)), p = -1);
  }
  return {
    x: v,
    y: u,
    placement: f,
    strategy: o,
    middlewareData: c
  };
}, Uv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: p = !0,
        ...x
      } = xi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = Wn(o), b = xn(s), C = Wn(s) === s, A = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), I = f || (C || !p ? [Wa(s)] : Ov(s)), L = c !== "none";
      !f && L && I.push(...Fv(s, p, c, A));
      const E = [s, ...I], F = await l.detectOverflow(t, x), U = [];
      let K = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && U.push(F[g]), u) {
        const _ = Dv(o, a, A);
        U.push(F[_[0]], F[_[1]]);
      }
      if (K = [...K, {
        placement: o,
        overflows: U
      }], !U.every((_) => _ <= 0)) {
        var O, V;
        const _ = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, T = E[_];
        if (T && (!(u === "alignment" ? b !== xn(T) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        K.every((q) => xn(q.placement) === b ? q.overflows[0] > 0 : !0)))
          return {
            data: {
              index: _,
              overflows: K
            },
            reset: {
              placement: T
            }
          };
        let R = (V = K.filter((H) => H.overflows[0] <= 0).sort((H, q) => H.overflows[1] - q.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!R)
          switch (m) {
            case "bestFit": {
              var B;
              const H = (B = K.filter((q) => {
                if (L) {
                  const G = xn(q.placement);
                  return G === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  G === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((G) => G > 0).reduce((G, ie) => G + ie, 0)]).sort((q, G) => q[1] - G[1])[0]) == null ? void 0 : B[0];
              H && (R = H);
              break;
            }
            case "initialPlacement":
              R = s;
              break;
          }
        if (o !== R)
          return {
            reset: {
              placement: R
            }
          };
      }
      return {};
    }
  };
}, qv = /* @__PURE__ */ new Set(["left", "top"]);
async function jv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Wn(n), s = or(n), l = xn(n) === "y", h = qv.has(a) ? -1 : 1, v = i && l ? -1 : 1, u = xi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: c
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof c == "number" && (m = s === "end" ? c * -1 : c), l ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const Zv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await jv(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
};
function sr() {
  return typeof window < "u";
}
function On(e) {
  return ki(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Mt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nn(e) {
  var t;
  return (t = (ki(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ki(e) {
  return sr() ? e instanceof Node || e instanceof Mt(e).Node : !1;
}
function Xt(e) {
  return sr() ? e instanceof Element || e instanceof Mt(e).Element : !1;
}
function fn(e) {
  return sr() ? e instanceof HTMLElement || e instanceof Mt(e).HTMLElement : !1;
}
function Yl(e) {
  return !sr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Mt(e).ShadowRoot;
}
function cr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Yt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function Wv(e) {
  return /^(table|td|th)$/.test(On(e));
}
function ur(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Xv = /transform|translate|scale|rotate|perspective|filter/, Yv = /paint|layout|strict|content/, pn = (e) => !!e && e !== "none";
let Vr;
function Si(e) {
  const t = Xt(e) ? Yt(e) : e;
  return pn(t.transform) || pn(t.translate) || pn(t.scale) || pn(t.rotate) || pn(t.perspective) || !_i() && (pn(t.backdropFilter) || pn(t.filter)) || Xv.test(t.willChange || "") || Yv.test(t.contain || "");
}
function Gv(e) {
  let t = An(e);
  for (; fn(t) && !ma(t); ) {
    if (Si(t))
      return t;
    if (ur(t))
      return null;
    t = An(t);
  }
  return null;
}
function _i() {
  return Vr == null && (Vr = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Vr;
}
function ma(e) {
  return /^(html|body|#document)$/.test(On(e));
}
function Yt(e) {
  return Mt(e).getComputedStyle(e);
}
function dr(e) {
  return Xt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function An(e) {
  if (On(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Yl(e) && e.host || // Fallback.
    nn(e)
  );
  return Yl(t) ? t.host : t;
}
function fs(e) {
  const t = An(e);
  return ma(t) ? (e.ownerDocument || e).body : fn(t) && cr(t) ? t : fs(t);
}
function ga(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = fs(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Mt(o);
  if (i) {
    const s = ai(a);
    return t.concat(a, a.visualViewport || [], cr(o) ? o : [], s && n ? ga(s) : []);
  } else
    return t.concat(o, ga(o, [], n));
}
function ai(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hs(e) {
  const t = Yt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = fn(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Za(n) !== i || Za(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Ci(e) {
  return Xt(e) ? e : e.contextElement;
}
function Hn(e) {
  const t = Ci(e);
  if (!fn(t))
    return Jt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = hs(t);
  let a = (i ? Za(n.width) : n.width) / r, s = (i ? Za(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const Kv = /* @__PURE__ */ Jt(0);
function vs(e) {
  const t = Mt(e);
  return !_i() || !t.visualViewport ? Kv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Jv(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === Mt(e);
}
function Ln(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Ci(e);
  let a = Jt(1);
  t && (r ? Xt(r) && (a = Hn(r)) : a = Hn(e));
  const s = Jv(i, n, r) ? vs(i) : Jt(0);
  let l = (o.left + s.x) / a.x, h = (o.top + s.y) / a.y, v = o.width / a.x, u = o.height / a.y;
  if (i && r) {
    const f = Mt(i), m = Xt(r) ? Mt(r) : r;
    let c = f, p = ai(c);
    for (; p && m !== c; ) {
      const x = Hn(p), g = p.getBoundingClientRect(), b = Yt(p), C = g.left + (p.clientLeft + parseFloat(b.paddingLeft)) * x.x, A = g.top + (p.clientTop + parseFloat(b.paddingTop)) * x.y;
      l *= x.x, h *= x.y, v *= x.x, u *= x.y, l += C, h += A, c = Mt(p), p = ai(c);
    }
  }
  return Xa({
    width: v,
    height: u,
    x: l,
    y: h
  });
}
function fr(e, t) {
  const n = dr(e).scrollLeft;
  return t ? t.left + n : Ln(nn(e)).left + n;
}
function ms(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - fr(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Qv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = nn(r), s = t ? ur(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Jt(1);
  const v = Jt(0), u = fn(r);
  if ((u || !i) && ((On(r) !== "body" || cr(a)) && (l = dr(r)), u)) {
    const m = Ln(r);
    h = Hn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !u && !i ? ms(a, l) : Jt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - l.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - l.scrollTop * h.y + v.y + f.y
  };
}
function em(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function tm(e) {
  const t = dr(e), n = e.ownerDocument.body, r = Vn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), o = Vn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + fr(e);
  const a = -t.scrollTop;
  return Yt(n).direction === "rtl" && (i += Vn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: a
  };
}
const nm = 25;
function am(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", o = Mt(e), i = nn(e), a = o.visualViewport;
  let s = i.clientWidth, l = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !_i() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (s = a.width, l = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (fr(i) <= 0) {
    const f = i.ownerDocument, m = f.body, c = getComputedStyle(m), p = f.compatMode === "CSS1Compat" && parseFloat(c.marginLeft) + parseFloat(c.marginRight) || 0, x = Math.abs(i.clientWidth - m.clientWidth - p), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? x / 2 : x;
    g <= nm && (s -= g);
  }
  return {
    width: s,
    height: l,
    x: h,
    y: v
  };
}
function rm(e, t) {
  const n = Ln(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Hn(e), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, h = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: h
  };
}
function Gl(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = am(e, n, t);
  else if (t === "document")
    r = tm(nn(e));
  else if (Xt(t))
    r = rm(t, n);
  else {
    const o = vs(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Xa(r);
}
function im(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ga(e, [], !1).filter((s) => Xt(s) && On(s) !== "body"), o = null;
  const i = Yt(e).position === "fixed";
  let a = i ? An(e) : e;
  for (; Xt(a) && !ma(a); ) {
    const s = Yt(a), l = Si(a), h = o ? o.position : i ? "fixed" : "";
    !l && (h === "fixed" || h === "absolute" && s.position === "static") ? r = r.filter((u) => u !== a) : o = s, a = An(a);
  }
  return t.set(e, r), r;
}
function lm(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? ur(t) ? [] : im(t, this._c) : [].concat(n), r], s = Gl(t, a[0], o);
  let l = s.top, h = s.right, v = s.bottom, u = s.left;
  for (let f = 1; f < a.length; f++) {
    const m = Gl(t, a[f], o);
    l = Vn(m.top, l), h = ti(m.right, h), v = ti(m.bottom, v), u = Vn(m.left, u);
  }
  return {
    width: h - u,
    height: v - l,
    x: u,
    y: l
  };
}
function om(e) {
  const {
    width: t,
    height: n
  } = hs(e);
  return {
    width: t,
    height: n
  };
}
function sm(e, t, n) {
  const r = fn(t), o = nn(t), i = n === "fixed", a = Ln(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jt(0);
  if ((r || !i) && ((On(t) !== "body" || cr(o)) && (s = dr(t)), r)) {
    const f = Ln(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && o && (l.x = fr(o));
  const h = o && !r && !i ? ms(o, s) : Jt(0), v = a.left + s.scrollLeft - l.x - h.x, u = a.top + s.scrollTop - l.y - h.y;
  return {
    x: v,
    y: u,
    width: a.width,
    height: a.height
  };
}
function Hr(e) {
  return Yt(e).position === "static";
}
function Kl(e, t) {
  if (!fn(e) || Yt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return nn(e) === n && (n = n.ownerDocument.body), n;
}
function gs(e, t) {
  const n = Mt(e);
  if (ur(e))
    return n;
  if (!fn(e)) {
    let o = An(e);
    for (; o && !ma(o); ) {
      if (Xt(o) && !Hr(o))
        return o;
      o = An(o);
    }
    return n;
  }
  let r = Kl(e, t);
  for (; r && Wv(r) && Hr(r); )
    r = Kl(r, t);
  return r && ma(r) && Hr(r) && !Si(r) ? n : r || Gv(e) || n;
}
const cm = async function(e) {
  const t = this.getOffsetParent || gs, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: sm(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function um(e) {
  return Yt(e).direction === "rtl";
}
const dm = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Qv,
  getDocumentElement: nn,
  getClippingRect: lm,
  getOffsetParent: gs,
  getElementRects: cm,
  getClientRects: em,
  getDimensions: om,
  getScale: Hn,
  isElement: Xt,
  isRTL: um
};
function bs(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function fm(e, t, n) {
  let r = null, o;
  const i = nn(e);
  function a() {
    var v;
    clearTimeout(o), (v = r) == null || v.disconnect(), r = null;
  }
  function s(v, u) {
    v === void 0 && (v = !1), u === void 0 && (u = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: p,
      height: x
    } = f;
    if (v || t(), !p || !x)
      return;
    const g = Oa(c), b = Oa(i.clientWidth - (m + p)), C = Oa(i.clientHeight - (c + x)), A = Oa(m), L = {
      rootMargin: -g + "px " + -b + "px " + -C + "px " + -A + "px",
      threshold: Vn(0, ti(1, u)) || 1
    };
    let E = !0;
    function F(U) {
      const K = U[0].intersectionRatio;
      if (!bs(f, e.getBoundingClientRect()))
        return s();
      if (K !== u) {
        if (!E)
          return s();
        K ? s(!1, K) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E = !1;
    }
    try {
      r = new IntersectionObserver(F, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(F, L);
    }
    r.observe(e);
  }
  const l = Mt(e), h = () => s(n);
  return l.addEventListener("resize", h), s(!0), () => {
    l.removeEventListener("resize", h), a();
  };
}
function ps(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, h = Ci(e), v = o || i ? [...h ? ga(h) : [], ...t ? ga(t) : []] : [];
  v.forEach((g) => {
    o && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const u = h && s ? fm(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = m) == null || C.observe(t);
    })), n();
  }), h && !l && m.observe(h), t && m.observe(t));
  let c, p = l ? Ln(e) : null;
  l && x();
  function x() {
    const g = Ln(e);
    p && !bs(p, g) && n(), p = g, c = requestAnimationFrame(x);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), u?.(), (g = m) == null || g.disconnect(), m = null, l && cancelAnimationFrame(c);
  };
}
const ys = Zv, ws = Uv, hm = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = n ?? {}, i = {
    ...dm,
    ...o.platform,
    _c: r
  };
  return Hv(e, t, {
    ...o,
    platform: i
  });
};
function vm(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Jl(e) {
  if (vm(e)) {
    const t = e.$el;
    return ki(t) && On(t) === "#comment" ? null : t;
  }
  return e;
}
function xs(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ql(e, t) {
  const n = xs(e);
  return Math.round(t * n) / n;
}
function ks(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, o = W(() => {
    var E;
    return (E = at(n.open)) != null ? E : !0;
  }), i = W(() => at(n.middleware)), a = W(() => {
    var E;
    return (E = at(n.placement)) != null ? E : "bottom";
  }), s = W(() => {
    var E;
    return (E = at(n.strategy)) != null ? E : "absolute";
  }), l = W(() => {
    var E;
    return (E = at(n.transform)) != null ? E : !0;
  }), h = W(() => Jl(e.value)), v = W(() => Jl(t.value)), u = pe(0), f = pe(0), m = pe(s.value), c = pe(a.value), p = _n({}), x = pe(!1), g = W(() => {
    const E = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return E;
    const F = Ql(v.value, u.value), U = Ql(v.value, f.value);
    return l.value ? {
      ...E,
      transform: "translate(" + F + "px, " + U + "px)",
      ...xs(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: F + "px",
      top: U + "px"
    };
  });
  let b;
  function C() {
    if (h.value == null || v.value == null)
      return;
    const E = o.value;
    hm(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: s.value
    }).then((F) => {
      u.value = F.x, f.value = F.y, m.value = F.strategy, c.value = F.placement, p.value = F.middlewareData, x.value = E !== !1;
    });
  }
  function A() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (A(), r === void 0) {
      C();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, C);
      return;
    }
  }
  function L() {
    o.value || (x.value = !1);
  }
  return He([i, a, s, o], C, {
    flush: "sync"
  }), He([h, v], I, {
    flush: "sync"
  }), He(o, L, {
    flush: "sync"
  }), Js() && mo(A), {
    x: Rn(u),
    y: Rn(f),
    strategy: Rn(m),
    placement: Rn(c),
    middlewareData: Rn(p),
    isPositioned: Rn(x),
    floatingStyles: g,
    update: C
  };
}
const Na = pe(!1);
let Un, qn, jn, ri = 0;
const Ei = () => (St(() => {
  ri += 1, mm();
}), In(() => {
  ri -= 1, gm();
}), Na), mm = () => {
  typeof window > "u" || (Un || (Un = () => Na.value = !0, window.addEventListener("keydown", Un, !0)), qn || (qn = () => Na.value = !1, window.addEventListener("mousedown", qn, !0)), jn || (jn = () => Na.value = !1, window.addEventListener("pointerdown", jn, !0)));
}, gm = () => {
  typeof window > "u" || ri || (Un && (window.removeEventListener("keydown", Un, !0), Un = null), qn && (window.removeEventListener("mousedown", qn, !0), qn = null), jn && (window.removeEventListener("pointerdown", jn, !0), jn = null));
}, Ss = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, $2 = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Ut = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Ut || {});
const bm = {
  ref: "container",
  class: "lc-menu-button"
}, pm = ["id", "aria-activedescendant"], ym = ["id", "aria-selected", "onClick"], I2 = /* @__PURE__ */ Se({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = nt("button"), i = nt("menu"), a = pe(null), s = pe(!1), { floatingStyles: l } = ks(o, i, {
      middleware: [
        ys({
          alignmentAxis: 4
        }),
        ws(),
        Ss
      ],
      placement: () => e.placement,
      whileElementsMounted: ps
    }), h = $t(e.id), v = Ei(), u = W(() => {
      if (!(!s.value || !Lt(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = W(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      s.value && (a.value = null, s.value = !1);
    }, c = () => {
      if (s.value) {
        m();
        return;
      }
      g();
    }, p = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, x = (b) => {
      if (!tn(b.key, Ut)) return;
      b.key !== Ut.Tab && (b.preventDefault(), b.stopPropagation());
      const C = e.options.length - 1;
      switch (b.key) {
        case Ut.ArrowDown:
          if (s.value && Lt(a.value)) {
            a.value = Math.min(C, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.ArrowUp:
          if (s.value && Lt(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = C, g();
          break;
        case Ut.End:
          if (!s.value) return;
          a.value = C;
          break;
        case Ut.Enter:
        case Ut.Space:
          if (s.value && Lt(a.value)) {
            p(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Ut.Escape:
        case Ut.Tab:
          m();
          break;
        case Ut.Home:
          if (!s.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      s.value || (s.value = !0, e.value && (a.value = f.value));
    };
    return Qa(i, m, {
      ignore: [o, ...at(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), St(() => {
      e.value && (a.value = f.value);
    }), (b, C) => ($(), j("div", bm, [
      Re(Z(Tt), Ce({
        id: Z(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${Z(h)}-menu`,
        "aria-expanded": s.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: c,
        onKeydown: x
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      ($(), xe(pa, { to: "body" }, [
        s.value ? ($(), xe(Z(wa), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Et({ ...Z(l), zIndex: e.zIndex })
        }, {
          default: _e(() => [
            ne("ul", {
              id: `${Z(h)}-menu`,
              "aria-activedescendant": u.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              ($(!0), j(rt, null, yt(e.options, (A, I) => ($(), j("li", {
                key: `${A.label}-${"value" in A ? A.value : "action"}`,
                class: ye(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === I && Z(v),
                  "lc-menu-button__menu-item--selected": "value" in A && A.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${Z(h)}-menuitem-${I}`,
                  "aria-selected": "value" in A && A.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: (L) => p(A)
                }, [
                  Re(Z(Je), {
                    name: A.icon
                  }, null, 8, ["name"]),
                  ne("span", null, Ie(A.label), 1),
                  "value" in A && A.value === e.value ? ($(), xe(Z(Je), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : se("", !0)
                ], 8, ym)
              ], 2))), 128))
            ], 8, pm)
          ]),
          _: 1
        }, 8, ["style"])) : se("", !0)
      ]))
    ], 512));
  }
}), wm = "medium", xm = "default", D2 = ["medium", "small"], O2 = ["default", "info", "warning"], km = { class: "lc-message-box__headline" }, Sm = {
  key: 0,
  class: "lc-message-box__text"
}, M2 = /* @__PURE__ */ Se({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ Cn({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: () => wm },
    text: {},
    variant: { default: () => xm }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Ya(e, "modelValue"), r = W(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (o, i) => ($(), xe(Z(t0), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: ye(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: _e(() => [
        ne("span", km, [
          Re(Z(Je), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ne("span", null, Ie(e.headline), 1)
        ])
      ]),
      default: _e(() => [
        ve(o.$slots, "default", {}, () => [
          e.text ? ($(), j("p", Sm, Ie(e.text), 1)) : se("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
});
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var on;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(on || (on = {}));
const Fa = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), _s = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Ur = (e, t) => (e.match(new RegExp(Fa(t), "g")) || []).length, _m = (e, t) => e.substring(0, e.indexOf(t)), Cs = [
  ",",
  ".",
  "٫",
  "。"
], eo = "(0|[1-9]\\d*)";
class Cm {
  constructor(t) {
    var n, r, o, i, a, s;
    const { currency: l, currencyDisplay: h, locale: v, precision: u, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: l,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const c = new Intl.NumberFormat(v, this.options), p = c.formatToParts(123456);
    this.currency = (n = p.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = p.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (o = p.find(({ type: b }) => b === "group")) === null || o === void 0 ? void 0 : o.value, this.minusSign = (i = c.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof u == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = u : (this.minimumFractionDigits = (a = u?.min) !== null && a !== void 0 ? a : c.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (s = u?.max) !== null && s !== void 0 ? s : c.resolvedOptions().maximumFractionDigits);
    const x = (b) => _m(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = x(c.format(1)), this.suffix = g(c.format(1)), this.negativePrefix = x(c.format(-1)), this.negativeSuffix = g(c.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Fa(this.decimalSymbol)}(\\d*))?` : "", o = this.stripGroupingSeparator(t).match(new RegExp(`^${eo}${r}$`));
      if (o && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(o[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(o[1])}.${this.onlyDigits(o[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${eo}${Fa(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Fa(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return Cs.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class Es {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class Em extends Es {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), o = (c) => c === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (c) => {
      if (o(c))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(c))
          return c;
        if (c.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(c);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const s = i(a);
    if (s != null)
      return this.currencyFormat.insertCurrency(s, r);
    const [l, ...h] = a.split(this.currencyFormat.decimalSymbol), v = _s(this.currencyFormat.onlyDigits(l)), u = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && u.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || o(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${u}`,
      fractionDigits: u
    } : "";
  }
}
class Tm extends Es {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), o = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${_s(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: o,
      fractionDigits: o.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const Am = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class Lm {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...Am,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new Cm(this.options), this.numberMask = this.options.autoDecimalDigits ? new Tm(this.currencyFormat) : new Em(this.currencyFormat);
    const n = {
      [on.precision]: this.currencyFormat.maximumFractionDigits,
      [on.thousands]: 3,
      [on.tenThousands]: 4,
      [on.millions]: 6,
      [on.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== on.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let o;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: s, minimumFractionDigits: l } = this.currencyFormat;
        this.focus ? l = n ? a.replace(/0+$/, "").length : Math.min(s, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || l === 0) && (l = s = 0), o = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: l,
          maximumFractionDigits: s
        });
      } else
        o = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(o) && this.currencyFormat.parse(o) !== 0 && (o = o.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (o = o.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (o = o.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = o, this.numberValue = this.currencyFormat.parse(o);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, o = t;
      if (r && o.data && Cs.includes(o.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: s, decimalSymbol: l, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let u = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Ur(this.formattedValue, v) === Ur(n, v) + 1)
            return f - u - 1;
          if (f < u)
            return r;
          if (l !== void 0 && n.indexOf(l) !== -1) {
            const m = n.indexOf(l) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(l) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (u -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - u : Math.max(f - Math.max(u, s.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const o = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(o);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: o, suffix: i, negativeSuffix: a, groupingSymbol: s, currency: l } = this.currencyFormat, h = this.numberValue < 0, v = h ? o : r, u = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < u)
        return u;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= u && l !== void 0 && v.includes(l) && (f -= u, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && s !== void 0 && (f -= Ur(t.substring(0, n), s)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const $m = (e) => e?.matches("input") ? e : e?.querySelector("input");
function Im(e, t) {
  var n, r, o, i;
  let a;
  const s = pe(null), l = pe(null), h = pe(null), v = oi();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const u = v?.props || ((o = v?.proxy) === null || o === void 0 ? void 0 : o.$props), f = Qs.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = W(() => u?.[f ? "modelValue" : "value"]);
  return He(s, (c) => {
    var p;
    if (c) {
      const x = $m((p = c?.$el) !== null && p !== void 0 ? p : c);
      x ? (a = new Lm({
        el: x,
        options: e,
        onInput: (g) => {
          h.value = g.number, l.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: s,
    numberValue: h,
    formattedValue: l,
    setValue: (c) => a?.setValue(c),
    setOptions: (c) => a?.setOptions(c)
  };
}
const to = 2, R2 = /* @__PURE__ */ Se({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => Ze.general.currency },
    locale: { default: () => Ze.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ba(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: o, inputRef: i, numberValue: a, setValue: s } = Im(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: to,
        valueRange: e.valueRange
      }
    ), l = W(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: u }) => u === "currency")?.value ?? e.currency
    ), h = W(
      () => Lt(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (u) => {
      s(Lt(u) ? parseFloat((u / 100).toFixed(to)) : null);
    };
    return St(async () => {
      Lt(e.value) && (await Ga(), v(e.value));
    }), He(h, (u) => {
      n("update:value", u);
    }), He(
      () => e.value,
      (u) => {
        u !== h.value && v(u);
      }
    ), (u, f) => ($(), xe(Z(ir), Ce({
      ref_key: "inputRef",
      ref: i
    }, { ...u.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: Z(o)
    }), Ka({
      prefix: _e(() => [
        kt(Ie(l.value), 1)
      ]),
      _: 2
    }, [
      u.$slots.suffix ? {
        name: "suffix",
        fn: _e(() => [
          ve(u.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), Dm = ["aria-checked", "aria-label"], N2 = /* @__PURE__ */ Se({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => Ze.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ba(e, ["toggleAriaLabel"]), n = pe("password"), r = W(() => o.value ? "eye-off" : "eye"), o = W(() => n.value === "text"), i = () => {
      n.value = o.value ? "password" : "text";
    };
    return (a, s) => ($(), xe(Z(ir), Ce({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: _e(() => [
        ne("button", {
          "aria-checked": o.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Re(Z(Je), { name: r.value }, null, 8, ["name"])
        ], 40, Dm),
        ve(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), F2 = ["password", "text"], Om = 0, Mm = "medium", P2 = ["medium", "small"], B2 = ["info", "success"], Rm = ["aria-valuenow"], z2 = /* @__PURE__ */ Se({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: () => Om },
    size: { default: () => Mm },
    variant: { default: "info" }
  },
  setup(e) {
    const t = W(() => e.size === "medium" ? 36 : 24);
    return (n, r) => ($(), j("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: ye([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Re(Z(Fo), Ce({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Re(kn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: _e(() => [
          ($(), xe(Z(Je), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, Rm));
  }
}), Ti = /* @__PURE__ */ Symbol(), Nm = ["for"], Fm = { class: "lc-radio__control" }, Pm = ["id", "aria-labelledby", "data-click-name", "name"], Bm = ["id"], zm = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = $n(Ti), o = $t(e.id), i = W(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!at(r?.disabled) || e.disabled,
        "lc-radio--error": !!at(r?.hasError)
      }
    ]), a = W(() => e.value === at(r?.value) || e.checked), s = W({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), l = W(() => {
      if (at(r?.value))
        return a.value ? 0 : -1;
    }), h = W(() => at(r?.name) ?? e.name);
    return (v, u) => ($(), j("label", {
      class: ye([i.value, v.$attrs.class]),
      for: Z(o)
    }, [
      ne("div", Fm, [
        Qt(ne("input", Ce({ id: Z(o) }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: l.value
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => s.value = f),
          "aria-labelledby": e.label ? `${Z(o)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, Pm), [
          [ec, s.value]
        ])
      ]),
      e.label ? ($(), j("span", {
        key: 0,
        id: `${Z(o)}-label`,
        class: ye(["lc-radio__label", e.labelClass])
      }, Ie(e.label), 11, Bm)) : se("", !0)
    ], 10, Nm));
  }
}), Vm = { class: "lc-radio-card__main" }, V2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = nt("radio"), n = $n(Ti), r = W(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), o = W(() => e.value === at(n?.value) || e.checked), i = W(() => e.disabled || at(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const s = t.value?.$el?.querySelector("input");
      if (!s) return;
      const l = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      s.dispatchEvent(l), s.dispatchEvent(h);
    };
    return (s, l) => ($(), xe(Z(wa), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: ye([r.value, s.$attrs.class]),
      onClick: a
    }, {
      default: _e(() => [
        ne("div", Vm, [
          Re(Z(zm), Ce({ ref: "radio" }, {
            ...en(s.$attrs, ["class"]),
            ...s.$props
          }), null, 16),
          ve(s.$slots, "default", {
            checked: o.value,
            disabled: i.value
          })
        ]),
        Qt(ne("div", {
          class: "lc-radio-card__underneath",
          onClick: l[0] || (l[0] = ca(() => {
          }, ["stop"]))
        }, [
          ve(s.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ui, o.value && s.$slots.underneath]
        ]),
        ve(s.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), Hm = ["id", "aria-labelledby"], Um = ["id"], H2 = /* @__PURE__ */ Se({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), o = W(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = W(() => !!e.errorMessage);
    return St(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), Ja(Ti, {
      disabled: () => e.disabled,
      hasError: vo(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, s) => ($(), j("fieldset", Ce({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: Z(r),
      "aria-labelledby": e.label ? `${Z(r)}-label` : void 0,
      class: o.value,
      role: "radiogroup"
    }), [
      e.label ? ($(), j("legend", {
        key: 0,
        id: `${Z(r)}-label`,
        class: "lc-radio-group__label"
      }, Ie(e.label), 9, Um)) : se("", !0),
      ne("div", {
        class: ye(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        ve(a.$slots, "default")
      ], 2),
      e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, Hm));
  }
}), U2 = ["horizontal", "vertical"], qm = { class: "lc-rating" }, q2 = /* @__PURE__ */ Se({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => ($(), j("div", qm, [
      ($(!0), j(rt, null, yt(new Array(e.max), (r, o) => ($(), j("svg", {
        key: o,
        class: ye(["lc-rating__star", o < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        ne("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ne("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), jm = /* @__PURE__ */ Se({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => ($(), j("div", {
      "aria-hidden": "true",
      class: ye(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Et({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), j2 = ["full", "half", "large", "medium", "none", "small"], Zm = { class: "lc-remote-list__content" }, Wm = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, Z2 = /* @__PURE__ */ Se({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = W(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), o = W(() => e.count < e.total), i = () => {
      o.value && n("fetch-more");
    };
    return (a, s) => ($(), j("section", {
      class: ye(r.value)
    }, [
      ne("ul", Zm, [
        ve(a.$slots, "default"),
        e.loading ? ve(a.$slots, "loading", {}, () => [
          ($(!0), j(rt, null, yt(e.numberOfSkeletons, (l) => ($(), xe(Z(jm), {
            key: l,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : se("", !0)
      ]),
      !e.loading && o.value ? ($(), j("div", Wm, [
        ve(a.$slots, "load-more", Ot(Pt({ fetchMore: i })), () => [
          Re(Z(Tt), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: _e(() => [
              kt(Ie(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? se("", !0) : ($(), xe(Z(hi), { key: 0 }))
      ])) : se("", !0)
    ], 2));
  }
}), Xm = { class: "lc-scratchcard-teaser__button-wrap" }, W2 = /* @__PURE__ */ Se({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => ($(), xe(Z(lr), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: _e(() => [
        Re(Z(fi), Ce({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: _e(() => [
            ve(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ne("div", Xm, [
          Re(Z(Tt), Ce({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: _e(() => [
              kt(Ie(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), X2 = [...as];
var Gt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Gt || {});
const Ym = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], Gm = ["id"], Km = { class: "lc-select__input" }, Jm = ["id", "aria-activedescendant", "aria-labelledby"], Qm = ["id", "aria-selected", "onClickPassive"], Y2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [Ze.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = nt("button"), o = nt("container"), i = nt("menu"), a = nt("options"), s = pe(null), l = pe(!1), h = li({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = ks(r, i, {
      middleware: [ws(), Ss, ys(2)],
      whileElementsMounted: ps
    }), { width: u } = yn(o), f = $t(e.id), m = Ei(), c = W(() => {
      if (!(!l.value || !Lt(s.value)))
        return `${f}-option-${s.value}`;
    }), p = W(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": l.value,
        "lc-select--fixed-value": b.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), x = W(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = W(() => e.options.findIndex((T) => T.value === e.value)), b = W(() => e.notNullable && e.options.length === 1 && !!e.value), C = W(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), A = W(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = W(() => ({
      ...v.value,
      minWidth: `${u.value}px`
    })), L = () => {
      l.value && (s.value = null, l.value = !1, e.onBlur?.(), E("focusout"));
    }, E = (T) => {
      const R = r.value;
      if (!R) return;
      h[T] = !0;
      const H = new Event(T, { bubbles: !0 });
      R.dispatchEvent(H);
    }, F = async () => {
      l.value || await B();
    }, U = (T) => {
      const R = T.type;
      if (!V(R)) return;
      h[R] ? h[R] = !1 : T.stopPropagation();
    }, K = async (T) => {
      if (!tn(T.key, Gt)) return;
      T.key !== Gt.Tab && (T.preventDefault(), T.stopPropagation());
      const R = e.options.length - 1;
      switch (T.key) {
        case Gt.ArrowDown:
          if (l.value && Lt(s.value)) {
            s.value = Math.min(R, s.value + 1), _();
            break;
          }
          s.value = 0, await B();
          break;
        case Gt.ArrowUp:
          if (l.value && Lt(s.value)) {
            s.value = Math.max(0, s.value - 1), _();
            break;
          }
          s.value = R, await B();
          break;
        case Gt.Enter:
        case Gt.Space:
          if (l.value && Lt(s.value)) {
            O(e.options[s.value].value);
            break;
          }
          await B();
          break;
        case Gt.Escape:
          L();
          break;
        case Gt.Tab:
          if (!l.value || !Lt(s.value)) break;
          O(e.options[s.value].value);
          break;
      }
    }, O = (T) => {
      const R = e.value === T ? null : T;
      e.notNullable && R === null || (n("update:value", R), L());
    }, V = (T) => T === "focusin" || T === "focusout", B = async () => {
      l.value || (l.value = !0, e.value && (s.value = g.value), E("focusin"), await Ga(), _());
    }, _ = () => {
      if (!Lt(s.value)) return;
      a.value?.[s.value]?.scrollIntoView({ block: "center" });
    };
    return Qa(i, L, {
      ignore: [r, ...at(e.ignoreOutsideClickOn)]
    }), St(() => {
      e.autofocus && r.value?.focus(), e.value && (s.value = g.value);
    }), (T, R) => ($(), j("div", {
      ref: "container",
      class: ye([p.value, T.$attrs.class])
    }, [
      ne("button", Ce({
        id: Z(f),
        ref: "button"
      }, en(T.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${Z(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : l.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${Z(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: F,
        onFocusin: U,
        onFocusout: U,
        onKeydown: K
      }), [
        !b.value && e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(f)}-label`,
          class: ye(C.value)
        }, Ie(e.label), 11, Gm)) : se("", !0),
        ne("div", Km, Ie(x.value), 1),
        b.value ? se("", !0) : ($(), xe(Z(Je), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, Ym),
      b.value ? se("", !0) : ($(), xe(Z(Du), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: _e(() => [
          l.value ? ($(), j("div", {
            key: 0,
            ref: "menu",
            class: ye(A.value),
            style: Et(I.value)
          }, [
            ne("ul", {
              id: `${Z(f)}-listbox`,
              "aria-activedescendant": c.value,
              "aria-labelledby": e.label ? `${Z(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              ($(!0), j(rt, null, yt(e.options, (H, q) => ($(), j("li", {
                key: `${H.label}-${H.value}`,
                class: ye(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": s.value === q && Z(m),
                  "lc-select__menu-item--selected": H.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${Z(f)}-option-${q}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": H.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (G) => O(H.value)
                }, [
                  ne("span", null, Ie(H.label), 1),
                  H.value === e.value ? ($(), xe(Z(Je), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : se("", !0)
                ], 40, Qm)
              ], 2))), 128))
            ], 8, Jm)
          ], 6)) : se("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), G2 = ["default", "discreet"];
var Wt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(Wt || {});
const eg = ["id", "aria-activedescendant"], K2 = /* @__PURE__ */ Se({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = nt("list"), o = pe(null), i = $t(e.id), a = Ei(), s = W(() => {
      if (Lt(o.value))
        return `${i}-option-${o.value}`;
    }), l = W(() => !r.value || !Lt(o.value) ? null : r.value.querySelectorAll('[role="option"]')[o.value]), h = W(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = W(
      () => e.options.findIndex((A) => A.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), u = (A) => e.optionComponent ? g(A) ? "span" : e.optionComponent : x(A) ? g(A) ? "span" : Yn(A.to) : "button", f = () => {
      a.value && (o.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (o.value = null);
    }, c = (A) => {
      if (!tn(A.key, Wt) || !Lt(o.value))
        return;
      A.preventDefault(), A.stopPropagation();
      const I = e.options.length - 1;
      switch (A.key) {
        case Wt.ArrowDown:
        case Wt.ArrowRight:
          o.value = Math.min(I, o.value + 1);
          break;
        case Wt.ArrowLeft:
        case Wt.ArrowUp:
          o.value = Math.max(0, o.value - 1);
          break;
        case Wt.End:
          o.value = I;
          break;
        case Wt.Enter:
        case Wt.Space:
          l.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case Wt.Home:
          o.value = 0;
          break;
      }
    }, p = (A) => {
      let I;
      if (e.multiple) {
        const L = Array.isArray(e.value) ? e.value : [];
        I = L.includes(A) ? L.filter((E) => E !== A) : C([...L, A]);
      } else
        I = e.value === A ? void 0 : A;
      n("update:value", I);
    }, x = ({ href: A, to: I }) => !!(A || I), g = (A) => Array.isArray(e.value) ? e.value.includes(A.value) : e.value === A.value, b = () => {
      l.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, C = (A) => {
      const I = new Map(e.options.map((L, E) => [L.value, E]));
      return [...A].sort(
        (L, E) => (I.get(L) ?? 1 / 0) - (I.get(E) ?? 1 / 0)
      );
    };
    return St(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), He(o, (A) => {
      A !== null && b();
    }), (A, I) => ($(), j("div", {
      class: ye(h.value)
    }, [
      ne("ul", {
        id: Z(i),
        ref: "list",
        "aria-activedescendant": s.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: c
      }, [
        ($(!0), j(rt, null, yt(e.options, (L, E) => ($(), j("li", {
          key: `${L.label}-${L.value}`,
          class: ye(["lc-select-list__item", {
            "lc-select-list__item--focused": o.value === E && Z(a),
            "lc-select-list__item--selected": g(L)
          }]),
          role: "presentation"
        }, [
          ($(), xe(Nt(u(L)), Ce({
            id: `${Z(i)}-option-${E}`
          }, { ref_for: !0 }, {
            ...ku(L, ["href", "target", "to"]),
            ...L?.additionalProps ?? {}
          }, {
            "aria-label": L.ariaLabelText || void 0,
            "aria-selected": g(L),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: x(L) && !g(L) ? void 0 : "button",
            onClickPassive: (F) => p(L.value)
          }), {
            default: _e(() => [
              ne("span", null, Ie(L.label), 1),
              g(L) ? ($(), xe(Z(Je), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : se("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, eg)
    ], 2));
  }
});
function Ma(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function tg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ts(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var no = Ts((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(c) {
      return c.split("").reverse().join("");
    }
    function o(c, p) {
      return c.substring(0, p.length) === p;
    }
    function i(c, p) {
      return c.slice(-1 * p.length) === p;
    }
    function a(c, p, x) {
      if ((c[p] || c[x]) && c[p] === c[x]) throw new Error(p);
    }
    function s(c) {
      return typeof c == "number" && isFinite(c);
    }
    function l(c, p) {
      return c = c.toString().split("e"), (+((c = (c = Math.round(+(c[0] + "e" + (c[1] ? +c[1] + p : p)))).toString().split("e"))[0] + "e" + (c[1] ? +c[1] - p : -p))).toFixed(p);
    }
    function h(c, p, x, g, b, C, A, I, L, E, F, U) {
      var K, O, V, B = U, _ = "", T = "";
      return C && (U = C(U)), !!s(U) && (c !== !1 && parseFloat(U.toFixed(c)) === 0 && (U = 0), U < 0 && (K = !0, U = Math.abs(U)), c !== !1 && (U = l(U, c)), (U = U.toString()).indexOf(".") !== -1 ? (V = (O = U.split("."))[0], x && (_ = x + O[1])) : V = U, p && (V = r(V).match(/.{1,3}/g), V = r(V.join(r(p)))), K && I && (T += I), g && (T += g), K && L && (T += L), T += V, T += _, b && (T += b), E && (T = E(T, B)), T);
    }
    function v(c, p, x, g, b, C, A, I, L, E, F, U) {
      var K, O = "";
      return F && (U = F(U)), !(!U || typeof U != "string") && (I && o(U, I) && (U = U.replace(I, ""), K = !0), g && o(U, g) && (U = U.replace(g, "")), L && o(U, L) && (U = U.replace(L, ""), K = !0), b && i(U, b) && (U = U.slice(0, -1 * b.length)), p && (U = U.split(p).join("")), x && (U = U.replace(x, ".")), K && (O += "-"), (O = (O += U).replace(/[^0-9\.\-.]/g, "")) !== "" && (O = Number(O), A && (O = A(O)), !!s(O) && O));
    }
    function u(c) {
      var p, x, g, b = {};
      for (c.suffix === void 0 && (c.suffix = c.postfix), p = 0; p < n.length; p += 1) if ((g = c[x = n[p]]) === void 0) x !== "negative" || b.negativeBefore ? x === "mark" && b.thousand !== "." ? b[x] = "." : b[x] = !1 : b[x] = "-";
      else if (x === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(x);
        b[x] = g;
      } else if (x === "encoder" || x === "decoder" || x === "edit" || x === "undo") {
        if (typeof g != "function") throw new Error(x);
        b[x] = g;
      } else {
        if (typeof g != "string") throw new Error(x);
        b[x] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(c, p, x) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(c[n[g]]);
      return b.push(x), p.apply("", b);
    }
    function m(c) {
      if (!(this instanceof m)) return new m(c);
      typeof c == "object" && (c = u(c), this.to = function(p) {
        return f(c, h, p);
      }, this.from = function(p) {
        return f(c, v, p);
      });
    }
    return m;
  })();
})), ng = tg(Ts((function(e, t) {
  (function(n) {
    function r(N) {
      return o(N) && typeof N.from == "function";
    }
    function o(N) {
      return typeof N == "object" && typeof N.to == "function";
    }
    function i(N) {
      N.parentElement.removeChild(N);
    }
    function a(N) {
      return N != null;
    }
    function s(N) {
      N.preventDefault();
    }
    function l(N) {
      return N.filter((function(S) {
        return !this[S] && (this[S] = !0);
      }), {});
    }
    function h(N, S) {
      return Math.round(N / S) * S;
    }
    function v(N, S) {
      var w = N.getBoundingClientRect(), J = N.ownerDocument, M = J.documentElement, re = C(J);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (re.x = 0), S ? w.top + re.y - M.clientTop : w.left + re.x - M.clientLeft;
    }
    function u(N) {
      return typeof N == "number" && !isNaN(N) && isFinite(N);
    }
    function f(N, S, w) {
      w > 0 && (x(N, S), setTimeout((function() {
        g(N, S);
      }), w));
    }
    function m(N) {
      return Math.max(Math.min(N, 100), 0);
    }
    function c(N) {
      return Array.isArray(N) ? N : [N];
    }
    function p(N) {
      var S = (N = String(N)).split(".");
      return S.length > 1 ? S[1].length : 0;
    }
    function x(N, S) {
      N.classList && !/\s/.test(S) ? N.classList.add(S) : N.className += " " + S;
    }
    function g(N, S) {
      N.classList && !/\s/.test(S) ? N.classList.remove(S) : N.className = N.className.replace(new RegExp("(^|\\b)" + S.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(N, S) {
      return N.classList ? N.classList.contains(S) : new RegExp("\\b" + S + "\\b").test(N.className);
    }
    function C(N) {
      var S = window.pageXOffset !== void 0, w = (N.compatMode || "") === "CSS1Compat";
      return { x: S ? window.pageXOffset : w ? N.documentElement.scrollLeft : N.body.scrollLeft, y: S ? window.pageYOffset : w ? N.documentElement.scrollTop : N.body.scrollTop };
    }
    function A() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var N = !1;
      try {
        var S = Object.defineProperty({}, "passive", { get: function() {
          N = !0;
        } });
        window.addEventListener("test", null, S);
      } catch {
      }
      return N;
    }
    function L() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function E(N, S) {
      return 100 / (S - N);
    }
    function F(N, S, w) {
      return 100 * S / (N[w + 1] - N[w]);
    }
    function U(N, S) {
      return F(N, N[0] < 0 ? S + Math.abs(N[0]) : S - N[0], 0);
    }
    function K(N, S) {
      return S * (N[1] - N[0]) / 100 + N[0];
    }
    function O(N, S) {
      for (var w = 1; N >= S[w]; ) w += 1;
      return w;
    }
    function V(N, S, w) {
      if (w >= N.slice(-1)[0]) return 100;
      var J = O(w, N), M = N[J - 1], re = N[J], D = S[J - 1], Q = S[J];
      return D + U([M, re], w) / E(D, Q);
    }
    function B(N, S, w) {
      if (w >= 100) return N.slice(-1)[0];
      var J = O(w, S), M = N[J - 1], re = N[J], D = S[J - 1];
      return K([M, re], (w - D) * E(D, S[J]));
    }
    function _(N, S, w, J) {
      if (J === 100) return J;
      var M = O(J, N), re = N[M - 1], D = N[M];
      return w ? J - re > (D - re) / 2 ? D : re : S[M - 1] ? N[M - 1] + h(J - N[M - 1], S[M - 1]) : J;
    }
    var T, R;
    n.PipsMode = void 0, (R = n.PipsMode || (n.PipsMode = {})).Range = "range", R.Steps = "steps", R.Positions = "positions", R.Count = "count", R.Values = "values", n.PipsType = void 0, (T = n.PipsType || (n.PipsType = {}))[T.None = -1] = "None", T[T.NoValue = 0] = "NoValue", T[T.LargeValue = 1] = "LargeValue", T[T.SmallValue = 2] = "SmallValue";
    var H = (function() {
      function N(S, w, J) {
        var M;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [J || !1], this.xNumSteps = [!1], this.snap = w;
        var re = [];
        for (Object.keys(S).forEach((function(D) {
          re.push([c(S[D]), D]);
        })), re.sort((function(D, Q) {
          return D[0][0] - Q[0][0];
        })), M = 0; M < re.length; M++) this.handleEntryPoint(re[M][1], re[M][0]);
        for (this.xNumSteps = this.xSteps.slice(0), M = 0; M < this.xNumSteps.length; M++) this.handleStepPoint(M, this.xNumSteps[M]);
      }
      return N.prototype.getDistance = function(S) {
        for (var w = [], J = 0; J < this.xNumSteps.length - 1; J++) w[J] = F(this.xVal, S, J);
        return w;
      }, N.prototype.getAbsoluteDistance = function(S, w, J) {
        var M, re = 0;
        if (S < this.xPct[this.xPct.length - 1]) for (; S > this.xPct[re + 1]; ) re++;
        else S === this.xPct[this.xPct.length - 1] && (re = this.xPct.length - 2);
        J || S !== this.xPct[re + 1] || re++, w === null && (w = []);
        var D = 1, Q = w[re], y = 0, ce = 0, Te = 0, d = 0;
        for (M = J ? (S - this.xPct[re]) / (this.xPct[re + 1] - this.xPct[re]) : (this.xPct[re + 1] - S) / (this.xPct[re + 1] - this.xPct[re]); Q > 0; ) y = this.xPct[re + 1 + d] - this.xPct[re + d], w[re + d] * D + 100 - 100 * M > 100 ? (ce = y * M, D = (Q - 100 * M) / w[re + d], M = 1) : (ce = w[re + d] * y / 100 * D, D = 0), J ? (Te -= ce, this.xPct.length + d >= 1 && d--) : (Te += ce, this.xPct.length - d >= 1 && d++), Q = w[re + d] * D;
        return S + Te;
      }, N.prototype.toStepping = function(S) {
        return S = V(this.xVal, this.xPct, S);
      }, N.prototype.fromStepping = function(S) {
        return B(this.xVal, this.xPct, S);
      }, N.prototype.getStep = function(S) {
        return S = _(this.xPct, this.xSteps, this.snap, S);
      }, N.prototype.getDefaultStep = function(S, w, J) {
        var M = O(S, this.xPct);
        return (S === 100 || w && S === this.xPct[M - 1]) && (M = Math.max(M - 1, 1)), (this.xVal[M] - this.xVal[M - 1]) / J;
      }, N.prototype.getNearbySteps = function(S) {
        var w = O(S, this.xPct);
        return { stepBefore: { startValue: this.xVal[w - 2], step: this.xNumSteps[w - 2], highestStep: this.xHighestCompleteStep[w - 2] }, thisStep: { startValue: this.xVal[w - 1], step: this.xNumSteps[w - 1], highestStep: this.xHighestCompleteStep[w - 1] }, stepAfter: { startValue: this.xVal[w], step: this.xNumSteps[w], highestStep: this.xHighestCompleteStep[w] } };
      }, N.prototype.countStepDecimals = function() {
        var S = this.xNumSteps.map(p);
        return Math.max.apply(null, S);
      }, N.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, N.prototype.convert = function(S) {
        return this.getStep(this.toStepping(S));
      }, N.prototype.handleEntryPoint = function(S, w) {
        var J;
        if (!u(J = S === "min" ? 0 : S === "max" ? 100 : parseFloat(S)) || !u(w[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(J), this.xVal.push(w[0]);
        var M = Number(w[1]);
        J ? this.xSteps.push(!isNaN(M) && M) : isNaN(M) || (this.xSteps[0] = M), this.xHighestCompleteStep.push(0);
      }, N.prototype.handleStepPoint = function(S, w) {
        if (w) if (this.xVal[S] !== this.xVal[S + 1]) {
          this.xSteps[S] = F([this.xVal[S], this.xVal[S + 1]], w, 0) / E(this.xPct[S], this.xPct[S + 1]);
          var J = (this.xVal[S + 1] - this.xVal[S]) / this.xNumSteps[S], M = Math.ceil(Number(J.toFixed(3)) - 1), re = this.xVal[S] + this.xNumSteps[S] * M;
          this.xHighestCompleteStep[S] = re;
        } else this.xSteps[S] = this.xHighestCompleteStep[S] = this.xVal[S];
      }, N;
    })(), q = { to: function(N) {
      return N === void 0 ? "" : N.toFixed(2);
    }, from: Number }, G = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, ie = { tooltips: ".__tooltips", aria: ".__aria" };
    function X(N, S) {
      if (!u(S)) throw new Error("noUiSlider: 'step' is not numeric.");
      N.singleStep = S;
    }
    function oe(N, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      N.keyboardPageMultiplier = S;
    }
    function ue(N, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      N.keyboardMultiplier = S;
    }
    function he(N, S) {
      if (!u(S)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      N.keyboardDefaultStep = S;
    }
    function be(N, S) {
      if (typeof S != "object" || Array.isArray(S)) throw new Error("noUiSlider: 'range' is not an object.");
      if (S.min === void 0 || S.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      N.spectrum = new H(S, N.snap || !1, N.singleStep);
    }
    function fe(N, S) {
      if (S = c(S), !Array.isArray(S) || !S.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      N.handles = S.length, N.start = S;
    }
    function we(N, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      N.snap = S;
    }
    function Ae(N, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      N.animate = S;
    }
    function Oe(N, S) {
      if (typeof S != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      N.animationDuration = S;
    }
    function We(N, S) {
      var w, J = [!1];
      if (S === "lower" ? S = [!0, !1] : S === "upper" && (S = [!1, !0]), S === !0 || S === !1) {
        for (w = 1; w < N.handles; w++) J.push(S);
        J.push(!1);
      } else {
        if (!Array.isArray(S) || !S.length || S.length !== N.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        J = S;
      }
      N.connect = J;
    }
    function Fe(N, S) {
      switch (S) {
        case "horizontal":
          N.ort = 0;
          break;
        case "vertical":
          N.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function de(N, S) {
      if (!u(S)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      S !== 0 && (N.margin = N.spectrum.getDistance(S));
    }
    function Ne(N, S) {
      if (!u(S)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (N.limit = N.spectrum.getDistance(S), !N.limit || N.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function qe(N, S) {
      var w;
      if (!u(S) && !Array.isArray(S)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(S) && S.length !== 2 && !u(S[0]) && !u(S[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (S !== 0) {
        for (Array.isArray(S) || (S = [S, S]), N.padding = [N.spectrum.getDistance(S[0]), N.spectrum.getDistance(S[1])], w = 0; w < N.spectrum.xNumSteps.length - 1; w++) if (N.padding[0][w] < 0 || N.padding[1][w] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var J = S[0] + S[1], M = N.spectrum.xVal[0];
        if (J / (N.spectrum.xVal[N.spectrum.xVal.length - 1] - M) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function je(N, S) {
      switch (S) {
        case "ltr":
          N.dir = 0;
          break;
        case "rtl":
          N.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function Xe(N, S) {
      if (typeof S != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var w = S.indexOf("tap") >= 0, J = S.indexOf("drag") >= 0, M = S.indexOf("fixed") >= 0, re = S.indexOf("snap") >= 0, D = S.indexOf("hover") >= 0, Q = S.indexOf("unconstrained") >= 0, y = S.indexOf("drag-all") >= 0, ce = S.indexOf("smooth-steps") >= 0;
      if (M) {
        if (N.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        de(N, N.start[1] - N.start[0]);
      }
      if (Q && (N.margin || N.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      N.events = { tap: w || re, drag: J, dragAll: y, smoothSteps: ce, fixed: M, snap: re, hover: D, unconstrained: Q };
    }
    function Ve(N, S) {
      if (S !== !1) if (S === !0 || o(S)) {
        N.tooltips = [];
        for (var w = 0; w < N.handles; w++) N.tooltips.push(S);
      } else {
        if ((S = c(S)).length !== N.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        S.forEach((function(J) {
          if (typeof J != "boolean" && !o(J)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), N.tooltips = S;
      }
    }
    function Pe(N, S) {
      if (S.length !== N.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      N.handleAttributes = S;
    }
    function it(N, S) {
      if (!o(S)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      N.ariaFormat = S;
    }
    function ut(N, S) {
      if (!r(S)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      N.format = S;
    }
    function ge(N, S) {
      if (typeof S != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      N.keyboardSupport = S;
    }
    function Be(N, S) {
      N.documentElement = S;
    }
    function ze(N, S) {
      if (typeof S != "string" && S !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      N.cssPrefix = S;
    }
    function Ke(N, S) {
      if (typeof S != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof N.cssPrefix == "string" ? (N.cssClasses = {}, Object.keys(S).forEach((function(w) {
        N.cssClasses[w] = N.cssPrefix + S[w];
      }))) : N.cssClasses = S;
    }
    function Qe(N) {
      var S = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: q, format: q }, w = { step: { r: !1, t: X }, keyboardPageMultiplier: { r: !1, t: oe }, keyboardMultiplier: { r: !1, t: ue }, keyboardDefaultStep: { r: !1, t: he }, start: { r: !0, t: fe }, connect: { r: !0, t: We }, direction: { r: !0, t: je }, snap: { r: !1, t: we }, animate: { r: !1, t: Ae }, animationDuration: { r: !1, t: Oe }, range: { r: !0, t: be }, orientation: { r: !1, t: Fe }, margin: { r: !1, t: de }, limit: { r: !1, t: Ne }, padding: { r: !1, t: qe }, behaviour: { r: !0, t: Xe }, ariaFormat: { r: !1, t: it }, format: { r: !1, t: ut }, tooltips: { r: !1, t: Ve }, keyboardSupport: { r: !0, t: ge }, documentElement: { r: !1, t: Be }, cssPrefix: { r: !0, t: ze }, cssClasses: { r: !0, t: Ke }, handleAttributes: { r: !1, t: Pe } }, J = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: G, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      N.format && !N.ariaFormat && (N.ariaFormat = N.format), Object.keys(w).forEach((function(y) {
        if (a(N[y]) || J[y] !== void 0) w[y].t(S, a(N[y]) ? N[y] : J[y]);
        else if (w[y].r) throw new Error("noUiSlider: '" + y + "' is required.");
      })), S.pips = N.pips;
      var M = document.createElement("div"), re = M.style.msTransform !== void 0, D = M.style.transform !== void 0;
      S.transformRule = D ? "transform" : re ? "msTransform" : "webkitTransform";
      var Q = [["left", "top"], ["right", "bottom"]];
      return S.style = Q[S.dir][S.ort], S;
    }
    function ht(N, S, w) {
      var J, M, re, D, Q, y = A(), ce = L() && I(), Te = N, d = S.spectrum, ae = [], te = [], k = [], P = 0, ee = {}, $e = N.ownerDocument, ke = S.documentElement || $e.documentElement, Le = $e.body, Ye = $e.dir === "rtl" || S.ort === 1 ? 0 : 100;
      function wt(z, Y) {
        var le = $e.createElement("div");
        return Y && x(le, Y), z.appendChild(le), le;
      }
      function ot(z, Y) {
        var le = wt(z, S.cssClasses.origin), me = wt(le, S.cssClasses.handle);
        if (wt(me, S.cssClasses.touchArea), me.setAttribute("data-handle", String(Y)), S.keyboardSupport && (me.setAttribute("tabindex", "0"), me.addEventListener("keydown", (function(Ee) {
          return Ps(Ee, Y);
        }))), S.handleAttributes !== void 0) {
          var De = S.handleAttributes[Y];
          Object.keys(De).forEach((function(Ee) {
            me.setAttribute(Ee, De[Ee]);
          }));
        }
        return me.setAttribute("role", "slider"), me.setAttribute("aria-orientation", S.ort ? "vertical" : "horizontal"), Y === 0 ? x(me, S.cssClasses.handleLower) : Y === S.handles - 1 && x(me, S.cssClasses.handleUpper), le;
      }
      function Ge(z, Y) {
        return !!Y && wt(z, S.cssClasses.connect);
      }
      function mt(z, Y) {
        var le = wt(Y, S.cssClasses.connects);
        M = [], (re = []).push(Ge(le, z[0]));
        for (var me = 0; me < S.handles; me++) M.push(ot(Y, me)), k[me] = me, re.push(Ge(le, z[me + 1]));
      }
      function _t(z) {
        return x(z, S.cssClasses.target), S.dir === 0 ? x(z, S.cssClasses.ltr) : x(z, S.cssClasses.rtl), S.ort === 0 ? x(z, S.cssClasses.horizontal) : x(z, S.cssClasses.vertical), x(z, getComputedStyle(z).direction === "rtl" ? S.cssClasses.textDirectionRtl : S.cssClasses.textDirectionLtr), wt(z, S.cssClasses.base);
      }
      function At(z, Y) {
        return !(!S.tooltips || !S.tooltips[Y]) && wt(z.firstChild, S.cssClasses.tooltip);
      }
      function hn() {
        return Te.hasAttribute("disabled");
      }
      function an(z) {
        return M[z].hasAttribute("disabled");
      }
      function st() {
        Q && (Gn("update" + ie.tooltips), Q.forEach((function(z) {
          z && i(z);
        })), Q = null);
      }
      function It() {
        st(), Q = M.map(At), br("update" + ie.tooltips, (function(z, Y, le) {
          if (Q && S.tooltips && Q[Y] !== !1) {
            var me = z[Y];
            S.tooltips[Y] !== !0 && (me = S.tooltips[Y].to(le[Y])), Q[Y].innerHTML = me;
          }
        }));
      }
      function xt() {
        Gn("update" + ie.aria), br("update" + ie.aria, (function(z, Y, le, me, De) {
          k.forEach((function(Ee) {
            var Ue = M[Ee], Me = Sa(te, Ee, 0, !0, !0, !0), bt = Sa(te, Ee, 100, !0, !0, !0), ft = De[Ee], lt = String(S.ariaFormat.to(le[Ee]));
            Me = d.fromStepping(Me).toFixed(1), bt = d.fromStepping(bt).toFixed(1), ft = d.fromStepping(ft).toFixed(1), Ue.children[0].setAttribute("aria-valuemin", Me), Ue.children[0].setAttribute("aria-valuemax", bt), Ue.children[0].setAttribute("aria-valuenow", ft), Ue.children[0].setAttribute("aria-valuetext", lt);
          }));
        }));
      }
      function Vt(z) {
        if (z.mode === n.PipsMode.Range || z.mode === n.PipsMode.Steps) return d.xVal;
        if (z.mode === n.PipsMode.Count) {
          if (z.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var Y = z.values - 1, le = 100 / Y, me = []; Y--; ) me[Y] = Y * le;
          return me.push(100), Ft(me, z.stepped);
        }
        return z.mode === n.PipsMode.Positions ? Ft(z.values, z.stepped) : z.mode === n.PipsMode.Values ? z.stepped ? z.values.map((function(De) {
          return d.fromStepping(d.getStep(d.toStepping(De)));
        })) : z.values : [];
      }
      function Ft(z, Y) {
        return z.map((function(le) {
          return d.fromStepping(Y ? d.getStep(le) : le);
        }));
      }
      function ka(z) {
        function Y(ft, lt) {
          return Number((ft + lt).toFixed(7));
        }
        var le = Vt(z), me = {}, De = d.xVal[0], Ee = d.xVal[d.xVal.length - 1], Ue = !1, Me = !1, bt = 0;
        return (le = l(le.slice().sort((function(ft, lt) {
          return ft - lt;
        }))))[0] !== De && (le.unshift(De), Ue = !0), le[le.length - 1] !== Ee && (le.push(Ee), Me = !0), le.forEach((function(ft, lt) {
          var ct, tt, Ct, Dt, pt, Fi, wr, Pi, Bi, zi, xr = ft, Mn = le[lt + 1], Vi = z.mode === n.PipsMode.Steps;
          for (Vi && (ct = d.xNumSteps[lt]), ct || (ct = Mn - xr), Mn === void 0 && (Mn = xr), ct = Math.max(ct, 1e-7), tt = xr; tt <= Mn; tt = Y(tt, ct)) {
            for (Pi = (pt = (Dt = d.toStepping(tt)) - bt) / (z.density || 1), zi = pt / (Bi = Math.round(Pi)), Ct = 1; Ct <= Bi; Ct += 1) me[(Fi = bt + Ct * zi).toFixed(5)] = [d.fromStepping(Fi), 0];
            wr = le.indexOf(tt) > -1 ? n.PipsType.LargeValue : Vi ? n.PipsType.SmallValue : n.PipsType.NoValue, !lt && Ue && tt !== Mn && (wr = 0), tt === Mn && Me || (me[Dt.toFixed(5)] = [tt, wr]), bt = Dt;
          }
        })), me;
      }
      function Is(z, Y, le) {
        var me, De, Ee = $e.createElement("div"), Ue = ((me = {})[n.PipsType.None] = "", me[n.PipsType.NoValue] = S.cssClasses.valueNormal, me[n.PipsType.LargeValue] = S.cssClasses.valueLarge, me[n.PipsType.SmallValue] = S.cssClasses.valueSub, me), Me = ((De = {})[n.PipsType.None] = "", De[n.PipsType.NoValue] = S.cssClasses.markerNormal, De[n.PipsType.LargeValue] = S.cssClasses.markerLarge, De[n.PipsType.SmallValue] = S.cssClasses.markerSub, De), bt = [S.cssClasses.valueHorizontal, S.cssClasses.valueVertical], ft = [S.cssClasses.markerHorizontal, S.cssClasses.markerVertical];
        function lt(tt, Ct) {
          var Dt = Ct === S.cssClasses.value, pt = Dt ? Ue : Me;
          return Ct + " " + (Dt ? bt : ft)[S.ort] + " " + pt[tt];
        }
        function ct(tt, Ct, Dt) {
          if ((Dt = Y ? Y(Ct, Dt) : Dt) !== n.PipsType.None) {
            var pt = wt(Ee, !1);
            pt.className = lt(Dt, S.cssClasses.marker), pt.style[S.style] = tt + "%", Dt > n.PipsType.NoValue && ((pt = wt(Ee, !1)).className = lt(Dt, S.cssClasses.value), pt.setAttribute("data-value", String(Ct)), pt.style[S.style] = tt + "%", pt.innerHTML = String(le.to(Ct)));
          }
        }
        return x(Ee, S.cssClasses.pips), x(Ee, S.ort === 0 ? S.cssClasses.pipsHorizontal : S.cssClasses.pipsVertical), Object.keys(z).forEach((function(tt) {
          ct(tt, z[tt][0], z[tt][1]);
        })), Ee;
      }
      function hr() {
        D && (i(D), D = null);
      }
      function vr(z) {
        hr();
        var Y = ka(z), le = z.filter, me = z.format || { to: function(De) {
          return String(Math.round(De));
        } };
        return D = Te.appendChild(Is(Y, le, me));
      }
      function Li() {
        var z = J.getBoundingClientRect(), Y = "offset" + ["Width", "Height"][S.ort];
        return S.ort === 0 ? z.width || J[Y] : z.height || J[Y];
      }
      function vn(z, Y, le, me) {
        var De = function(Ue) {
          var Me = Ds(Ue, me.pageOffset, me.target || Y);
          return !!Me && !(hn() && !me.doNotReject) && !(b(Te, S.cssClasses.tap) && !me.doNotReject) && !(z === y.start && Me.buttons !== void 0 && Me.buttons > 1) && (!me.hover || !Me.buttons) && (ce || Me.preventDefault(), Me.calcPoint = Me.points[S.ort], void le(Me, me));
        }, Ee = [];
        return z.split(" ").forEach((function(Ue) {
          Y.addEventListener(Ue, De, !!ce && { passive: !0 }), Ee.push([Ue, De]);
        })), Ee;
      }
      function Ds(z, Y, le) {
        var me = z.type.indexOf("touch") === 0, De = z.type.indexOf("mouse") === 0, Ee = z.type.indexOf("pointer") === 0, Ue = 0, Me = 0;
        if (z.type.indexOf("MSPointer") === 0 && (Ee = !0), z.type === "mousedown" && !z.buttons && !z.touches) return !1;
        if (me) {
          var bt = function(ct) {
            var tt = ct.target;
            return tt === le || le.contains(tt) || z.composed && z.composedPath().shift() === le;
          };
          if (z.type === "touchstart") {
            var ft = Array.prototype.filter.call(z.touches, bt);
            if (ft.length > 1) return !1;
            Ue = ft[0].pageX, Me = ft[0].pageY;
          } else {
            var lt = Array.prototype.find.call(z.changedTouches, bt);
            if (!lt) return !1;
            Ue = lt.pageX, Me = lt.pageY;
          }
        }
        return Y = Y || C($e), (De || Ee) && (Ue = z.clientX + Y.x, Me = z.clientY + Y.y), z.pageOffset = Y, z.points = [Ue, Me], z.cursor = De || Ee, z;
      }
      function $i(z) {
        var Y = 100 * (z - v(J, S.ort)) / Li();
        return Y = m(Y), S.dir ? 100 - Y : Y;
      }
      function Os(z) {
        var Y = 100, le = !1;
        return M.forEach((function(me, De) {
          if (!an(De)) {
            var Ee = te[De], Ue = Math.abs(Ee - z);
            (Ue < Y || Ue <= Y && z > Ee || Ue === 100 && Y === 100) && (le = De, Y = Ue);
          }
        })), le;
      }
      function Ms(z, Y) {
        z.type === "mouseout" && z.target.nodeName === "HTML" && z.relatedTarget === null && mr(z, Y);
      }
      function Rs(z, Y) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && z.buttons === 0 && Y.buttonsProperty !== 0) return mr(z, Y);
        var le = (S.dir ? -1 : 1) * (z.calcPoint - Y.startCalcPoint);
        Ii(le > 0, 100 * le / Y.baseSize, Y.locations, Y.handleNumbers, Y.connect);
      }
      function mr(z, Y) {
        Y.handle && (g(Y.handle, S.cssClasses.active), P -= 1), Y.listeners.forEach((function(le) {
          ke.removeEventListener(le[0], le[1]);
        })), P === 0 && (g(Te, S.cssClasses.drag), yr(), z.cursor && (Le.style.cursor = "", Le.removeEventListener("selectstart", s))), S.events.smoothSteps && (Y.handleNumbers.forEach((function(le) {
          mn(le, te[le], !0, !0, !1, !1);
        })), Y.handleNumbers.forEach((function(le) {
          gt("update", le);
        }))), Y.handleNumbers.forEach((function(le) {
          gt("change", le), gt("set", le), gt("end", le);
        }));
      }
      function gr(z, Y) {
        if (!Y.handleNumbers.some(an)) {
          var le;
          Y.handleNumbers.length === 1 && (le = M[Y.handleNumbers[0]].children[0], P += 1, x(le, S.cssClasses.active)), z.stopPropagation();
          var me = [], De = vn(y.move, ke, Rs, { target: z.target, handle: le, connect: Y.connect, listeners: me, startCalcPoint: z.calcPoint, baseSize: Li(), pageOffset: z.pageOffset, handleNumbers: Y.handleNumbers, buttonsProperty: z.buttons, locations: te.slice() }), Ee = vn(y.end, ke, mr, { target: z.target, handle: le, listeners: me, doNotReject: !0, handleNumbers: Y.handleNumbers }), Ue = vn("mouseout", ke, Ms, { target: z.target, handle: le, listeners: me, doNotReject: !0, handleNumbers: Y.handleNumbers });
          me.push.apply(me, De.concat(Ee, Ue)), z.cursor && (Le.style.cursor = getComputedStyle(z.target).cursor, M.length > 1 && x(Te, S.cssClasses.drag), Le.addEventListener("selectstart", s, !1)), Y.handleNumbers.forEach((function(Me) {
            gt("start", Me);
          }));
        }
      }
      function Ns(z) {
        z.stopPropagation();
        var Y = $i(z.calcPoint), le = Os(Y);
        le !== !1 && (S.events.snap || f(Te, S.cssClasses.tap, S.animationDuration), mn(le, Y, !0, !0), yr(), gt("slide", le, !0), gt("update", le, !0), S.events.snap ? gr(z, { handleNumbers: [le] }) : (gt("change", le, !0), gt("set", le, !0)));
      }
      function Fs(z) {
        var Y = $i(z.calcPoint), le = d.getStep(Y), me = d.fromStepping(le);
        Object.keys(ee).forEach((function(De) {
          De.split(".")[0] === "hover" && ee[De].forEach((function(Ee) {
            Ee.call(Ca, me);
          }));
        }));
      }
      function Ps(z, Y) {
        if (hn() || an(Y)) return !1;
        var le = ["Left", "Right"], me = ["Down", "Up"], De = ["PageDown", "PageUp"], Ee = ["Home", "End"];
        S.dir && !S.ort ? le.reverse() : S.ort && !S.dir && (me.reverse(), De.reverse());
        var Ue, Me = z.key.replace("Arrow", ""), bt = Me === De[0], ft = Me === De[1], lt = Me === me[0] || Me === le[0] || bt, ct = Me === me[1] || Me === le[1] || ft, tt = Me === Ee[0], Ct = Me === Ee[1];
        if (!(lt || ct || tt || Ct)) return !0;
        if (z.preventDefault(), ct || lt) {
          var Dt = lt ? 0 : 1, pt = Ni(Y)[Dt];
          if (pt === null) return !1;
          pt === !1 && (pt = d.getDefaultStep(te[Y], lt, S.keyboardDefaultStep)), pt *= ft || bt ? S.keyboardPageMultiplier : S.keyboardMultiplier, pt = Math.max(pt, 1e-7), pt *= lt ? -1 : 1, Ue = ae[Y] + pt;
        } else Ue = Ct ? S.spectrum.xVal[S.spectrum.xVal.length - 1] : S.spectrum.xVal[0];
        return mn(Y, d.toStepping(Ue), !0, !0), gt("slide", Y), gt("update", Y), gt("change", Y), gt("set", Y), !1;
      }
      function Bs(z) {
        z.fixed || M.forEach((function(Y, le) {
          vn(y.start, Y.children[0], gr, { handleNumbers: [le] });
        })), z.tap && vn(y.start, J, Ns, {}), z.hover && vn(y.move, J, Fs, { hover: !0 }), z.drag && re.forEach((function(Y, le) {
          if (Y !== !1 && le !== 0 && le !== re.length - 1) {
            var me = M[le - 1], De = M[le], Ee = [Y], Ue = [me, De], Me = [le - 1, le];
            x(Y, S.cssClasses.draggable), z.fixed && (Ee.push(me.children[0]), Ee.push(De.children[0])), z.dragAll && (Ue = M, Me = k), Ee.forEach((function(bt) {
              vn(y.start, bt, gr, { handles: Ue, handleNumbers: Me, connect: Y });
            }));
          }
        }));
      }
      function br(z, Y) {
        ee[z] = ee[z] || [], ee[z].push(Y), z.split(".")[0] === "update" && M.forEach((function(le, me) {
          gt("update", me);
        }));
      }
      function zs(z) {
        return z === ie.aria || z === ie.tooltips;
      }
      function Gn(z) {
        var Y = z && z.split(".")[0], le = Y ? z.substring(Y.length) : z;
        Object.keys(ee).forEach((function(me) {
          var De = me.split(".")[0], Ee = me.substring(De.length);
          Y && Y !== De || le && le !== Ee || zs(Ee) && le !== Ee || delete ee[me];
        }));
      }
      function gt(z, Y, le) {
        Object.keys(ee).forEach((function(me) {
          var De = me.split(".")[0];
          z === De && ee[me].forEach((function(Ee) {
            Ee.call(Ca, ae.map(S.format.to), Y, ae.slice(), le || !1, te.slice(), Ca);
          }));
        }));
      }
      function Sa(z, Y, le, me, De, Ee, Ue) {
        var Me;
        return M.length > 1 && !S.events.unconstrained && (me && Y > 0 && (Me = d.getAbsoluteDistance(z[Y - 1], S.margin, !1), le = Math.max(le, Me)), De && Y < M.length - 1 && (Me = d.getAbsoluteDistance(z[Y + 1], S.margin, !0), le = Math.min(le, Me))), M.length > 1 && S.limit && (me && Y > 0 && (Me = d.getAbsoluteDistance(z[Y - 1], S.limit, !1), le = Math.min(le, Me)), De && Y < M.length - 1 && (Me = d.getAbsoluteDistance(z[Y + 1], S.limit, !0), le = Math.max(le, Me))), S.padding && (Y === 0 && (Me = d.getAbsoluteDistance(0, S.padding[0], !1), le = Math.max(le, Me)), Y === M.length - 1 && (Me = d.getAbsoluteDistance(100, S.padding[1], !0), le = Math.min(le, Me))), Ue || (le = d.getStep(le)), !((le = m(le)) === z[Y] && !Ee) && le;
      }
      function pr(z, Y) {
        var le = S.ort;
        return (le ? Y : z) + ", " + (le ? z : Y);
      }
      function Ii(z, Y, le, me, De) {
        var Ee = le.slice(), Ue = me[0], Me = S.events.smoothSteps, bt = [!z, z], ft = [z, !z];
        me = me.slice(), z && me.reverse(), me.length > 1 ? me.forEach((function(ct, tt) {
          var Ct = Sa(Ee, ct, Ee[ct] + Y, bt[tt], ft[tt], !1, Me);
          Ct === !1 ? Y = 0 : (Y = Ct - Ee[ct], Ee[ct] = Ct);
        })) : bt = ft = [!0];
        var lt = !1;
        me.forEach((function(ct, tt) {
          lt = mn(ct, le[ct] + Y, bt[tt], ft[tt], !1, Me) || lt;
        })), lt && (me.forEach((function(ct) {
          gt("update", ct), gt("slide", ct);
        })), De != null && gt("drag", Ue));
      }
      function Di(z, Y) {
        return S.dir ? 100 - z - Y : z;
      }
      function Vs(z, Y) {
        te[z] = Y, ae[z] = d.fromStepping(Y);
        var le = "translate(" + pr(Di(Y, 0) - Ye + "%", "0") + ")";
        M[z].style[S.transformRule] = le, Oi(z), Oi(z + 1);
      }
      function yr() {
        k.forEach((function(z) {
          var Y = te[z] > 50 ? -1 : 1, le = 3 + (M.length + Y * z);
          M[z].style.zIndex = String(le);
        }));
      }
      function mn(z, Y, le, me, De, Ee) {
        return De || (Y = Sa(te, z, Y, le, me, !1, Ee)), Y !== !1 && (Vs(z, Y), !0);
      }
      function Oi(z) {
        if (re[z]) {
          var Y = 0, le = 100;
          z !== 0 && (Y = te[z - 1]), z !== re.length - 1 && (le = te[z]);
          var me = le - Y, De = "translate(" + pr(Di(Y, me) + "%", "0") + ")", Ee = "scale(" + pr(me / 100, "1") + ")";
          re[z].style[S.transformRule] = De + " " + Ee;
        }
      }
      function Mi(z, Y) {
        return z === null || z === !1 || z === void 0 ? te[Y] : (typeof z == "number" && (z = String(z)), (z = S.format.from(z)) !== !1 && (z = d.toStepping(z)), z === !1 || isNaN(z) ? te[Y] : z);
      }
      function _a(z, Y, le) {
        var me = c(z), De = te[0] === void 0;
        Y = Y === void 0 || Y, S.animate && !De && f(Te, S.cssClasses.tap, S.animationDuration), k.forEach((function(Me) {
          mn(Me, Mi(me[Me], Me), !0, !1, le);
        }));
        var Ee = k.length === 1 ? 0 : 1;
        if (De && d.hasNoSize() && (le = !0, te[0] = 0, k.length > 1)) {
          var Ue = 100 / (k.length - 1);
          k.forEach((function(Me) {
            te[Me] = Me * Ue;
          }));
        }
        for (; Ee < k.length; ++Ee) k.forEach((function(Me) {
          mn(Me, te[Me], !0, !0, le);
        }));
        yr(), k.forEach((function(Me) {
          gt("update", Me), me[Me] !== null && Y && gt("set", Me);
        }));
      }
      function Hs(z) {
        _a(S.start, z);
      }
      function Us(z, Y, le, me) {
        if (!((z = Number(z)) >= 0 && z < k.length)) throw new Error("noUiSlider: invalid handle number, got: " + z);
        mn(z, Mi(Y, z), !0, !0, me), gt("update", z), le && gt("set", z);
      }
      function Ri(z) {
        if (z === void 0 && (z = !1), z) return ae.length === 1 ? ae[0] : ae.slice(0);
        var Y = ae.map(S.format.to);
        return Y.length === 1 ? Y[0] : Y;
      }
      function qs() {
        for (Gn(ie.aria), Gn(ie.tooltips), Object.keys(S.cssClasses).forEach((function(z) {
          g(Te, S.cssClasses[z]);
        })); Te.firstChild; ) Te.removeChild(Te.firstChild);
        delete Te.noUiSlider;
      }
      function Ni(z) {
        var Y = te[z], le = d.getNearbySteps(Y), me = ae[z], De = le.thisStep.step, Ee = null;
        if (S.snap) return [me - le.stepBefore.startValue || null, le.stepAfter.startValue - me || null];
        De !== !1 && me + De > le.stepAfter.startValue && (De = le.stepAfter.startValue - me), Ee = me > le.thisStep.startValue ? le.thisStep.step : le.stepBefore.step !== !1 && me - le.stepBefore.highestStep, Y === 100 ? De = null : Y === 0 && (Ee = null);
        var Ue = d.countStepDecimals();
        return De !== null && De !== !1 && (De = Number(De.toFixed(Ue))), Ee !== null && Ee !== !1 && (Ee = Number(Ee.toFixed(Ue))), [Ee, De];
      }
      function js() {
        return k.map(Ni);
      }
      function Zs(z, Y) {
        var le = Ri(), me = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        me.forEach((function(Ee) {
          z[Ee] !== void 0 && (w[Ee] = z[Ee]);
        }));
        var De = Qe(w);
        me.forEach((function(Ee) {
          z[Ee] !== void 0 && (S[Ee] = De[Ee]);
        })), d = De.spectrum, S.margin = De.margin, S.limit = De.limit, S.padding = De.padding, S.pips ? vr(S.pips) : hr(), S.tooltips ? It() : st(), te = [], _a(a(z.start) ? z.start : le, Y);
      }
      function Ws() {
        J = _t(Te), mt(S.connect, J), Bs(S.events), _a(S.start), S.pips && vr(S.pips), S.tooltips && It(), xt();
      }
      Ws();
      var Ca = { destroy: qs, steps: js, on: br, off: Gn, get: Ri, set: _a, setHandle: Us, reset: Hs, __moveHandles: function(z, Y, le) {
        Ii(z, Y, te, le);
      }, options: w, updateOptions: Zs, target: Te, removePips: hr, removeTooltips: st, getPositions: function() {
        return te.slice();
      }, getTooltips: function() {
        return Q;
      }, getOrigins: function() {
        return M;
      }, pips: vr };
      return Ca;
    }
    function vt(N, S) {
      if (!N || !N.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + N);
      if (N.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var w = ht(N, Qe(S), S);
      return N.noUiSlider = w, w;
    }
    var et = { __spectrum: H, cssClasses: G, create: vt };
    n.create = vt, n.cssClasses = G, n.default = et, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function ao(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, o) {
    return r === n[o];
  }));
}
var ii = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, s, l) {
    const { value: h, modelValue: v, min: u } = Ea(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = pe(f.value);
    if (Ma(f.value) && (f = pe(u.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, s, l) {
    const { classes: h, showTooltip: v, tooltipPosition: u, orientation: f } = Ea(a), m = W((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: W((() => {
      const c = { ...m.value };
      return Object.keys(c).forEach(((p) => {
        c[p] = Array.isArray(c[p]) ? c[p].filter(((x) => x !== null)).join(" ") : c[p];
      })), v.value !== "always" && (c.target += ` ${v.value === "drag" ? c.tooltipDrag : c.tooltipFocus}`), f.value === "horizontal" && (c.tooltip += u.value === "bottom" ? ` ${c.tooltipBottom}` : ` ${c.tooltipTop}`), f.value === "vertical" && (c.tooltip += u.value === "right" ? ` ${c.tooltipRight}` : ` ${c.tooltipLeft}`), c;
    })) };
  })(e), o = (function(a, s, l) {
    const { format: h, step: v } = Ea(a), u = l.value, f = l.classList, m = W((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : no({ ...h.value }) : no({ decimals: v.value >= 0 ? 0 : 2 }))), c = W((() => Array.isArray(u.value) ? u.value.map(((p) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: c, tooltipsMerge: (p, x, g) => {
      var b = getComputedStyle(p).direction === "rtl", C = p.noUiSlider.options.direction === "rtl", A = p.noUiSlider.options.orientation === "vertical", I = p.noUiSlider.getTooltips(), L = p.noUiSlider.getOrigins();
      I.forEach((function(E, F) {
        E && L[F].appendChild(E);
      })), p.noUiSlider.on("update", (function(E, F, U, K, O) {
        var V = [[]], B = [[]], _ = [[]], T = 0;
        I[0] && (V[0][0] = 0, B[0][0] = O[0], _[0][0] = m.value.to(parseFloat(E[0])));
        for (var R = 1; R < E.length; R++) (!I[R] || E[R] - E[R - 1] > x) && (V[++T] = [], _[T] = [], B[T] = []), I[R] && (V[T].push(R), _[T].push(m.value.to(parseFloat(E[R]))), B[T].push(O[R]));
        V.forEach((function(H, q) {
          for (var G = H.length, ie = 0; ie < G; ie++) {
            var X = H[ie];
            if (ie === G - 1) {
              var oe = 0;
              B[q].forEach((function(fe) {
                oe += 1e3 - fe;
              }));
              var ue = A ? "bottom" : "right", he = C ? 0 : G - 1, be = 1e3 - B[q][he];
              oe = (b && !A ? 100 : 0) + oe / G - be, I[X].innerHTML = _[q].join(g), I[X].style.display = "block", I[X].style[ue] = oe + "%", f.value.tooltipHidden.split(" ").forEach(((fe) => {
                I[X].classList.contains(fe) && I[X].classList.remove(fe);
              }));
            } else I[X].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((fe) => {
              I[X].classList.add(fe);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, s, l) {
    const { orientation: h, direction: v, tooltips: u, step: f, min: m, max: c, merge: p, id: x, disabled: g, options: b, classes: C, format: A, lazy: I, ariaLabelledby: L, aria: E } = Ea(a), F = l.value, U = l.initialValue, K = l.tooltipsFormat, O = l.tooltipsMerge, V = l.tooltipFormat, B = l.classList, _ = pe(null), T = pe(null), R = pe(!1), H = W((() => {
      let fe = { cssPrefix: "", cssClasses: B.value, orientation: h.value, direction: v.value, tooltips: !!u.value && K.value, connect: "lower", start: Ma(F.value) ? m.value : F.value, range: { min: m.value, max: c.value } };
      if (f.value > 0 && (fe.step = f.value), Array.isArray(F.value) && (fe.connect = !0), L && L.value || E && Object.keys(E.value).length) {
        let we = Array.isArray(F.value) ? F.value : [F.value];
        fe.handleAttributes = we.map(((Ae) => Object.assign({}, E.value, L && L.value ? { "aria-labelledby": L.value } : {})));
      }
      return A.value && (fe.ariaFormat = V.value), fe;
    })), q = W((() => {
      let fe = { id: x && x.value ? x.value : void 0 };
      return g.value && (fe.disabled = !0), fe;
    })), G = W((() => Array.isArray(F.value))), ie = () => {
      let fe = T.value.get();
      return Array.isArray(fe) ? fe.map(((we) => parseFloat(we))) : parseFloat(fe);
    }, X = function(fe) {
      let we = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      T.value.set(fe, we);
    }, oe = (fe) => {
      s.emit("input", fe), s.emit("update:modelValue", fe), s.emit("update", fe);
    }, ue = () => {
      T.value = ng.create(_.value, Object.assign({}, H.value, b.value)), u.value && G.value && p.value >= 0 && O(_.value, p.value, " - "), T.value.on("set", (() => {
        const fe = ie();
        s.emit("change", fe), s.emit("set", fe), I.value && oe(fe);
      })), T.value.on("update", (() => {
        if (!R.value) return;
        const fe = ie();
        G.value && ao(F.value, fe) || !G.value && F.value == fe ? s.emit("update", fe) : I.value || oe(fe);
      })), T.value.on("start", (() => {
        s.emit("start", ie());
      })), T.value.on("end", (() => {
        s.emit("end", ie());
      })), T.value.on("slide", (() => {
        s.emit("slide", ie());
      })), T.value.on("drag", (() => {
        s.emit("drag", ie());
      })), _.value.querySelectorAll("[data-handle]").forEach(((fe) => {
        fe.onblur = () => {
          _.value && B.value.focused.split(" ").forEach(((we) => {
            _.value.classList.remove(we);
          }));
        }, fe.onfocus = () => {
          B.value.focused.split(" ").forEach(((we) => {
            _.value.classList.add(we);
          }));
        };
      })), R.value = !0;
    }, he = () => {
      T.value.off(), T.value.destroy(), T.value = null;
    }, be = (fe, we) => {
      R.value = !1, he(), ue();
    };
    return St(ue), In(he), He(G, be, { immediate: !1 }), He(m, be, { immediate: !1 }), He(c, be, { immediate: !1 }), He(f, be, { immediate: !1 }), He(h, be, { immediate: !1 }), He(v, be, { immediate: !1 }), He(u, be, { immediate: !1 }), He(p, be, { immediate: !1 }), He(A, be, { immediate: !1, deep: !0 }), He(b, be, { immediate: !1, deep: !0 }), He(C, be, { immediate: !1, deep: !0 }), He(F, ((fe, we) => {
      we && (typeof we == "object" && typeof fe == "object" && fe && Object.keys(we) > Object.keys(fe) || typeof we == "object" && typeof fe != "object" || Ma(fe)) && be();
    }), { immediate: !1 }), He(F, ((fe) => {
      if (Ma(fe)) return void X(m.value, !1);
      let we = ie();
      G.value && !Array.isArray(we) && (we = [we]), (G.value && !ao(fe, we) || !G.value && fe != we) && X(fe, !1);
    }), { deep: !0 }), { slider: _, slider$: T, isRange: G, sliderProps: q, init: ue, destroy: he, refresh: be, update: X, reset: () => {
      oe(U.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: o.tooltipFormat, tooltipsFormat: o.tooltipsFormat, tooltipsMerge: o.tooltipsMerge, classList: r.classList });
  return { ...r, ...o, ...i };
} };
ii.render = function(e, t, n, r, o, i) {
  return $(), j("div", Ce(e.sliderProps, { ref: "slider" }), null, 16);
}, ii.__file = "src/Slider.vue";
const ag = ["data-click-name"], rg = { class: "lc-slider__wrap" }, ig = {
  key: 0,
  class: "lc-slider__min"
}, lg = {
  key: 0,
  class: "lc-slider__slider-marks"
}, og = ["data-testid"], sg = {
  key: 1,
  class: "lc-slider__max"
}, cg = 1, J2 = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = pe(!1), r = nt("slider"), o = t, i = W({
      get: () => e.value,
      set: (f) => o("update:value", f)
    }), a = W(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), s = W(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + cg;
      return Array.from({ length: f }, (m, c) => c);
    }), l = (f) => {
      const m = r.value;
      if (!m) return;
      const c = new Event(f, { bubbles: !0 });
      m.dispatchEvent(c);
    }, h = () => {
      n.value || (l("focusin"), l("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", l(f);
    }, u = (f) => ["max", "min"].includes(String(f));
    return (f, m) => ($(), j("div", {
      ref: "slider",
      class: ye(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ne("div", rg, [
        e.hideMin ? se("", !0) : ($(), j("span", ig, [
          ve(f.$slots, "min", Ot(Pt({ min: e.min })), () => [
            kt(Ie(e.format(e.min)), 1)
          ])
        ])),
        ne("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = ca(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = ca(() => v("focusout"), ["stop"]))
        }, [
          Re(Z(ii), Ce({
            ...en(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (c) => i.value = c),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? se("", !0) : ($(), j("div", lg, [
            ($(!0), j(rt, null, yt(s.value, (c) => ($(), j("span", {
              key: c,
              class: ye(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${c}`]: u(c)
              }]),
              "data-testid": `lc-slider-mark-${c}`,
              style: Et(
                typeof c == "string" && !u(c) ? `left:${c}%` : null
              )
            }, null, 14, og))), 128))
          ]))
        ], 32),
        e.hideMax ? se("", !0) : ($(), j("span", sg, [
          ve(f.$slots, "max", Ot(Pt({ max: e.max })), () => [
            kt(Ie(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, ag));
  }
});
function Sn() {
  return Sn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sn.apply(this, arguments);
}
var ug = 0.996, dg = function(t, n) {
  return n === void 0 && (n = ug), t * n / (1 - n);
};
function fg(e) {
  return e[e.length - 1];
}
function hg(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var vg = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function qr(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function ro(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Xn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Xn(t);
  }), e;
}
function mg() {
  var e = {};
  function t(o, i) {
    return e[o] = (e[o] || []).concat(i), function() {
      return n(o, i);
    };
  }
  function n(o, i) {
    e[o] = (e[o] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(o, i) {
    o in e && e[o].forEach(function(a) {
      return a(i);
    });
  }
  return Xn({
    on: t,
    off: n,
    dispatch: r
  });
}
function gg(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(s) {
      return s !== a;
    });
  }, o = function() {
    t.forEach(r);
  };
  return Xn({
    observe: n,
    unobserve: r,
    disconnect: o
  });
}
var bg = 16 * 1.125, pg = typeof window < "u" && window.innerHeight || 800, jr = [1, bg, pg];
function yg(e) {
  var t = e.deltaX * jr[e.deltaMode], n = e.deltaY * jr[e.deltaMode], r = (e.deltaZ || 0) * jr[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var wg = [-1, -1, -1];
function xg(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? wg : t.map(function(r) {
    return r ? -1 : 1;
  });
  return Sn({}, e, {
    axisDelta: e.axisDelta.map(function(r, o) {
      return r * n[o];
    })
  });
}
var io = 700, kg = function(t) {
  return Sn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return vg(n, -io, io);
    })
  });
}, Zr = process.env.NODE_ENV !== "production", Sg = 0.6, _g = 0.96, Cg = 2, lo = 5, oo = /* @__PURE__ */ Xn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Eg = 400;
function so() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Eg
  };
}
function Tg(e) {
  e === void 0 && (e = {});
  var t = mg(), n = t.on, r = t.off, o = t.dispatch, i = oo, a = so(), s, l = !1, h, v = function(_) {
    Array.isArray(_) ? _.forEach(function(T) {
      return c(T);
    }) : c(_);
  }, u = function(_) {
    return _ === void 0 && (_ = {}), Object.values(_).some(function(T) {
      return T == null;
    }) ? (Zr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Xn(Sn({}, oo, i, _));
  }, f = function(_) {
    var T = Sn({
      event: s,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return qr(T.axisMovement, T.axisVelocity.map(function(R) {
          return dg(R);
        }));
      }
    }, _);
    o("wheel", Sn({}, T, {
      previous: h
    })), h = T;
  }, m = function(_, T) {
    var R = i, H = R.preventWheelAction, q = T[0], G = T[1], ie = T[2];
    if (typeof H == "boolean") return H;
    switch (H) {
      case "x":
        return Math.abs(q) >= _;
      case "y":
        return Math.abs(G) >= _;
      case "z":
        return Math.abs(ie) >= _;
      default:
        return Zr && console.warn("unsupported preventWheelAction value: " + H, "warn"), !1;
    }
  }, c = function(_) {
    var T = kg(xg(yg(_), i.reverseSign)), R = T.axisDelta, H = T.timeStamp, q = ro(R);
    if (_.preventDefault && m(q, R) && _.preventDefault(), a.isStarted ? a.isMomentum && q > Math.max(2, a.lastAbsDelta * 2) && (F(!0), L()) : L(), q === 0 && Object.is && Object.is(_.deltaX, -0)) {
      l = !0;
      return;
    }
    s = _, a.axisMovement = qr(a.axisMovement, R), a.lastAbsDelta = q, a.scrollPointsToMerge.push({
      axisDelta: R,
      timeStamp: H
    }), p(), f({
      axisDelta: R,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, E();
  }, p = function() {
    a.scrollPointsToMerge.length === Cg ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(_) {
        return _.axisDelta;
      }).reduce(qr),
      timeStamp: hg(a.scrollPointsToMerge.map(function(_) {
        return _.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || A()) : a.isStartPublished || x();
  }, x = function() {
    a.axisVelocity = fg(a.scrollPointsToMerge).axisDelta.map(function(_) {
      return _ / a.willEndTimeout;
    });
  }, g = function() {
    var _ = a.scrollPoints, T = _[0], R = _[1];
    if (!(!R || !T)) {
      var H = T.timeStamp - R.timeStamp;
      if (H <= 0) {
        Zr && console.warn("invalid deltaTime");
        return;
      }
      var q = T.axisDeltaSum.map(function(ie) {
        return ie / H;
      }), G = q.map(function(ie, X) {
        return ie / (a.axisVelocity[X] || 1);
      });
      a.axisVelocity = q, a.accelerationFactors.push(G), b(H);
    }
  }, b = function(_) {
    var T = Math.ceil(_ / 10) * 10 * 1.2;
    a.isMomentum || (T = Math.max(100, T * 2)), a.willEndTimeout = Math.min(1e3, Math.round(T));
  }, C = function(_) {
    return _ === 0 ? !0 : _ <= _g && _ >= Sg;
  }, A = function() {
    if (a.accelerationFactors.length >= lo) {
      if (l && (l = !1, ro(a.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var _ = a.accelerationFactors.slice(lo * -1), T = _.every(function(R) {
        var H = !!R.reduce(function(G, ie) {
          return G && G < 1 && G === ie ? 1 : 0;
        }), q = R.filter(C).length === R.length;
        return H || q;
      });
      T && I(), a.accelerationFactors = _;
    }
  }, I = function() {
    a.isMomentum = !0;
  }, L = function() {
    a = so(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, l = !1;
  }, E = /* @__PURE__ */ (function() {
    var B;
    return function() {
      clearTimeout(B), B = setTimeout(F, a.willEndTimeout);
    };
  })(), F = function(_) {
    _ === void 0 && (_ = !1), a.isStarted && (a.isMomentum && _ ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, U = gg(v), K = U.observe, O = U.unobserve, V = U.disconnect;
  return u(e), Xn({
    on: n,
    off: r,
    observe: K,
    unobserve: O,
    disconnect: V,
    feedWheel: v,
    updateOptions: u
  });
}
var Ag = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
Ai.globalOptions = void 0;
var Lg = process.env.NODE_ENV !== "production";
function Ai(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var s, l, h = a.mergeOptions, v = a.optionsAtMedia, u = h(Ag, Ai.globalOptions), f = h(u, e);
    t = v(f);
    var m = i.internalEngine(), c = (s = t.target) != null ? s : i.containerNode().parentNode, p = (l = t.forceWheelAxis) != null ? l : m.options.axis, x = Tg({
      preventWheelAction: p,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      E = (p === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = x.observe(c), C = x.on("wheel", q), A = !1, I, L = 0, E = 0, F = !1;
    g(), i.on("resize", g);
    function U(G) {
      try {
        I = new MouseEvent("mousedown", G.event), T(I);
      } catch {
        return Lg && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      A = !0, L = 0, O(), t.wheelDraggingClass && c.classList.add(t.wheelDraggingClass);
    }
    function K(G) {
      A = !1, T(_("mouseup", G)), V(), t.wheelDraggingClass && c.classList.remove(t.wheelDraggingClass);
    }
    function O() {
      document.documentElement.addEventListener("mousemove", B, !0), document.documentElement.addEventListener("mouseup", B, !0), document.documentElement.addEventListener("mousedown", B, !0);
    }
    function V() {
      document.documentElement.removeEventListener("mousemove", B, !0), document.documentElement.removeEventListener("mouseup", B, !0), document.documentElement.removeEventListener("mousedown", B, !0);
    }
    function B(G) {
      A && G.isTrusted && G.stopImmediatePropagation();
    }
    function _(G, ie) {
      var X, oe;
      if (p === m.options.axis) {
        var ue = ie.axisMovement;
        X = ue[0], oe = ue[1];
      } else {
        var he = ie.axisMovement;
        oe = he[0], X = he[1];
      }
      var be = R(ie), fe = be.isAtBoundary;
      if (fe) {
        var we = Math.min(L / E, 1), Ae = 0.25 + we * 0.5, Oe = X > 0 ? -1 : 1, We = L * Oe, Fe = We * Ae;
        X += Fe, oe += Fe;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var de = m.containerRect.width, Ne = m.containerRect.height;
        X = X < 0 ? Math.max(X, -de) : Math.min(X, de), oe = oe < 0 ? Math.max(oe, -Ne) : Math.min(oe, Ne);
      }
      return new MouseEvent(G, {
        clientX: I.clientX + X,
        clientY: I.clientY + oe,
        screenX: I.screenX + X,
        screenY: I.screenY + oe,
        movementX: X,
        movementY: oe,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function T(G) {
      i.containerNode().dispatchEvent(G);
    }
    function R(G) {
      var ie = G.axisDelta, X = ie[0], oe = ie[1], ue = i.scrollProgress(), he = ue < 1, be = ue > 0, fe = p === "x" ? X : oe, we = fe < 0, Ae = fe > 0, Oe = we && !he || Ae && !be;
      return {
        isAtBoundary: Oe,
        primaryAxisDelta: fe
      };
    }
    function H(G) {
      var ie = R(G), X = ie.isAtBoundary, oe = ie.primaryAxisDelta;
      if (X && !G.isMomentum) {
        if (L += Math.abs(oe), L > E)
          return F = !0, K(G), !0;
      } else
        L = 0;
      return !1;
    }
    function q(G) {
      var ie = G.axisDelta, X = ie[0], oe = ie[1], ue = p === "x" ? X : oe, he = p === "x" ? oe : X, be = G.isMomentum && G.previous && !G.previous.isMomentum, fe = G.isEnding && !G.isMomentum || be, we = Math.abs(ue) > Math.abs(he);
      we && !A && !G.isMomentum && !F && U(G), F && G.isEnding && (F = !1), A && (H(G) || (fe ? K(G) : T(_("mousemove", G))));
    }
    n = function() {
      b(), C(), i.off("resize", g), V();
    };
  }
  var o = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return o;
}
const $g = { class: "lc-slot-wheel__wrap" }, Q2 = /* @__PURE__ */ Se({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      nr({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      Ai()
    ], [a, s] = rr(
      {
        ...o,
        startIndex: Math.max(
          0,
          e.options.findIndex((L) => L.value === e.value)
        )
      },
      i
    ), l = $n(ei, () => null, !0), h = wo(), v = () => {
      s.value?.reInit({
        ...o,
        watchDrag: !1
      });
    }, u = () => {
      s.value?.reInit({
        ...o,
        watchDrag: !0
      });
    }, f = (L) => Math.max(
      0,
      e.options.findIndex((E) => E.value === L)
    ), m = (L) => !L || h.value === "reduce", c = (L, E = !0) => {
      s.value?.scrollTo(f(L), m(E));
    }, p = () => {
      I(), r("ready");
    }, x = () => {
      l?.disable();
    }, g = () => {
      l?.enable();
    }, b = () => {
      I(), r("reInit");
    }, C = () => {
      const L = s.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[L].value);
    }, A = () => {
      r("optionsChanged");
    }, I = () => {
      if (!s.value) return;
      const { rootNode: L, slideNodes: E } = s.value, U = L().getBoundingClientRect(), K = U.top + U.height / 2;
      E().forEach((O) => {
        const V = O.getBoundingClientRect(), T = (V.top + V.height / 2 - K) / (U.height / 2), R = Math.max(-1, Math.min(1, T)), H = 1 - Math.abs(R) * 0.3, q = O.style.transform.split(" ").filter((G) => !G.startsWith("scale("));
        q.push(`scale(${H})`), O.style.transform = q.join(" ");
      });
    };
    return St(() => {
      s.value && s.value.on("init", p).on("pointerDown", x).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", C).on("slidesChanged", A);
    }), He(
      () => e.value,
      (L) => c(L)
    ), t({
      disable: v,
      enable: u,
      moveToOption: c
    }), (L, E) => ($(), j("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      ne("div", $g, [
        ($(!0), j(rt, null, yt(e.options, (F, U) => ($(), j("div", {
          key: `${F.label}-${F.value}`,
          className: "lc-slot-wheel__option"
        }, [
          ve(L.$slots, "option", Ce({ ref_for: !0 }, { index: U, option: F }), () => [
            kt(Ie(F.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), Ig = "checkmark", eb = ["info", "success"], Dg = ["for"], Og = ["id", "aria-label", "data-click-name"], Mg = { class: "lc-switch__toggle" }, tb = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: () => Ig },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = $t(e.id), { vibrate: o } = xo(), i = W(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = W({
      get: () => e.value,
      set: (s) => {
        n("update:value", s), o();
      }
    });
    return (s, l) => ($(), j("label", {
      class: ye([i.value, s.$attrs.class]),
      for: Z(r)
    }, [
      Qt(ne("input", Ce({
        ...en(s.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: Z(r),
        "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: l[1] || (l[1] = ci((h) => a.value = !a.value, ["enter"]))
      }), null, 16, Og), [
        [ho, a.value]
      ]),
      l[2] || (l[2] = ne("div", { class: "lc-switch__track" }, null, -1)),
      ne("div", Mg, [
        Re(Z(Je), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, Dg));
  }
}), nb = /* @__PURE__ */ Se({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = W(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => ($(), j("table", {
      class: ye(t.value)
    }, [
      ve(n.$slots, "default")
    ], 2));
  }
}), ab = ["medium", "small", "none"], rb = ["column", "row"], ib = ["bottom", "top"], lb = ["automatic", "manual"], ob = ["default", "divider"], sb = /* @__PURE__ */ Symbol();
var Bn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Bn || {});
const Rg = ["id"], Ng = { class: "lc-tabs__tablist-inner" }, Fg = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], Pg = {
  key: 1,
  class: "lc-tabs__header"
}, Bg = ["aria-labelledby"], zg = ["id", "aria-labelledby"], cb = /* @__PURE__ */ Se({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = nt("carousel"), i = nt("container"), a = nt("tabs"), s = $t(e.id), l = pe(0), h = pe(0), v = pe(null), u = pe(null), f = pe(!1), m = pe(!1);
    let c = null;
    const p = W(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), x = () => {
      m.value = !0, c && clearTimeout(c), c = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const O = a.value?.[l.value];
      O && (v.value = `${O.offsetWidth}px`, u.value = `${O.offsetLeft}px`);
    };
    qt(window, "resize", [g, x]), fc(i, g);
    const b = W(() => e.tabs.length <= 1), C = (O, V) => {
      O !== l.value && (l.value = O, V?.skipCarousel || o.value?.moveToIndex(O), V?.skipUpdateEvent || r("update:value", e.tabs[O].name));
    }, A = (O) => {
      a.value?.[O].focus();
    }, I = (O) => {
      if (O !== l.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, L = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, E = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, F = (O) => e.tabs.findIndex((V) => V.name === O), U = (O) => {
      if (!tn(O.key, Bn)) return;
      O.preventDefault(), O.stopPropagation();
      let V;
      switch (O.key) {
        case Bn.ArrowLeft:
          V = E();
          break;
        case Bn.ArrowRight:
          V = L();
          break;
        case Bn.End:
          V = e.tabs.length - 1;
          break;
        case Bn.Home:
          V = 0;
          break;
      }
      h.value = V, e.trigger === "automatic" && C(V);
    }, K = () => {
      const O = F(e.value);
      O !== -1 && (l.value = O, h.value = O);
    };
    return tc(K), nc(K), St(() => {
      g(), b.value || (f.value = !0);
    }), He(l, g), He(h, A), He(
      () => e.value,
      (O) => {
        if (!O) return;
        const V = F(O);
        V !== -1 && C(V, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (O, V) => ($(), j("section", {
      id: Z(s),
      class: ye(p.value)
    }, [
      ve(O.$slots, "top"),
      b.value ? se("", !0) : ($(), j("div", {
        key: 0,
        ref: "container",
        class: ye(["lc-tabs__nav_container", e.containerClass])
      }, [
        ne("nav", {
          class: ye(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Et({
            "--active-tab-index": l.value,
            ...u.value && { "--indicator-offset": u.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ne("div", Ng, [
            ($(!0), j(rt, null, yt(e.tabs, (B, _) => ($(), j("button", {
              id: `${Z(s)}-tab-${_}`,
              key: B.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${Z(s)}-tabpanel-${_}`,
              "aria-selected": l.value === _,
              class: ye(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: l.value !== _ ? -1 : void 0,
              type: "button",
              onClickPassive: (T) => C(_),
              onKeydown: U
            }, [
              O.$slots.tab ? ve(O.$slots, "tab", Ce({ ref_for: !0 }, { tab: B, index: _ }), void 0, void 0, 0) : ($(), j(rt, { key: 1 }, [
                B.icon ? ($(), xe(Z(Je), {
                  key: 0,
                  name: B.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : se("", !0),
                kt(" " + Ie(B.title ?? B.name), 1)
              ], 64))
            ], 42, Fg))), 128))
          ])
        ], 6),
        ve(O.$slots, "subnav")
      ], 2)),
      O.$slots.header ? ($(), j("header", Pg, [
        ve(O.$slots, "header")
      ])) : se("", !0),
      !f.value && e.tabs.length > 0 ? ($(), j("div", {
        key: 2,
        "aria-labelledby": `${Z(s)}-tab-${l.value}`,
        class: ye(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        ve(O.$slots, "tab-panel", {
          index: l.value,
          tab: e.tabs[l.value]
        })
      ], 8, Bg)) : se("", !0),
      b.value ? se("", !0) : ($(), xe(Z(pf), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: ye(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": l.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: V[0] || (V[0] = (B) => C(B, { skipCarousel: !0 })),
        onReady: V[1] || (V[1] = (B) => f.value = !0)
      }, {
        slide: _e(({ index: B, isVisible: _, slide: T }) => [
          ne("div", Ce({
            id: `${Z(s)}-tabpanel-${B}`
          }, I(B), {
            "aria-labelledby": `${Z(s)}-tab-${B}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || _ || B === l.value ? ve(O.$slots, "tab-panel", Ot(Pt({ tab: T, index: B })), void 0, void 0, 0) : se("", !0)
          ], 16, zg)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, Rg));
  }
}), Vg = ["for"], Hg = ["id"], Ug = ["id", "aria-labelledby", "data-click-error", "data-click-name"], qg = { class: "lc-textarea__feedback-wrap" }, jg = { class: "lc-textarea__counter" }, ub = /* @__PURE__ */ Se({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = nt("textarea"), o = $t(e.id), i = pe(!1), a = W(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), s = W(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), l = W(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = W({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return St(() => {
      e.autofocus && r.value?.focus();
    }), (v, u) => ($(), j("div", {
      class: ye([a.value, v.$attrs.class])
    }, [
      ne("label", {
        class: "lc-textarea__wrap",
        for: Z(o)
      }, [
        e.label ? ($(), j("span", {
          key: 0,
          id: `${Z(o)}-label`,
          class: ye(l.value)
        }, Ie(e.label), 11, Hg)) : se("", !0),
        Qt(ne("textarea", Ce({
          id: Z(o),
          ref: "textarea"
        }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${Z(o)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: u[1] || (u[1] = (f) => i.value = !0),
          onFocusout: u[2] || (u[2] = (f) => i.value = !1)
        }), null, 16, Ug), [
          [ac, h.value]
        ])
      ], 8, Vg),
      ne("div", qg, [
        e.noFeedback ? se("", !0) : ($(), xe(Z(Dn), Ce({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ne("span", jg, [
          ne("span", null, Ie(s.value) + "/" + Ie(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), Zg = "info", db = ["danger", "info", "success", "warning", "win"], Wg = { class: "lc-toast__indicator" }, Xg = { class: "lc-toast__content" }, Yg = {
  key: 0,
  class: "lc-toast__title"
}, Gg = {
  key: 0,
  class: "lc-toast__text"
}, fb = /* @__PURE__ */ Se({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: () => Zg }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => ($(), j("article", {
      class: ye(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ne("aside", Wg, [
        Re(Z(Je), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ne("section", Xg, [
        e.headline ? ($(), j("span", Yg, Ie(e.headline), 1)) : se("", !0),
        ve(n.$slots, "default", {}, () => [
          e.text ? ($(), j("p", Gg, Ie(e.text), 1)) : se("", !0)
        ])
      ]),
      e.closable ? ($(), xe(Z(Tt), {
        key: 0,
        "aria-label": Z(Ze).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (o) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : se("", !0)
    ], 2));
  }
}), Kg = ["left", "right"], As = 0.4, Jg = 0.75, co = 0.85, Qg = 0.2, uo = 150, e1 = 8, t1 = As, n1 = 400, a1 = 1800, r1 = 300, i1 = "cubic-bezier(0.22, 1, 0.36, 1)", l1 = "cubic-bezier(0.4, 0, 0.2, 1)", o1 = {
  key: 1,
  class: "lc-swipeable__action-label"
}, hb = /* @__PURE__ */ Se({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, o = nt("lcSwipeableRef"), i = cn(), a = pe(null), s = pe(0), l = pe(0), h = pe(0), v = pe(!1), u = pe(!1), f = pe(!1), m = pe(!1), c = pe(!1), p = pe(null), x = pe(!1), g = pe(null);
    let b = 0, C = null, A = null, I = 0;
    const { direction: L, distanceX: E } = hc(o, {
      onSwipe: () => {
        if (g.value === null || e.disabled || c.value || !o.value)
          return;
        v.value || oe();
        const ge = o.value.clientWidth, Be = l.value - E.value, ze = G(Be);
        if (ze && !_(ze)) {
          s.value = 0;
          return;
        }
        const Ke = R(ze), Qe = q(Be, ge, T(ze));
        m.value = ie(ge, Ke), h.value = Math.min(1, Math.abs(E.value) / (ge * Ke));
        const ht = !!(ze && B(ze)?.fullSwipe && m.value);
        ue(ht), he(ze), s.value = ht && ze ? X(ze, ge) : Qe, ze && ze !== a.value && be(ze);
      },
      onSwipeEnd: (ge, Be) => qe(Be),
      pointerTypes: e.pointerTypes,
      threshold: e1
    }), F = W(() => Kg.map((ge) => ({ action: B(ge), side: ge }))), U = W(() => v.value && !u.value), K = W(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": U.value }
    ]), O = W(() => ({
      transform: `translateX(${s.value}px)`,
      ...p.value === null ? {} : { transition: p.value }
    })), V = W(() => co + (1 - co) * h.value), B = (ge) => ge === "left" ? e.leftAction : ge === "right" ? e.rightAction : void 0, _ = (ge) => !!(B(ge) || i[`${ge}-action`]), T = (ge) => B(ge)?.resistanceThreshold ?? Jg, R = (ge) => {
      const Be = B(ge);
      return Be?.fullSwipe ? T(ge) : Be?.activationThreshold ?? As;
    }, H = () => {
      if (!o.value) return 0;
      const ge = o.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!ge) return 0;
      const Be = getComputedStyle(ge).transform;
      if (!Be || Be === "none") return 0;
      const ze = new DOMMatrix(Be).m41;
      return Number.isFinite(ze) ? ze : 0;
    }, q = (ge, Be, ze) => {
      const Ke = Be * ze, Qe = Math.abs(ge);
      if (Qe <= Ke) return ge;
      const ht = Be * Qg, et = (1 - 1 / ((Qe - Ke) / ht + 1)) * ht;
      return Math.sign(ge) * (Ke + et);
    }, G = (ge) => ge < 0 ? "left" : ge > 0 ? "right" : null, ie = (ge, Be) => Math.abs(E.value) >= ge * Be, X = (ge, Be) => ge === "left" ? -Be : Be, oe = () => {
      l.value = H(), v.value = !0, g.value !== null && Oe(g.value);
    }, ue = (ge) => {
      ge !== f.value && (f.value = ge, u.value = !0, b = performance.now());
    }, he = (ge) => {
      !u.value || f.value || !(performance.now() - b >= uo) && ge === a.value || (u.value = !1);
    }, be = (ge) => {
      a.value = ge, x.value = !0, r("swipe-start", ge);
    }, fe = () => {
      !x.value || !a.value || (x.value = !1, r("swipe-end", a.value));
    }, we = () => {
      l.value = 0, h.value = 0, v.value = !1, f.value = !1, u.value = !1;
    }, Ae = (ge) => !e.pointerTypes || e.pointerTypes.includes(ge.pointerType), Oe = (ge) => {
      o.value?.setPointerCapture?.(ge);
    }, We = (ge) => {
      o.value?.hasPointerCapture?.(ge) && o.value.releasePointerCapture(ge);
    }, Fe = () => {
      C !== null && (clearTimeout(C), C = null);
    }, de = () => {
      Fe(), g.value === null && (a.value = null);
    }, Ne = () => {
      Fe(), C = setTimeout(de, uo);
    }, qe = (ge) => {
      if (g.value === null) return;
      We(g.value), g.value = null, fe();
      const Be = f.value;
      we(), m.value = !1;
      const ze = !e.disabled && (ge === "left" || ge === "right") && _(ge) && o.value !== null && ie(o.value.clientWidth, R(ge));
      (!ze || !Be) && (s.value = 0), (!ze || !Be) && Ne(), ze && r("trigger", ge);
    }, je = () => {
      u.value = !1, g.value === null && s.value === 0 && de();
    }, Xe = () => {
      A !== null && (clearTimeout(A), A = null);
    }, Ve = () => {
      I += 1, Xe(), c.value = !1, p.value = null;
    }, Pe = (ge) => new Promise((Be) => {
      A = setTimeout(() => {
        A = null, Be();
      }, ge);
    }), it = async (ge, Be = {}) => {
      const ze = o.value;
      if (!ze || !_(ge)) return;
      const {
        distance: Ke = ze.clientWidth * t1,
        hold: Qe = a1,
        slideBack: ht = r1,
        slideOut: vt = n1
      } = Be;
      Ve();
      const et = ++I;
      Fe(), c.value = !0, a.value = ge, p.value = `transform ${vt}ms ${i1}`, s.value = (ge === "left" ? -1 : 1) * Ke, await Pe(vt + Qe), et === I && (p.value = `transform ${ht}ms ${l1}`, s.value = 0, await Pe(ht), et === I && (c.value = !1, p.value = null, de()));
    }, ut = () => {
      Ve();
      const ge = a.value, Be = x.value;
      g.value !== null && (We(g.value), g.value = null), we(), s.value = 0, m.value = !1, x.value = !1, Be && ge && r("swipe-end", ge), Ne();
    };
    return qt(o, "pointerdown", (ge) => {
      Ae(ge) && (Fe(), Ve(), g.value = ge.pointerId);
    }), qt(window, ["pointerup", "pointercancel"], (ge) => {
      ge.pointerId === g.value && qe(L.value);
    }), qt(window, "pointermove", (ge) => {
      g.value !== null && (ge.pointerType !== "mouse" || ge.buttons !== 0 || qe(L.value));
    }), qt(o, "pointercancel", ut), He(
      () => e.disabled,
      (ge) => {
        ge && ut();
      }
    ), si(() => {
      Fe(), Ve();
    }), t({ close: ut, preview: it }), (ge, Be) => ($(), j("div", {
      ref_key: "lcSwipeableRef",
      ref: o,
      class: ye([
        "lc-swipeable",
        {
          "lc-swipeable--disabled": e.disabled,
          "lc-swipeable--dragging": U.value
        }
      ])
    }, [
      ($(!0), j(rt, null, yt(F.value, ({ side: ze, action: Ke }) => ($(), j(rt, { key: ze }, [
        Ke || ge.$slots[`${ze}-action`] ? ($(), j("div", {
          key: 0,
          class: ye([
            "lc-swipeable__action",
            `lc-swipeable__action--${ze}`,
            {
              "lc-swipeable__action--hidden": a.value !== ze,
              "lc-swipeable__action--dragging": U.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === ze
            }
          ])
        }, [
          ve(ge.$slots, `${ze}-action`, {}, () => [
            Ke ? ($(), j("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Et(a.value === ze ? { transform: `scale(${V.value})` } : void 0)
            }, [
              Re(Z(Je), {
                name: Ke.icon
              }, null, 8, ["name"])
            ], 4)) : se("", !0),
            Ke?.label ? ($(), j("span", o1, Ie(Ke.label), 1)) : se("", !0)
          ])
        ], 2)) : se("", !0)
      ], 64))), 128)),
      ne("div", {
        class: ye(K.value),
        style: Et(O.value),
        onTransitionend: ca(je, ["self"])
      }, [
        ve(ge.$slots, "default")
      ], 38)
    ], 2));
  }
}), s1 = { class: "lc-lottery-remaining-picks__headline" }, c1 = { class: "lc-lottery-remaining-picks__done" }, u1 = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, d1 = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, f1 = /* @__PURE__ */ Se({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => Ze.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = pe(!1);
    He(
      () => e.complete,
      (r, o) => {
        r && !o ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const o = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === o && (t.value = !1);
    };
    return (r, o) => ($(), j("div", {
      class: ye([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      ne("div", s1, [
        ve(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ne("div", c1, [
        ne("span", u1, [
          Re(Z(Je), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? ($(), j("span", d1, Ie(e.doneLabel), 1)) : se("", !0)
      ])
    ], 34));
  }
}), Ls = /* @__PURE__ */ Symbol(), h1 = ({ available: e }) => e.value > 0, $s = () => {
  const e = rc(/* @__PURE__ */ new Set());
  return { isInline: W(() => {
    const r = [...e].filter(h1);
    if (r.length)
      return r.every(({ available: o, required: i }) => i.value <= o.value);
  }), join: (r) => (e.add(r), () => {
    e.delete(r);
  }) };
}, vb = () => Ja(Ls, $s()), v1 = () => $n(Ls, null), m1 = ["aria-hidden"], g1 = {
  key: 0,
  class: "lc-lottery-editor-card__warning lc-lottery-editor-card__warning--headline"
}, b1 = ["aria-hidden"], p1 = {
  key: 0,
  ref: "warning",
  class: "lc-lottery-editor-card__warning"
}, y1 = {
  key: 1,
  ref: "labels",
  class: "lc-lottery-editor-card__labels"
}, w1 = { class: "lc-lottery-editor-card__footer" }, x1 = "medium", mb = /* @__PURE__ */ Se({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ Cn({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => Ze.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    numberClass: { type: Function },
    quickPickLabel: { default: () => Ze.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    removable: { type: Boolean, default: !1 },
    removeAriaLabel: { default: () => Ze.lcLotteryEditorCard.removeAriaLabel },
    toggleAriaLabel: { default: () => Ze.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    warning: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ Cn(["clear", "collapse", "collapsed", "expand", "expanded", "quick-pick", "remove", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Ya(e, "expanded"), o = pe();
    ic(() => {
      r.value && (o.value = e.warning);
    });
    const i = () => {
      e.removable && n("remove");
    }, a = nt("summary"), s = nt("numbers"), l = (K) => s.value?.$el?.querySelector(K) ?? void 0, h = W(() => l(".lc-lottery-numbers__number")), { width: v } = yn(a), { width: u } = yn(h), { width: f } = yn(
      W(() => s.value?.$el ?? a.value?.firstElementChild)
    ), m = nt("labels"), c = { box: "border-box" }, { width: p } = yn(
      nt("wagerLabel"),
      void 0,
      c
    ), { width: x } = yn(
      nt("betTypeLabel"),
      void 0,
      c
    ), { width: g } = yn(nt("warning")), b = (K) => K && parseFloat(getComputedStyle(K).columnGap) || 0, C = (K, O) => K.reduce((V, B) => V + B, 0) + O * Math.max(0, K.length - 1), A = W(
      () => C(
        [p.value, x.value].filter(Boolean),
        b(m.value)
      )
    ), I = W(
      () => C(
        [f.value, A.value, g.value].filter(Boolean),
        b(a.value)
      )
    ), L = v1() ?? $s();
    mo(L.join({ available: v, required: I }));
    const { isInline: E } = L, F = W(
      () => e.fields?.reduce((K, { numbers: O }) => K + O.length, 0) ?? 0
    ), U = W(() => {
      if (!v.value || !u.value || !F.value) return;
      const K = l(".lc-lottery-numbers__list"), O = K && parseFloat(getComputedStyle(K).columnGap) || 0, V = Math.max(
        1,
        Math.floor((v.value + O) / (u.value + O))
      ), B = Math.ceil(F.value / V);
      return B > 1 ? B : void 0;
    });
    return (K, O) => ($(), xe(Z(wa), Ce({
      modelValue: r.value,
      "onUpdate:modelValue": O[2] || (O[2] = (V) => r.value = V),
      animated: "",
      "body-class": "lc-lottery-editor-card__body",
      class: [
        "lc-lottery-editor-card",
        {
          "lc-lottery-editor-card--removable": e.removable,
          "lc-lottery-editor-card--separated": e.separated,
          "lc-lottery-editor-card--warning": e.warning && !r.value
        }
      ],
      expandable: !e.removable,
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow }, {
      "toggle-aria-label": e.warning ? `${e.toggleAriaLabel}, ${e.warning}` : e.toggleAriaLabel,
      onCollapse: O[3] || (O[3] = (V) => n("collapse")),
      onCollapsed: O[4] || (O[4] = (V) => n("collapsed")),
      onExpand: O[5] || (O[5] = (V) => n("expand")),
      onExpanded: O[6] || (O[6] = (V) => n("expanded"))
    }), {
      header: _e(() => [
        ($(), xe(Nt(e.removable ? "button" : "div"), {
          "aria-label": e.removable ? e.removeAriaLabel : void 0,
          class: ye([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ]),
          type: e.removable ? "button" : void 0,
          onClick: i
        }, {
          default: _e(() => [
            ne("div", {
              "aria-hidden": !r.value,
              class: "lc-lottery-editor-card__expanded"
            }, [
              o.value ? ($(), j("span", g1, [
                Re(Z(Je), {
                  name: "edit",
                  size: "small"
                }),
                kt(" " + Ie(o.value), 1)
              ])) : se("", !0),
              Re(Z(f1), Ce({
                class: { "lc-lottery-editor-card__remaining--hidden": o.value }
              }, { complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining }), {
                default: _e(({ countClass: V }) => [
                  ve(K.$slots, "headline", Ot(Pt({ countClass: V })))
                ]),
                _: 3
              }, 16, ["class"])
            ], 8, m1),
            ne("div", {
              ref: "summary",
              "aria-hidden": r.value,
              class: ye([
                "lc-lottery-editor-card__summary",
                {
                  "lc-lottery-editor-card__summary--inline": Z(E) === !0,
                  "lc-lottery-editor-card__summary--stacked": Z(E) === !1
                }
              ])
            }, [
              ve(K.$slots, "summary", {}, () => [
                e.fields ? ($(), xe(Z(gv), Ce({
                  key: 0,
                  ref: "numbers"
                }, { fields: e.fields, numberClass: e.numberClass }, {
                  rows: U.value,
                  size: x1
                }), null, 16, ["rows"])) : se("", !0)
              ]),
              e.warning ? ($(), j("span", p1, [
                Re(Z(Je), {
                  name: "edit",
                  size: "small"
                }),
                kt(" " + Ie(e.warning), 1)
              ], 512)) : se("", !0),
              e.wager || e.betType ? ($(), j("div", y1, [
                e.wager ? ($(), j("span", {
                  key: 0,
                  ref: "wagerLabel",
                  class: "lc-lottery-editor-card__label"
                }, Ie(e.wager), 513)) : se("", !0),
                e.betType ? ($(), j("span", {
                  key: 1,
                  ref: "betTypeLabel",
                  class: "lc-lottery-editor-card__label"
                }, Ie(e.betType), 513)) : se("", !0)
              ], 512)) : se("", !0)
            ], 10, b1)
          ]),
          _: 3
        }, 8, ["aria-label", "class", "type"])),
        e.removable ? ($(), xe(Z(Je), {
          key: 0,
          class: "lc-lottery-editor-card__remove",
          name: "trash-full"
        })) : se("", !0)
      ]),
      footer: _e(() => [
        ne("div", w1, [
          Re(Z(Tt), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "clear",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: O[0] || (O[0] = (V) => n("clear"))
          }, {
            default: _e(() => [
              kt(Ie(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Re(Z(Tt), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: O[1] || (O[1] = (V) => n("quick-pick"))
          }, {
            default: _e(() => [
              kt(Ie(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _e(() => [
        e.separated ? ($(), xe(Z(hi), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : se("", !0),
        ve(K.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "expandable", "header-class", "toggle-aria-label"]));
  }
});
export {
  Qo as AmplitudeEvents,
  Bt as FORM_FIELD_EVENTS,
  H1 as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  Vu as LC_BUTTON_DEFAULT_ICON_POSITION,
  Hu as LC_BUTTON_DEFAULT_SIZE,
  Uu as LC_BUTTON_DEFAULT_VARIANT,
  $1 as LC_BUTTON_ICON_POSITIONS,
  I1 as LC_BUTTON_SIZES,
  O1 as LC_BUTTON_TRIGGERS,
  D1 as LC_BUTTON_TYPES,
  M1 as LC_BUTTON_VARIANTS,
  N1 as LC_CARD_RADII,
  F1 as LC_CARD_SHADOWS,
  P1 as LC_CARD_VARIANTS,
  q1 as LC_CAROUSEL_MOVE_TRIGGERS,
  U1 as LC_CAROUSEL_VARIANTS,
  Z1 as LC_COUNTDOWN_VARIANTS,
  C1 as LC_COUNT_BUBBLE_VARIANTS,
  i2 as LC_FORM_FIELD_INTERACTION_MODES,
  pc as LC_ICON_DEFAULT_SIZE,
  T1 as LC_ICON_NAMES,
  E1 as LC_ICON_SIZES,
  c2 as LC_INFO_BUTTON_VARIANTS,
  Gh as LC_INFO_TEXT_DEFAULT_ICON_SIZE,
  Kh as LC_INFO_TEXT_DEFAULT_SIZE,
  b2 as LC_INFO_TEXT_ICON_ALIGNMENTS,
  p2 as LC_INFO_TEXT_SIZES,
  G1 as LC_INPUT_MODES,
  K1 as LC_INPUT_TYPES,
  k2 as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  s2 as LC_LOTTERY_JACPOT_SIZES,
  C2 as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  S2 as LC_LOTTERY_NUMBER_SIZES,
  _2 as LC_LOTTERY_NUMBER_SPACINGS,
  A2 as LC_LOTTERY_TEASER_VARIANTS,
  $2 as LC_MENU_BUTTON_PLACEMENTS,
  wm as LC_MESSAGE_BOX_DEFAULT_SIZE,
  xm as LC_MESSAGE_BOX_DEFAULT_VARIANT,
  D2 as LC_MESSAGE_BOX_SIZES,
  O2 as LC_MESSAGE_BOX_VARIANTS,
  B1 as LC_MODAL_CLOSE_TRIGGERS,
  z1 as LC_MODAL_SPACINGS,
  F2 as LC_PASSWORD_INPUT_TYPES,
  Om as LC_PROGRESS_INDICATOR_DEFAULT_PROGRESS,
  Mm as LC_PROGRESS_INDICATOR_DEFAULT_SIZE,
  P2 as LC_PROGRESS_INDICATOR_SIZES,
  B2 as LC_PROGRESS_INDICATOR_VARIANTS,
  U2 as LC_RADIO_GROUP_LAYOUTS,
  X2 as LC_SCRATCHCARD_TEASER_VARIANTS,
  G2 as LC_SELECT_LIST_VARIANTS,
  Ku as LC_SEPARATOR_DEFAULT_VARIANT,
  R1 as LC_SEPARATOR_VARIANTS,
  j2 as LC_SKELETON_RADII,
  Ig as LC_SWITCH_DEFAULT_ICON,
  eb as LC_SWITCH_VARIANTS,
  ab as LC_TABLE_PADDINGS,
  rb as LC_TABS_FLEX_DIRECTIONS,
  ib as LC_TABS_NAVIGATION_POSITIONS,
  lb as LC_TABS_TRIGGERS,
  ob as LC_TABS_VARIANTS,
  u2 as LC_TEASER_BACKGROUND_PATTERNS,
  d2 as LC_TEASER_BADGE_VARIANTS,
  f2 as LC_TEASER_HERO_BADGE_VARIANTS,
  as as LC_TEASER_VARIANTS,
  Zg as LC_TOAST_DEFAULT_VARIANT,
  db as LC_TOAST_VARIANTS,
  A1 as LcBadge,
  V1 as LcBottomSheet,
  Tt as LcButton,
  Gr as LcButtonActiveKeys,
  wa as LcCard,
  pf as LcCarousel,
  Ra as LcCarouselActiveKeys,
  j1 as LcCheckbox,
  Wr as LcCountBubble,
  Cf as LcCountdown,
  W1 as LcDataList,
  X1 as LcDataListItem,
  J1 as LcDateInput,
  Q1 as LcDescriptionList,
  e2 as LcDigitInput,
  ln as LcDigitInputActiveKeys,
  t2 as LcDigitInputGroup,
  t0 as LcExpandable,
  n2 as LcExpandableList,
  a2 as LcFlyOut,
  r2 as LcForm,
  l2 as LcFormField,
  o2 as LcHeader,
  x0 as LcHighFrequencyBall,
  es as LcHighFrequencyBallBackground,
  h2 as LcHighFrequencyTeaser,
  v2 as LcHighFrequencyTeaserWatch,
  Je as LcIcon,
  g2 as LcImage,
  ns as LcInfoButton,
  y2 as LcInfoText,
  ir as LcInput,
  w2 as LcLinkList,
  x2 as LcLinkListItem,
  jl as LcLotteryCutoffTime,
  mb as LcLotteryEditorCard,
  ts as LcLotteryJackpot,
  E2 as LcLotteryNumberSelector,
  Zt as LcLotteryNumberSelectorActiveKeys,
  gv as LcLotteryNumbers,
  f1 as LcLotteryRemainingPicks,
  T2 as LcLotteryTeaser,
  L2 as LcMaskedValueDisplay,
  I2 as LcMenuButton,
  Ut as LcMenuButtonActiveKeys,
  M2 as LcMessageBox,
  Bo as LcModal,
  R2 as LcMoneyInput,
  N2 as LcPasswordInput,
  z2 as LcProgressIndicator,
  zm as LcRadio,
  V2 as LcRadioCard,
  H2 as LcRadioGroup,
  q2 as LcRating,
  Z2 as LcRemoteList,
  W2 as LcScratchcardTeaser,
  Y2 as LcSelect,
  Gt as LcSelectActiveKeys,
  K2 as LcSelectList,
  Wt as LcSelectListActiveKeys,
  hi as LcSeparator,
  jm as LcSkeleton,
  J2 as LcSlider,
  Q2 as LcSlotWheel,
  hb as LcSwipeable,
  tb as LcSwitch,
  nb as LcTable,
  cb as LcTabs,
  Bn as LcTabsActiveKeys,
  lr as LcTeaser,
  U0 as LcTeaserBadge,
  j0 as LcTeaserHeroBadge,
  rs as LcTeaserHeroBadgeColor,
  ub as LcTextarea,
  fb as LcToast,
  ei as carouselContext,
  Ze as globalConfig,
  Z0 as isHeroBadge,
  _u as nuxtAppContext,
  vb as provideLcLotteryEditorCardGroup,
  L1 as setGlobalConfig,
  sb as tabContext
};
